/**
 * @file Generated by js-routes 2.3.7. Based on Rails 8.1.3 routes of Tshmanager::Application.
 * @version f1a2d9161285131379451632257b3be7f1472a752e0a99cd2f91852a9eaa4452
 * @see https://github.com/railsware/js-routes
 */
"use strict";
const __jsr = (() => {
    const hasProp = (value, key) => Object.prototype.hasOwnProperty.call(value, key);
    let NodeTypes;
    (function (NodeTypes) {
        NodeTypes[NodeTypes["GROUP"] = 1] = "GROUP";
        NodeTypes[NodeTypes["CAT"] = 2] = "CAT";
        NodeTypes[NodeTypes["SYMBOL"] = 3] = "SYMBOL";
        NodeTypes[NodeTypes["OR"] = 4] = "OR";
        NodeTypes[NodeTypes["STAR"] = 5] = "STAR";
        NodeTypes[NodeTypes["LITERAL"] = 6] = "LITERAL";
        NodeTypes[NodeTypes["SLASH"] = 7] = "SLASH";
        NodeTypes[NodeTypes["DOT"] = 8] = "DOT";
    })(NodeTypes || (NodeTypes = {}));
    const isBrowser = typeof window !== "undefined";
    const UnescapedSpecials = "-._~!$&'()*+,;=:@"
        .split("")
        .map((s) => s.charCodeAt(0));
    const UnescapedRanges = [
        ["a", "z"],
        ["A", "Z"],
        ["0", "9"],
    ].map((range) => range.map((s) => s.charCodeAt(0)));
    const ModuleReferences = {
        CJS: {
            define(routes) {
                if (module) {
                    // Some javascript processors (like vite/rolldown)
                    // warn on using module dot exports in an ESM module.
                    // This just obfuscates that assignment a little so
                    // users don't get a warning they can't fix.
                    const _mod = module;
                    _mod.exports = routes;
                }
            },
            isSupported() {
                return typeof module === "object";
            },
        },
        AMD: {
            define(routes) {
                if (define) {
                    define([], function () {
                        return routes;
                    });
                }
            },
            isSupported() {
                return typeof define === "function" && !!define.amd;
            },
        },
        UMD: {
            define(routes) {
                if (ModuleReferences.AMD.isSupported()) {
                    ModuleReferences.AMD.define(routes);
                }
                else {
                    if (ModuleReferences.CJS.isSupported()) {
                        try {
                            ModuleReferences.CJS.define(routes);
                        }
                        catch (error) {
                            if (error.name !== "TypeError")
                                throw error;
                        }
                    }
                }
            },
            isSupported() {
                return (ModuleReferences.AMD.isSupported() ||
                    ModuleReferences.CJS.isSupported());
            },
        },
        ESM: {
            define() {
                // Module can only be defined using ruby code generation
            },
            isSupported() {
                // Its impossible to check if "export" keyword is supported
                return true;
            },
        },
        NIL: {
            define() {
                // Defined using RubyVariables . WRAPPER
            },
            isSupported() {
                return true;
            },
        },
        DTS: {
            // Acts the same as ESM
            define(routes) {
                ModuleReferences.ESM.define(routes);
            },
            isSupported() {
                return ModuleReferences.ESM.isSupported();
            },
        },
    };
    class ParametersMissing extends Error {
        constructor(...keys) {
            super(`Route missing required keys: ${keys.join(", ")}`);
            this.keys = keys;
            Object.setPrototypeOf(this, Object.getPrototypeOf(this));
            this.name = ParametersMissing.name;
        }
    }
    const ReservedOptions = [
        "anchor",
        "trailing_slash",
        "subdomain",
        "host",
        "port",
        "protocol",
        "script_name",
    ];
    class UtilsClass {
        constructor() {
            this.configuration = {
                prefix: "",
                default_url_options: {},
                special_options_key: "_options",
                serializer: null || this.default_serializer.bind(this),
            };
        }
        default_serializer(value, prefix) {
            if (!prefix && !this.is_object(value)) {
                throw new Error("Url parameters should be a javascript hash");
            }
            prefix = prefix || "";
            const result = [];
            if (this.is_array(value)) {
                for (const element of value) {
                    result.push(this.default_serializer(element, prefix + "[]"));
                }
            }
            else if (this.is_object(value)) {
                for (let key in value) {
                    if (!hasProp(value, key))
                        continue;
                    let prop = value[key];
                    if (prefix) {
                        key = prefix + "[" + key + "]";
                    }
                    const subvalue = this.default_serializer(prop, key);
                    if (subvalue.length) {
                        result.push(subvalue);
                    }
                }
            }
            else {
                const key = encodeURIComponent(prefix);
                result.push(this.is_not_nullable(value) ||
                    false
                    ? key + "=" + encodeURIComponent("" + (value !== null && value !== void 0 ? value : ""))
                    : key);
            }
            return result.join("&");
        }
        serialize(object) {
            return this.configuration.serializer(object);
        }
        extract_options(number_of_params, args) {
            const last_el = args[args.length - 1];
            if ((args.length > number_of_params && last_el === 0) ||
                (this.is_object(last_el) && !this.looks_like_serialized_model(last_el))) {
                if (this.is_object(last_el)) {
                    delete last_el[this.configuration.special_options_key];
                }
                return {
                    args: args.slice(0, args.length - 1),
                    options: last_el,
                };
            }
            else {
                return { args, options: {} };
            }
        }
        looks_like_serialized_model(object) {
            return (this.is_object(object) &&
                !(this.configuration.special_options_key in object) &&
                ("id" in object || "to_param" in object || "toParam" in object));
        }
        path_identifier(object) {
            const result = this.unwrap_path_identifier(object);
            return this.is_nullable(result) ||
                (false && result === false)
                ? ""
                : "" + result;
        }
        unwrap_path_identifier(object) {
            let result = object;
            if (!this.is_object(object)) {
                return object;
            }
            if ("to_param" in object) {
                result = object.to_param;
            }
            else if ("toParam" in object) {
                result = object.toParam;
            }
            else if ("id" in object) {
                result = object.id;
            }
            else {
                result = object;
            }
            return this.is_callable(result) ? result.call(object) : result;
        }
        partition_parameters(parts, required_params, default_options, call_arguments) {
            let { args, options } = this.extract_options(parts.length, call_arguments);
            if (args.length > parts.length) {
                throw new Error("Too many parameters provided for path");
            }
            let use_all_parts = args.length > required_params.length;
            const parts_options = {
                ...this.configuration.default_url_options,
            };
            for (const key in options) {
                const value = options[key];
                if (!hasProp(options, key))
                    continue;
                use_all_parts = true;
                if (parts.includes(key)) {
                    parts_options[key] = value;
                }
            }
            options = {
                ...this.configuration.default_url_options,
                ...default_options,
                ...options,
            };
            const keyword_parameters = {};
            let query_parameters = {};
            for (const key in options) {
                if (!hasProp(options, key))
                    continue;
                const value = options[key];
                if (key === "params") {
                    if (this.is_object(value)) {
                        query_parameters = {
                            ...query_parameters,
                            ...value,
                        };
                    }
                    else {
                        throw new Error("params value should always be an object");
                    }
                }
                else if (this.is_reserved_option(key)) {
                    keyword_parameters[key] = value;
                }
                else {
                    if (!this.is_nullable(value) &&
                        (value !== default_options[key] || required_params.includes(key))) {
                        query_parameters[key] = value;
                    }
                }
            }
            const route_parts = use_all_parts ? parts : required_params;
            let i = 0;
            for (const part of route_parts) {
                if (i < args.length) {
                    const value = args[i];
                    if (!hasProp(parts_options, part)) {
                        query_parameters[part] = value;
                        ++i;
                    }
                }
            }
            return { keyword_parameters, query_parameters };
        }
        build_route(parts, required_params, default_options, route, absolute, args) {
            const { keyword_parameters, query_parameters } = this.partition_parameters(parts, required_params, default_options, args);
            let { trailing_slash, anchor, script_name } = keyword_parameters;
            const missing_params = required_params.filter((param) => !hasProp(query_parameters, param) ||
                this.is_nullable(query_parameters[param]));
            if (missing_params.length) {
                throw new ParametersMissing(...missing_params);
            }
            let result = this.get_prefix() + this.visit(route, query_parameters);
            if (trailing_slash) {
                result = result.replace(/(.*?)[/]?$/, "$1/");
            }
            const url_params = this.serialize(query_parameters);
            if (url_params.length) {
                result += "?" + url_params;
            }
            if (anchor) {
                result += "#" + anchor;
            }
            if (script_name) {
                const last_index = script_name.length - 1;
                if (script_name[last_index] == "/" && result[0] == "/") {
                    script_name = script_name.slice(0, last_index);
                }
                result = script_name + result;
            }
            if (absolute) {
                result = this.route_url(keyword_parameters) + result;
            }
            return result;
        }
        visit(route, parameters, optional = false) {
            switch (route[0]) {
                case NodeTypes.GROUP:
                    return this.visit(route[1], parameters, true);
                case NodeTypes.CAT:
                    return this.visit_cat(route, parameters, optional);
                case NodeTypes.SYMBOL:
                    return this.visit_symbol(route, parameters, optional);
                case NodeTypes.STAR:
                    return this.visit_globbing(route[1], parameters, true);
                case NodeTypes.LITERAL:
                case NodeTypes.SLASH:
                case NodeTypes.DOT:
                    return route[1];
                default:
                    throw new Error("Unknown Rails node type");
            }
        }
        is_not_nullable(object) {
            return !this.is_nullable(object);
        }
        is_nullable(object) {
            return object === undefined || object === null;
        }
        visit_cat(
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        [_type, left, right], parameters, optional) {
            const left_part = this.visit(left, parameters, optional);
            let right_part = this.visit(right, parameters, optional);
            if (optional &&
                ((this.is_optional_node(left[0]) && !left_part) ||
                    (this.is_optional_node(right[0]) && !right_part))) {
                return "";
            }
            // if left_part ends on '/' and right_part starts on '/'
            if (left_part[left_part.length - 1] === "/" && right_part[0] === "/") {
                // strip slash from right_part
                // to prevent double slash
                right_part = right_part.substring(1);
            }
            return left_part + right_part;
        }
        visit_symbol(
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        [_type, key], parameters, optional) {
            const value = this.path_identifier(parameters[key]);
            delete parameters[key];
            if (value.length) {
                return this.encode_segment(value);
            }
            if (optional) {
                return "";
            }
            else {
                throw new ParametersMissing(key);
            }
        }
        encode_segment(segment) {
            if (segment.match(/^[a-zA-Z0-9-]$/)) {
                // Performance optimization for 99% of cases
                return segment;
            }
            return (segment.match(/./gu) || [])
                .map((ch) => {
                const code = ch.charCodeAt(0);
                if (UnescapedRanges.find((range) => code >= range[0] && code <= range[1]) ||
                    UnescapedSpecials.includes(code)) {
                    return ch;
                }
                else {
                    return encodeURIComponent(ch);
                }
            })
                .join("");
        }
        is_optional_node(node) {
            return [NodeTypes.STAR, NodeTypes.SYMBOL, NodeTypes.CAT].includes(node);
        }
        build_path_spec(route, wildcard = false) {
            let key;
            switch (route[0]) {
                case NodeTypes.GROUP:
                    return `(${this.build_path_spec(route[1])})`;
                case NodeTypes.CAT:
                    return (this.build_path_spec(route[1]) + this.build_path_spec(route[2]));
                case NodeTypes.STAR:
                    return this.build_path_spec(route[1], true);
                case NodeTypes.SYMBOL:
                    key = route[1];
                    if (wildcard) {
                        return (key.startsWith("*") ? "" : "*") + key;
                    }
                    else {
                        return ":" + key;
                    }
                    break;
                case NodeTypes.SLASH:
                case NodeTypes.DOT:
                case NodeTypes.LITERAL:
                    return route[1];
                default:
                    throw new Error("Unknown Rails node type");
            }
        }
        visit_globbing(route, parameters, optional) {
            const key = route[1];
            let value = parameters[key];
            delete parameters[key];
            if (this.is_nullable(value)) {
                return this.visit(route, parameters, optional);
            }
            if (this.is_array(value)) {
                value = value.join("/");
            }
            const result = this.path_identifier(value);
            return encodeURI(result);
        }
        get_prefix() {
            const prefix = this.configuration.prefix;
            return prefix.match("/$")
                ? prefix.substring(0, prefix.length - 1)
                : prefix;
        }
        route(parts_table, route_spec, absolute = false) {
            const required_params = [];
            const parts = [];
            const default_options = {};
            for (const [part, { r: required, d: value }] of Object.entries(parts_table)) {
                parts.push(part);
                if (required) {
                    required_params.push(part);
                }
                if (this.is_not_nullable(value)) {
                    default_options[part] = value;
                }
            }
            const result = (...args) => {
                return this.build_route(parts, required_params, default_options, route_spec, absolute, args);
            };
            result.requiredParams = () => required_params;
            result.toString = () => {
                return this.build_path_spec(route_spec);
            };
            return result;
        }
        route_url(route_defaults) {
            const hostname = route_defaults.host || this.current_host();
            if (!hostname) {
                return "";
            }
            const subdomain = route_defaults.subdomain
                ? route_defaults.subdomain + "."
                : "";
            const protocol = route_defaults.protocol || this.current_protocol();
            let port = route_defaults.port ||
                (!route_defaults.host ? this.current_port() : undefined);
            port = port ? ":" + port : "";
            return protocol + "://" + subdomain + hostname + port;
        }
        current_host() {
            var _a;
            return (isBrowser && ((_a = window === null || window === void 0 ? void 0 : window.location) === null || _a === void 0 ? void 0 : _a.hostname)) || "";
        }
        current_protocol() {
            var _a, _b;
            return ((isBrowser && ((_b = (_a = window === null || window === void 0 ? void 0 : window.location) === null || _a === void 0 ? void 0 : _a.protocol) === null || _b === void 0 ? void 0 : _b.replace(/:$/, ""))) || "http");
        }
        current_port() {
            var _a;
            return (isBrowser && ((_a = window === null || window === void 0 ? void 0 : window.location) === null || _a === void 0 ? void 0 : _a.port)) || "";
        }
        is_object(value) {
            return (typeof value === "object" &&
                Object.prototype.toString.call(value) === "[object Object]");
        }
        is_array(object) {
            return object instanceof Array;
        }
        is_callable(object) {
            return typeof object === "function" && !!object.call;
        }
        is_reserved_option(key) {
            return ReservedOptions.includes(key);
        }
        configure(new_config) {
            if (new_config.prefix) {
                console.warn("JsRoutes configuration prefix option is deprecated in favor of default_url_options.script_name.");
            }
            this.configuration = { ...this.configuration, ...new_config };
            return this.configuration;
        }
        config() {
            return { ...this.configuration };
        }
        is_module_supported(name) {
            return ModuleReferences[name].isSupported();
        }
        ensure_module_supported(name) {
            if (!this.is_module_supported(name)) {
                throw new Error(`${name} is not supported by runtime`);
            }
        }
        define_module(name, module) {
            this.ensure_module_supported(name);
            ModuleReferences[name].define(module);
            return module;
        }
    }
    const utils = new UtilsClass();
    // We want this helper name to be short
    const __jsr = {
        r: utils.route.bind(utils),
    };
    return utils.define_module("ESM", {
        ...__jsr,
        configure: utils.configure.bind(utils),
        config: utils.config.bind(utils),
        serialize: utils.serialize.bind(utils),
        ...{},
    });
})();
export const configure = __jsr.configure;

export const config = __jsr.config;

export const serialize = __jsr.serialize;

/**
 * Generates rails route to
 * /call_center/call_sessions/:id/accept(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const accept_api_call_center_call_session_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{},"subdomain":{"d":"api"}}, [2,[7,"/"],[2,[6,"call_center"],[2,[7,"/"],[2,[6,"call_sessions"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"accept"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const account_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /account/avatar(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const account_avatar_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"avatar"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /account/avatar/status(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const account_avatar_status_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"avatar"],[2,[7,"/"],[2,[6,"status"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /account/avatar/upload(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const account_avatar_upload_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"avatar"],[2,[7,"/"],[2,[6,"upload"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/ai/system_prompts/:id/activate(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const activate_admin_ai_system_prompt_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"ai"],[2,[7,"/"],[2,[6,"system_prompts"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"activate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/support/mailboxes/:id/activate(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const activate_admin_support_mailbox_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"support"],[2,[7,"/"],[2,[6,"mailboxes"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"activate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /mail_domains/:id/activate(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const activate_mail_domain_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"mail_domains"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"activate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /mailboxes/:id/activate(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const activate_mailbox_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"mailboxes"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"activate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /personal_mailboxes/:id/activate(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const activate_personal_mailbox_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"personal_mailboxes"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"activate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /call_center/call_sessions/active_count(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const active_count_api_call_center_call_sessions_path = /*#__PURE__*/ __jsr.r({"format":{},"subdomain":{"d":"api"}}, [2,[7,"/"],[2,[6,"call_center"],[2,[7,"/"],[2,[6,"call_sessions"],[2,[7,"/"],[2,[6,"active_count"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /active_sessions/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const active_session_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"active_sessions"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /security-services/building-complexes/:building_complex_id/patrols/roads/:road_id/patrols/:id/add_coordinates(.:format)
 * @param {any} building_complex_id
 * @param {any} road_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const add_coordinates_security_services_building_complex_patrols_road_patrol_path = /*#__PURE__*/ __jsr.r({"building_complex_id":{"r":true},"road_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"security-services"],[2,[7,"/"],[2,[6,"building-complexes"],[2,[7,"/"],[2,[3,"building_complex_id"],[2,[7,"/"],[2,[6,"patrols"],[2,[7,"/"],[2,[6,"roads"],[2,[7,"/"],[2,[3,"road_id"],[2,[7,"/"],[2,[6,"patrols"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"add_coordinates"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/ai/activity/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_ai_activity_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"ai"],[2,[7,"/"],[2,[6,"activity"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/ai/activity(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_ai_activity_index_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"ai"],[2,[7,"/"],[2,[6,"activity"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/ai/system_prompts/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_ai_system_prompt_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"ai"],[2,[7,"/"],[2,[6,"system_prompts"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/ai/system_prompts(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_ai_system_prompts_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"ai"],[2,[7,"/"],[2,[6,"system_prompts"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/ai/workflows/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_ai_workflow_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"ai"],[2,[7,"/"],[2,[6,"workflows"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/ai/workflows/:workflow_id/runs/:id(.:format)
 * @param {any} workflow_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_ai_workflow_run_path = /*#__PURE__*/ __jsr.r({"workflow_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"ai"],[2,[7,"/"],[2,[6,"workflows"],[2,[7,"/"],[2,[3,"workflow_id"],[2,[7,"/"],[2,[6,"runs"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/ai/workflows/:workflow_id/runs(.:format)
 * @param {any} workflow_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_ai_workflow_runs_path = /*#__PURE__*/ __jsr.r({"workflow_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"ai"],[2,[7,"/"],[2,[6,"workflows"],[2,[7,"/"],[2,[3,"workflow_id"],[2,[7,"/"],[2,[6,"runs"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/ai/workflows(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_ai_workflows_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"ai"],[2,[7,"/"],[2,[6,"workflows"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/audit_events(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_audit_events_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"audit_events"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/building_complexes/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_building_complex_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"building_complexes"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/building_complexes(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_building_complexes_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"building_complexes"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/call_center/call_sessions/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_call_center_call_session_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"call_center"],[2,[7,"/"],[2,[6,"call_sessions"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/call_center/call_sessions(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_call_center_call_sessions_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"call_center"],[2,[7,"/"],[2,[6,"call_sessions"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/call_center/ivr_flows/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_call_center_ivr_flow_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"call_center"],[2,[7,"/"],[2,[6,"ivr_flows"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/call_center/ivr_flows(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_call_center_ivr_flows_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"call_center"],[2,[7,"/"],[2,[6,"ivr_flows"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/call_center(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_call_center_root_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"call_center"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/call_center/voicemails/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_call_center_voicemail_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"call_center"],[2,[7,"/"],[2,[6,"voicemails"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/call_center/voicemails(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_call_center_voicemails_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"call_center"],[2,[7,"/"],[2,[6,"voicemails"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/client-creation(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_client_creation_index_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"client-creation"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/company_activities(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_company_activities_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"company_activities"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/company_activities/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_company_activity_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"company_activities"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/company_activity_categories(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_company_activity_categories_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"company_activity_categories"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/company_activity_categories/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_company_activity_category_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"company_activity_categories"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/dashboard(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_dashboard_index_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"dashboard"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/drive/statistics(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_drive_statistics_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"drive"],[2,[7,"/"],[2,[6,"statistics"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/equipment_categories(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_equipment_categories_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"equipment_categories"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/equipment_categories/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_equipment_category_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"equipment_categories"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/equipment_subcategories(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_equipment_subcategories_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"equipment_subcategories"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/equipment_subcategories/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_equipment_subcategory_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"equipment_subcategories"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/equipment_trades/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_equipment_trade_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"equipment_trades"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/equipment_trades(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_equipment_trades_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"equipment_trades"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/guide/articles/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_guide_article_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"guide"],[2,[7,"/"],[2,[6,"articles"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/guide/articles/:article_id/versions/:id(.:format)
 * @param {any} article_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_guide_article_version_path = /*#__PURE__*/ __jsr.r({"article_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"guide"],[2,[7,"/"],[2,[6,"articles"],[2,[7,"/"],[2,[3,"article_id"],[2,[7,"/"],[2,[6,"versions"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/guide/articles/:article_id/versions(.:format)
 * @param {any} article_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_guide_article_versions_path = /*#__PURE__*/ __jsr.r({"article_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"guide"],[2,[7,"/"],[2,[6,"articles"],[2,[7,"/"],[2,[3,"article_id"],[2,[7,"/"],[2,[6,"versions"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/guide/articles(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_guide_articles_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"guide"],[2,[7,"/"],[2,[6,"articles"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/impersonation(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_impersonation_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"impersonation"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/invoices/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_invoice_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"invoices"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/invoices(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_invoices_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"invoices"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/messenger/activity/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_messenger_activity_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"messenger"],[2,[7,"/"],[2,[6,"activity"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/messenger/activity(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_messenger_activity_index_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"messenger"],[2,[7,"/"],[2,[6,"activity"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_root_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /admin/subscribers/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_subscriber_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"subscribers"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/subscribers(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_subscribers_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"subscribers"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/support/conversations/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_support_conversation_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"support"],[2,[7,"/"],[2,[6,"conversations"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/support/image_upload(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_support_image_upload_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"support"],[2,[7,"/"],[2,[6,"image_upload"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/support/mailboxes/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_support_mailbox_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"support"],[2,[7,"/"],[2,[6,"mailboxes"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/support/mailboxes(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_support_mailboxes_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"support"],[2,[7,"/"],[2,[6,"mailboxes"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/support(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_support_root_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"support"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/support/saved_replies(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_support_saved_replies_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"support"],[2,[7,"/"],[2,[6,"saved_replies"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/support/saved_replies/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_support_saved_reply_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"support"],[2,[7,"/"],[2,[6,"saved_replies"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/support/conversations/:id/sender_context(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_support_sender_context_admin_support_conversation_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"support"],[2,[7,"/"],[2,[6,"conversations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"sender_context"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/support/signatures/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_support_signature_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"support"],[2,[7,"/"],[2,[6,"signatures"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/tenants/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_tenant_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"tenants"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/tenants/:tenant_id/webdav_credentials/:id(.:format)
 * @param {any} tenant_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_tenant_webdav_credential_path = /*#__PURE__*/ __jsr.r({"tenant_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"tenants"],[2,[7,"/"],[2,[3,"tenant_id"],[2,[7,"/"],[2,[6,"webdav_credentials"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/tenants/:tenant_id/webdav_credentials(.:format)
 * @param {any} tenant_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_tenant_webdav_credentials_path = /*#__PURE__*/ __jsr.r({"tenant_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"tenants"],[2,[7,"/"],[2,[3,"tenant_id"],[2,[7,"/"],[2,[6,"webdav_credentials"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/tenants(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_tenants_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"tenants"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/voice/activity/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_voice_activity_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"voice"],[2,[7,"/"],[2,[6,"activity"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/voice/activity(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_voice_activity_index_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"voice"],[2,[7,"/"],[2,[6,"activity"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/voice_assistant/activity/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_voice_assistant_activity_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"voice_assistant"],[2,[7,"/"],[2,[6,"activity"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/voice_assistant/activity(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_voice_assistant_activity_index_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"voice_assistant"],[2,[7,"/"],[2,[6,"activity"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/webdav/statistics(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_webdav_statistics_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"webdav"],[2,[7,"/"],[2,[6,"statistics"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /ai(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const ai_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"ai"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /ai/conversations/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const ai_conversation_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"ai"],[2,[7,"/"],[2,[6,"conversations"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /ai/conversations(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const ai_conversations_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"ai"],[2,[7,"/"],[2,[6,"conversations"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /ai/kb_stream(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const ai_kb_stream_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"ai"],[2,[7,"/"],[2,[6,"kb_stream"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /ai/statistics(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const ai_statistics_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"ai"],[2,[7,"/"],[2,[6,"statistics"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /ai/stream(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const ai_stream_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"ai"],[2,[7,"/"],[2,[6,"stream"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /ai/workflows/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const ai_workflow_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"ai"],[2,[7,"/"],[2,[6,"workflows"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /ai/workflows/:workflow_id/runs/:id(.:format)
 * @param {any} workflow_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const ai_workflow_run_path = /*#__PURE__*/ __jsr.r({"workflow_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"ai"],[2,[7,"/"],[2,[6,"workflows"],[2,[7,"/"],[2,[3,"workflow_id"],[2,[7,"/"],[2,[6,"runs"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /ai/workflows(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const ai_workflows_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"ai"],[2,[7,"/"],[2,[6,"workflows"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /complexes/:building_complex_id/equipments/all_equipment_tasks(.:format)
 * @param {any} building_complex_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const all_equipment_tasks_building_complex_equipments_path = /*#__PURE__*/ __jsr.r({"building_complex_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"complexes"],[2,[7,"/"],[2,[3,"building_complex_id"],[2,[7,"/"],[2,[6,"equipments"],[2,[7,"/"],[2,[6,"all_equipment_tasks"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /tasklist/all/:building_complex_id(.:format)
 * @param {any} building_complex_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const all_tasks_path = /*#__PURE__*/ __jsr.r({"building_complex_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"tasklist"],[2,[7,"/"],[2,[6,"all"],[2,[7,"/"],[2,[3,"building_complex_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /ai/conversations/:agent_id(.:format)
 * @param {any} agent_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_ai_conversations_path = /*#__PURE__*/ __jsr.r({"agent_id":{"r":true},"format":{},"subdomain":{"d":"api"}}, [2,[7,"/"],[2,[6,"ai"],[2,[7,"/"],[2,[6,"conversations"],[2,[7,"/"],[2,[3,"agent_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /ai/conversations/attachments/resolve(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_ai_conversations_attachments_resolve_path = /*#__PURE__*/ __jsr.r({"format":{},"subdomain":{"d":"api"}}, [2,[7,"/"],[2,[6,"ai"],[2,[7,"/"],[2,[6,"conversations"],[2,[7,"/"],[2,[6,"attachments"],[2,[7,"/"],[2,[6,"resolve"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /ai/conversations/messages(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_ai_conversations_messages_path = /*#__PURE__*/ __jsr.r({"format":{},"subdomain":{"d":"api"}}, [2,[7,"/"],[2,[6,"ai"],[2,[7,"/"],[2,[6,"conversations"],[2,[7,"/"],[2,[6,"messages"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /ai/conversations/update_title(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_ai_conversations_update_title_path = /*#__PURE__*/ __jsr.r({"format":{},"subdomain":{"d":"api"}}, [2,[7,"/"],[2,[6,"ai"],[2,[7,"/"],[2,[6,"conversations"],[2,[7,"/"],[2,[6,"update_title"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /ai/v1/people(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_ai_v1_people_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"},"subdomain":{"d":"api"}}, [2,[7,"/"],[2,[6,"ai"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"people"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /ai/v1/people/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_ai_v1_person_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"},"subdomain":{"d":"api"}}, [2,[7,"/"],[2,[6,"ai"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"people"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /ai/voice_conversations/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_ai_voice_conversation_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{},"subdomain":{"d":"api"}}, [2,[7,"/"],[2,[6,"ai"],[2,[7,"/"],[2,[6,"voice_conversations"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /ai/voice_conversations(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_ai_voice_conversations_path = /*#__PURE__*/ __jsr.r({"format":{},"subdomain":{"d":"api"}}, [2,[7,"/"],[2,[6,"ai"],[2,[7,"/"],[2,[6,"voice_conversations"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /call_center/call_sessions/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_call_center_call_session_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{},"subdomain":{"d":"api"}}, [2,[7,"/"],[2,[6,"call_center"],[2,[7,"/"],[2,[6,"call_sessions"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /call_center/call_sessions(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_call_center_call_sessions_path = /*#__PURE__*/ __jsr.r({"format":{},"subdomain":{"d":"api"}}, [2,[7,"/"],[2,[6,"call_center"],[2,[7,"/"],[2,[6,"call_sessions"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /call_center/ivr_flows/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_call_center_ivr_flow_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{},"subdomain":{"d":"api"}}, [2,[7,"/"],[2,[6,"call_center"],[2,[7,"/"],[2,[6,"ivr_flows"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /call_center/ivr_flows(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_call_center_ivr_flows_path = /*#__PURE__*/ __jsr.r({"format":{},"subdomain":{"d":"api"}}, [2,[7,"/"],[2,[6,"call_center"],[2,[7,"/"],[2,[6,"ivr_flows"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /call_center/people(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_call_center_people_path = /*#__PURE__*/ __jsr.r({"format":{},"subdomain":{"d":"api"}}, [2,[7,"/"],[2,[6,"call_center"],[2,[7,"/"],[2,[6,"people"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /call_center/person_groups(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_call_center_person_groups_path = /*#__PURE__*/ __jsr.r({"format":{},"subdomain":{"d":"api"}}, [2,[7,"/"],[2,[6,"call_center"],[2,[7,"/"],[2,[6,"person_groups"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /chat/v1/attachments/:signed_id/download(.:format)
 * @param {any} signed_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_chat_v1_attachment_download_path = /*#__PURE__*/ __jsr.r({"signed_id":{"r":true},"format":{},"subdomain":{"d":"api"}}, [2,[7,"/"],[2,[6,"chat"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"attachments"],[2,[7,"/"],[2,[3,"signed_id"],[2,[7,"/"],[2,[6,"download"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /chat/v1/attachments/:signed_id/preview(.:format)
 * @param {any} signed_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_chat_v1_attachment_preview_path = /*#__PURE__*/ __jsr.r({"signed_id":{"r":true},"format":{},"subdomain":{"d":"api"}}, [2,[7,"/"],[2,[6,"chat"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"attachments"],[2,[7,"/"],[2,[3,"signed_id"],[2,[7,"/"],[2,[6,"preview"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /chat/v1/me(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_chat_v1_me_path = /*#__PURE__*/ __jsr.r({"format":{},"subdomain":{"d":"api"}}, [2,[7,"/"],[2,[6,"chat"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"me"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /chat/v1/mentions(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_chat_v1_mentions_path = /*#__PURE__*/ __jsr.r({"format":{},"subdomain":{"d":"api"}}, [2,[7,"/"],[2,[6,"chat"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"mentions"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /chat/v1/persons/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_chat_v1_person_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{},"subdomain":{"d":"api"}}, [2,[7,"/"],[2,[6,"chat"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"persons"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /chat/v1/persons(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_chat_v1_persons_path = /*#__PURE__*/ __jsr.r({"format":{},"subdomain":{"d":"api"}}, [2,[7,"/"],[2,[6,"chat"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"persons"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /chat/v1/push_tokens/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_chat_v1_push_token_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{},"subdomain":{"d":"api"}}, [2,[7,"/"],[2,[6,"chat"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"push_tokens"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /chat/v1/push_tokens(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_chat_v1_push_tokens_path = /*#__PURE__*/ __jsr.r({"format":{},"subdomain":{"d":"api"}}, [2,[7,"/"],[2,[6,"chat"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"push_tokens"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /chat/v1/rooms/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_chat_v1_room_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{},"subdomain":{"d":"api"}}, [2,[7,"/"],[2,[6,"chat"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"rooms"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /chat/v1/rooms/:room_id/messages/:id(.:format)
 * @param {any} room_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_chat_v1_room_message_path = /*#__PURE__*/ __jsr.r({"room_id":{"r":true},"id":{"r":true},"format":{},"subdomain":{"d":"api"}}, [2,[7,"/"],[2,[6,"chat"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"rooms"],[2,[7,"/"],[2,[3,"room_id"],[2,[7,"/"],[2,[6,"messages"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /chat/v1/rooms/:room_id/messages/:message_id/reactions(.:format)
 * @param {any} room_id
 * @param {any} message_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_chat_v1_room_message_reactions_path = /*#__PURE__*/ __jsr.r({"room_id":{"r":true},"message_id":{"r":true},"format":{},"subdomain":{"d":"api"}}, [2,[7,"/"],[2,[6,"chat"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"rooms"],[2,[7,"/"],[2,[3,"room_id"],[2,[7,"/"],[2,[6,"messages"],[2,[7,"/"],[2,[3,"message_id"],[2,[7,"/"],[2,[6,"reactions"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /chat/v1/rooms/:room_id/messages/:id(.:format)
 * @param {any} room_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_chat_v1_room_message_show_path = /*#__PURE__*/ __jsr.r({"room_id":{"r":true},"id":{"r":true},"format":{},"subdomain":{"d":"api"}}, [2,[7,"/"],[2,[6,"chat"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"rooms"],[2,[7,"/"],[2,[3,"room_id"],[2,[7,"/"],[2,[6,"messages"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /chat/v1/rooms/:room_id/messages(.:format)
 * @param {any} room_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_chat_v1_room_messages_path = /*#__PURE__*/ __jsr.r({"room_id":{"r":true},"format":{},"subdomain":{"d":"api"}}, [2,[7,"/"],[2,[6,"chat"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"rooms"],[2,[7,"/"],[2,[3,"room_id"],[2,[7,"/"],[2,[6,"messages"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /chat/v1/rooms/:room_id/typing(.:format)
 * @param {any} room_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_chat_v1_room_typing_index_path = /*#__PURE__*/ __jsr.r({"room_id":{"r":true},"format":{},"subdomain":{"d":"api"}}, [2,[7,"/"],[2,[6,"chat"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"rooms"],[2,[7,"/"],[2,[3,"room_id"],[2,[7,"/"],[2,[6,"typing"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /chat/v1/rooms(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_chat_v1_rooms_path = /*#__PURE__*/ __jsr.r({"format":{},"subdomain":{"d":"api"}}, [2,[7,"/"],[2,[6,"chat"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"rooms"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /chat/v1/search(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_chat_v1_search_path = /*#__PURE__*/ __jsr.r({"format":{},"subdomain":{"d":"api"}}, [2,[7,"/"],[2,[6,"chat"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"search"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /chat/v1/tasks/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_chat_v1_task_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{},"subdomain":{"d":"api"}}, [2,[7,"/"],[2,[6,"chat"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"tasks"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /chat/v1/tenants(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_chat_v1_tenants_path = /*#__PURE__*/ __jsr.r({"format":{},"subdomain":{"d":"api"}}, [2,[7,"/"],[2,[6,"chat"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"tenants"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /chat/v1/unfurl_link(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_chat_v1_unfurl_link_path = /*#__PURE__*/ __jsr.r({"format":{},"subdomain":{"d":"api"}}, [2,[7,"/"],[2,[6,"chat"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"unfurl_link"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /ehaz/v1/tasks/:ehaz_house_id(.:format)
 * @param {any} ehaz_house_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_ehaz_v1_path = /*#__PURE__*/ __jsr.r({"ehaz_house_id":{"r":true},"format":{"d":"json"},"subdomain":{"d":"api"}}, [2,[7,"/"],[2,[6,"ehaz"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"tasks"],[2,[7,"/"],[2,[3,"ehaz_house_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /ehaz/v1/resident_reports(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_ehaz_v1_resident_reports_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"},"subdomain":{"d":"api"}}, [2,[7,"/"],[2,[6,"ehaz"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"resident_reports"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /ehaz/v1/webhook(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_ehaz_v1_webhook_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"},"subdomain":{"d":"api"}}, [2,[7,"/"],[2,[6,"ehaz"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"webhook"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /eingatlan/v1/subscriber/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_eingatlan_v1_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"},"subdomain":{"d":"api"}}, [2,[7,"/"],[2,[6,"eingatlan"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"subscriber"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /eingatlan/v1/property(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_eingatlan_v1_property_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"},"subdomain":{"d":"api"}}, [2,[7,"/"],[2,[6,"eingatlan"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"property"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /eingatlan/v1/property/destroy(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_eingatlan_v1_property_destroy_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"},"subdomain":{"d":"api"}}, [2,[7,"/"],[2,[6,"eingatlan"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"property"],[2,[7,"/"],[2,[6,"destroy"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /eingatlan/v1/property/list(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_eingatlan_v1_property_list_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"},"subdomain":{"d":"api"}}, [2,[7,"/"],[2,[6,"eingatlan"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"property"],[2,[7,"/"],[2,[6,"list"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /eingatlan/v1/subscriber/create(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_eingatlan_v1_subscriber_create_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"},"subdomain":{"d":"api"}}, [2,[7,"/"],[2,[6,"eingatlan"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"subscriber"],[2,[7,"/"],[2,[6,"create"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /eingatlan/v1/subscriber/destroy(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_eingatlan_v1_subscriber_destroy_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"},"subdomain":{"d":"api"}}, [2,[7,"/"],[2,[6,"eingatlan"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"subscriber"],[2,[7,"/"],[2,[6,"destroy"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /eingatlan/v1/subscriber/modify(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_eingatlan_v1_subscriber_modify_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"},"subdomain":{"d":"api"}}, [2,[7,"/"],[2,[6,"eingatlan"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"subscriber"],[2,[7,"/"],[2,[6,"modify"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /eingatlan/v1/tasks(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_eingatlan_v1_tasks_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"},"subdomain":{"d":"api"}}, [2,[7,"/"],[2,[6,"eingatlan"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"tasks"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /email/v1/compose/addresses(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_email_v1_addresses_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"},"subdomain":{"d":"api"}}, [2,[7,"/"],[2,[6,"email"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"compose"],[2,[7,"/"],[2,[6,"addresses"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /email/v1/bulk(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_email_v1_bulk_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"},"subdomain":{"d":"api"}}, [2,[7,"/"],[2,[6,"email"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"bulk"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /email/v1/comments/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_email_v1_comment_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"},"subdomain":{"d":"api"}}, [2,[7,"/"],[2,[6,"email"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"comments"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /email/v1/comments(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_email_v1_comments_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"},"subdomain":{"d":"api"}}, [2,[7,"/"],[2,[6,"email"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"comments"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /email/v1/drafts/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_email_v1_draft_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"},"subdomain":{"d":"api"}}, [2,[7,"/"],[2,[6,"email"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"drafts"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /email/v1/drafts(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_email_v1_drafts_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"},"subdomain":{"d":"api"}}, [2,[7,"/"],[2,[6,"email"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"drafts"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /email/v1/folders/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_email_v1_folder_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"},"subdomain":{"d":"api"}}, [2,[7,"/"],[2,[6,"email"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"folders"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /email/v1/folders(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_email_v1_folders_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"},"subdomain":{"d":"api"}}, [2,[7,"/"],[2,[6,"email"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"folders"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /email/v1/compose/forward(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_email_v1_forward_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"},"subdomain":{"d":"api"}}, [2,[7,"/"],[2,[6,"email"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"compose"],[2,[7,"/"],[2,[6,"forward"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /email/v1/mailboxes(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_email_v1_mailboxes_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"},"subdomain":{"d":"api"}}, [2,[7,"/"],[2,[6,"email"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"mailboxes"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /email/v1/me(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_email_v1_me_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"},"subdomain":{"d":"api"}}, [2,[7,"/"],[2,[6,"email"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"me"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /email/v1/multi_inbox(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_email_v1_multi_inbox_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"},"subdomain":{"d":"api"}}, [2,[7,"/"],[2,[6,"email"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"multi_inbox"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /email/v1/compose/new_email(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_email_v1_new_email_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"},"subdomain":{"d":"api"}}, [2,[7,"/"],[2,[6,"email"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"compose"],[2,[7,"/"],[2,[6,"new_email"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /email/v1/persons(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_email_v1_persons_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"},"subdomain":{"d":"api"}}, [2,[7,"/"],[2,[6,"email"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"persons"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /email/v1/push_tokens(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_email_v1_push_tokens_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"},"subdomain":{"d":"api"}}, [2,[7,"/"],[2,[6,"email"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"push_tokens"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /email/v1/push_tokens/mailbox_preferences(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_email_v1_push_tokens_mailbox_preferences_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"},"subdomain":{"d":"api"}}, [2,[7,"/"],[2,[6,"email"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"push_tokens"],[2,[7,"/"],[2,[6,"mailbox_preferences"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /email/v1/search/query(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_email_v1_query_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"},"subdomain":{"d":"api"}}, [2,[7,"/"],[2,[6,"email"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"search"],[2,[7,"/"],[2,[6,"query"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /email/v1/compose/reply(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_email_v1_reply_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"},"subdomain":{"d":"api"}}, [2,[7,"/"],[2,[6,"email"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"compose"],[2,[7,"/"],[2,[6,"reply"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /email/v1/compose/reply_all(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_email_v1_reply_all_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"},"subdomain":{"d":"api"}}, [2,[7,"/"],[2,[6,"email"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"compose"],[2,[7,"/"],[2,[6,"reply_all"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /email/v1/sidebar_counts(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_email_v1_sidebar_counts_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"},"subdomain":{"d":"api"}}, [2,[7,"/"],[2,[6,"email"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"sidebar_counts"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /email/v1/tags(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_email_v1_tags_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"},"subdomain":{"d":"api"}}, [2,[7,"/"],[2,[6,"email"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"tags"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /email/v1/tenants(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_email_v1_tenants_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"},"subdomain":{"d":"api"}}, [2,[7,"/"],[2,[6,"email"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"tenants"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /email/v1/threads/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_email_v1_thread_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"},"subdomain":{"d":"api"}}, [2,[7,"/"],[2,[6,"email"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"threads"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /email/v1/threads(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_email_v1_threads_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"},"subdomain":{"d":"api"}}, [2,[7,"/"],[2,[6,"email"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"threads"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/system_prompt.json(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_internal_path = /*#__PURE__*/ __jsr.r({"format":{},"subdomain":{"d":"api"}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"system_prompt"],[2,[8,"."],[2,[6,"json"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/drive_files/finalize(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_internal_drive_files_finalize_path = /*#__PURE__*/ __jsr.r({"format":{},"subdomain":{"d":"api"}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"drive_files"],[2,[7,"/"],[2,[6,"finalize"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/drive_files/presign(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_internal_drive_files_presign_path = /*#__PURE__*/ __jsr.r({"format":{},"subdomain":{"d":"api"}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"drive_files"],[2,[7,"/"],[2,[6,"presign"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /mcp/tasks.json(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_mcp_path = /*#__PURE__*/ __jsr.r({"format":{},"subdomain":{"d":"api"}}, [2,[7,"/"],[2,[6,"mcp"],[2,[7,"/"],[2,[6,"tasks"],[2,[8,"."],[2,[6,"json"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /messenger/v1/webhook(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_messenger_v1_webhook_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"},"subdomain":{"d":"api"}}, [2,[7,"/"],[2,[6,"messenger"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"webhook"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /resident_reports/v1/building_complexes(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_resident_reports_v1_building_complexes_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"},"subdomain":{"d":"api"}}, [2,[7,"/"],[2,[6,"resident_reports"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"building_complexes"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /resident_reports/v1/reports/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_resident_reports_v1_report_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"},"subdomain":{"d":"api"}}, [2,[7,"/"],[2,[6,"resident_reports"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /resident_reports/v1/reports(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_resident_reports_v1_reports_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"},"subdomain":{"d":"api"}}, [2,[7,"/"],[2,[6,"resident_reports"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"reports"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /resident_reports/v1/settings(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_resident_reports_v1_settings_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"},"subdomain":{"d":"api"}}, [2,[7,"/"],[2,[6,"resident_reports"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"settings"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /resident_reports/v1/tenants(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_resident_reports_v1_tenants_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"},"subdomain":{"d":"api"}}, [2,[7,"/"],[2,[6,"resident_reports"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"tenants"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /tasks.ics(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_tasks_ical_path = /*#__PURE__*/ __jsr.r({"format":{"d":"ics"},"subdomain":{"d":"api"}}, [2,[7,"/"],[2,[6,"tasks"],[2,[8,"."],[2,[6,"ics"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /voice/dictations/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_voice_dictation_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{},"subdomain":{"d":"api"}}, [2,[7,"/"],[2,[6,"voice"],[2,[7,"/"],[2,[6,"dictations"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /voice/dictations(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_voice_dictations_path = /*#__PURE__*/ __jsr.r({"format":{},"subdomain":{"d":"api"}}, [2,[7,"/"],[2,[6,"voice"],[2,[7,"/"],[2,[6,"dictations"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /voice/log_usage(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_voice_log_usage_path = /*#__PURE__*/ __jsr.r({"format":{},"subdomain":{"d":"api"}}, [2,[7,"/"],[2,[6,"voice"],[2,[7,"/"],[2,[6,"log_usage"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /voice/parse(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_voice_parse_path = /*#__PURE__*/ __jsr.r({"format":{},"subdomain":{"d":"api"}}, [2,[7,"/"],[2,[6,"voice"],[2,[7,"/"],[2,[6,"parse"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /chat/v1/push_tokens/app_state(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const app_state_api_chat_v1_push_tokens_path = /*#__PURE__*/ __jsr.r({"format":{},"subdomain":{"d":"api"}}, [2,[7,"/"],[2,[6,"chat"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"push_tokens"],[2,[7,"/"],[2,[6,"app_state"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /email/v1/push_tokens/app_state(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const app_state_api_email_v1_push_tokens_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"},"subdomain":{"d":"api"}}, [2,[7,"/"],[2,[6,"email"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"push_tokens"],[2,[7,"/"],[2,[6,"app_state"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/call_center/voicemails/archive(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const archive_admin_call_center_voicemails_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"call_center"],[2,[7,"/"],[2,[6,"voicemails"],[2,[7,"/"],[2,[6,"archive"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /area_types/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const area_type_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"area_types"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /area_types(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const area_types_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"area_types"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /complexes/:id/assembly_report(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const assembly_report_building_complex_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"complexes"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"assembly_report"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/support/conversations/:id/assign_responsible(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const assign_responsible_admin_support_conversation_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"support"],[2,[7,"/"],[2,[6,"conversations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"assign_responsible"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /email/v1/threads/:id/assign_responsible(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const assign_responsible_api_email_v1_thread_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"},"subdomain":{"d":"api"}}, [2,[7,"/"],[2,[6,"email"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"threads"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"assign_responsible"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /emails/threads/:id/assign_responsible(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const assign_responsible_emails_thread_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"emails"],[2,[7,"/"],[2,[6,"threads"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"assign_responsible"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /complexes/:id/associate(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const associate_building_complex_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"complexes"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"associate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /complexes/:building_complex_id/buildings/:id/associate(.:format)
 * @param {any} building_complex_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const associate_building_complex_building_path = /*#__PURE__*/ __jsr.r({"building_complex_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"complexes"],[2,[7,"/"],[2,[3,"building_complex_id"],[2,[7,"/"],[2,[6,"buildings"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"associate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /complexes/:building_complex_id/buildings/:building_id/areas/:id/associate(.:format)
 * @param {any} building_complex_id
 * @param {any} building_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const associate_building_complex_building_area_path = /*#__PURE__*/ __jsr.r({"building_complex_id":{"r":true},"building_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"complexes"],[2,[7,"/"],[2,[3,"building_complex_id"],[2,[7,"/"],[2,[6,"buildings"],[2,[7,"/"],[2,[3,"building_id"],[2,[7,"/"],[2,[6,"areas"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"associate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /complexes/:building_complex_id/buildings/:building_id/areas/:area_id/properties/:id/associate(.:format)
 * @param {any} building_complex_id
 * @param {any} building_id
 * @param {any} area_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const associate_building_complex_building_area_property_path = /*#__PURE__*/ __jsr.r({"building_complex_id":{"r":true},"building_id":{"r":true},"area_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"complexes"],[2,[7,"/"],[2,[3,"building_complex_id"],[2,[7,"/"],[2,[6,"buildings"],[2,[7,"/"],[2,[3,"building_id"],[2,[7,"/"],[2,[6,"areas"],[2,[7,"/"],[2,[3,"area_id"],[2,[7,"/"],[2,[6,"properties"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"associate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /complexes/:building_complex_id/contracts/:id/associate(.:format)
 * @param {any} building_complex_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const associate_building_complex_contract_path = /*#__PURE__*/ __jsr.r({"building_complex_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"complexes"],[2,[7,"/"],[2,[3,"building_complex_id"],[2,[7,"/"],[2,[6,"contracts"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"associate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /complexes/:building_complex_id/equipments/:id/associate(.:format)
 * @param {any} building_complex_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const associate_building_complex_equipment_path = /*#__PURE__*/ __jsr.r({"building_complex_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"complexes"],[2,[7,"/"],[2,[3,"building_complex_id"],[2,[7,"/"],[2,[6,"equipments"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"associate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /complexes/:building_complex_id/meters/:id/associate(.:format)
 * @param {any} building_complex_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const associate_building_complex_meter_path = /*#__PURE__*/ __jsr.r({"building_complex_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"complexes"],[2,[7,"/"],[2,[3,"building_complex_id"],[2,[7,"/"],[2,[6,"meters"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"associate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /complexes/:building_complex_id/services/:id/associate(.:format)
 * @param {any} building_complex_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const associate_building_complex_service_path = /*#__PURE__*/ __jsr.r({"building_complex_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"complexes"],[2,[7,"/"],[2,[3,"building_complex_id"],[2,[7,"/"],[2,[6,"services"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"associate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /complexes/:building_complex_id/warranties/:id/associate(.:format)
 * @param {any} building_complex_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const associate_building_complex_warranty_path = /*#__PURE__*/ __jsr.r({"building_complex_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"complexes"],[2,[7,"/"],[2,[3,"building_complex_id"],[2,[7,"/"],[2,[6,"warranties"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"associate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /companies/:id/associate(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const associate_company_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"companies"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"associate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /tasks/:id/associate_company_people(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const associate_company_people_task_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"tasks"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"associate_company_people"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /company_relationship_types/:id/associate(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const associate_company_relationship_type_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"company_relationship_types"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"associate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /complexes/:id/associate_detail/:entity_id(.:format)
 * @param {any} id
 * @param {any} entity_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const associate_detail_building_complex_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"entity_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"complexes"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"associate_detail"],[2,[7,"/"],[2,[3,"entity_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /complexes/:building_complex_id/buildings/:id/associate_detail/:entity_id(.:format)
 * @param {any} building_complex_id
 * @param {any} id
 * @param {any} entity_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const associate_detail_building_complex_building_path = /*#__PURE__*/ __jsr.r({"building_complex_id":{"r":true},"id":{"r":true},"entity_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"complexes"],[2,[7,"/"],[2,[3,"building_complex_id"],[2,[7,"/"],[2,[6,"buildings"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"associate_detail"],[2,[7,"/"],[2,[3,"entity_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /complexes/:building_complex_id/buildings/:building_id/areas/:id/associate_detail/:entity_id(.:format)
 * @param {any} building_complex_id
 * @param {any} building_id
 * @param {any} id
 * @param {any} entity_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const associate_detail_building_complex_building_area_path = /*#__PURE__*/ __jsr.r({"building_complex_id":{"r":true},"building_id":{"r":true},"id":{"r":true},"entity_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"complexes"],[2,[7,"/"],[2,[3,"building_complex_id"],[2,[7,"/"],[2,[6,"buildings"],[2,[7,"/"],[2,[3,"building_id"],[2,[7,"/"],[2,[6,"areas"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"associate_detail"],[2,[7,"/"],[2,[3,"entity_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /complexes/:building_complex_id/buildings/:building_id/areas/:area_id/properties/:id/associate_detail/:entity_id(.:format)
 * @param {any} building_complex_id
 * @param {any} building_id
 * @param {any} area_id
 * @param {any} id
 * @param {any} entity_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const associate_detail_building_complex_building_area_property_path = /*#__PURE__*/ __jsr.r({"building_complex_id":{"r":true},"building_id":{"r":true},"area_id":{"r":true},"id":{"r":true},"entity_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"complexes"],[2,[7,"/"],[2,[3,"building_complex_id"],[2,[7,"/"],[2,[6,"buildings"],[2,[7,"/"],[2,[3,"building_id"],[2,[7,"/"],[2,[6,"areas"],[2,[7,"/"],[2,[3,"area_id"],[2,[7,"/"],[2,[6,"properties"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"associate_detail"],[2,[7,"/"],[2,[3,"entity_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /complexes/:building_complex_id/contracts/:id/associate_detail/:entity_id(.:format)
 * @param {any} building_complex_id
 * @param {any} id
 * @param {any} entity_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const associate_detail_building_complex_contract_path = /*#__PURE__*/ __jsr.r({"building_complex_id":{"r":true},"id":{"r":true},"entity_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"complexes"],[2,[7,"/"],[2,[3,"building_complex_id"],[2,[7,"/"],[2,[6,"contracts"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"associate_detail"],[2,[7,"/"],[2,[3,"entity_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /complexes/:building_complex_id/equipments/:id/associate_detail/:entity_id(.:format)
 * @param {any} building_complex_id
 * @param {any} id
 * @param {any} entity_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const associate_detail_building_complex_equipment_path = /*#__PURE__*/ __jsr.r({"building_complex_id":{"r":true},"id":{"r":true},"entity_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"complexes"],[2,[7,"/"],[2,[3,"building_complex_id"],[2,[7,"/"],[2,[6,"equipments"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"associate_detail"],[2,[7,"/"],[2,[3,"entity_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /complexes/:building_complex_id/meters/:id/associate_detail/:entity_id(.:format)
 * @param {any} building_complex_id
 * @param {any} id
 * @param {any} entity_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const associate_detail_building_complex_meter_path = /*#__PURE__*/ __jsr.r({"building_complex_id":{"r":true},"id":{"r":true},"entity_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"complexes"],[2,[7,"/"],[2,[3,"building_complex_id"],[2,[7,"/"],[2,[6,"meters"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"associate_detail"],[2,[7,"/"],[2,[3,"entity_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /complexes/:building_complex_id/services/:id/associate_detail/:entity_id(.:format)
 * @param {any} building_complex_id
 * @param {any} id
 * @param {any} entity_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const associate_detail_building_complex_service_path = /*#__PURE__*/ __jsr.r({"building_complex_id":{"r":true},"id":{"r":true},"entity_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"complexes"],[2,[7,"/"],[2,[3,"building_complex_id"],[2,[7,"/"],[2,[6,"services"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"associate_detail"],[2,[7,"/"],[2,[3,"entity_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /complexes/:building_complex_id/warranties/:id/associate_detail/:entity_id(.:format)
 * @param {any} building_complex_id
 * @param {any} id
 * @param {any} entity_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const associate_detail_building_complex_warranty_path = /*#__PURE__*/ __jsr.r({"building_complex_id":{"r":true},"id":{"r":true},"entity_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"complexes"],[2,[7,"/"],[2,[3,"building_complex_id"],[2,[7,"/"],[2,[6,"warranties"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"associate_detail"],[2,[7,"/"],[2,[3,"entity_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /companies/:id/associate_detail/:entity_id(.:format)
 * @param {any} id
 * @param {any} entity_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const associate_detail_company_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"entity_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"companies"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"associate_detail"],[2,[7,"/"],[2,[3,"entity_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /company_relationship_types/:id/associate_detail/:entity_id(.:format)
 * @param {any} id
 * @param {any} entity_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const associate_detail_company_relationship_type_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"entity_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"company_relationship_types"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"associate_detail"],[2,[7,"/"],[2,[3,"entity_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /newsletters/:id/associate_detail/:entity_id(.:format)
 * @param {any} id
 * @param {any} entity_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const associate_detail_newsletter_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"entity_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"newsletters"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"associate_detail"],[2,[7,"/"],[2,[3,"entity_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /people/:id/associate_detail/:entity_id(.:format)
 * @param {any} id
 * @param {any} entity_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const associate_detail_person_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"entity_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"people"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"associate_detail"],[2,[7,"/"],[2,[3,"entity_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /person_groups/:id/associate_detail/:entity_id(.:format)
 * @param {any} id
 * @param {any} entity_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const associate_detail_person_group_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"entity_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"person_groups"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"associate_detail"],[2,[7,"/"],[2,[3,"entity_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /resident_reports/:id/associate_detail/:entity_id(.:format)
 * @param {any} id
 * @param {any} entity_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const associate_detail_resident_report_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"entity_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"resident_reports"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"associate_detail"],[2,[7,"/"],[2,[3,"entity_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /security-services/building-complexes/:id/associate_detail/:entity_id(.:format)
 * @param {any} id
 * @param {any} entity_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const associate_detail_security_services_building_complex_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"entity_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"security-services"],[2,[7,"/"],[2,[6,"building-complexes"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"associate_detail"],[2,[7,"/"],[2,[3,"entity_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /security-services/building-complexes/:building_complex_id/patrols/checkpoints/:id/associate_detail/:entity_id(.:format)
 * @param {any} building_complex_id
 * @param {any} id
 * @param {any} entity_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const associate_detail_security_services_building_complex_patrols_checkpoint_path = /*#__PURE__*/ __jsr.r({"building_complex_id":{"r":true},"id":{"r":true},"entity_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"security-services"],[2,[7,"/"],[2,[6,"building-complexes"],[2,[7,"/"],[2,[3,"building_complex_id"],[2,[7,"/"],[2,[6,"patrols"],[2,[7,"/"],[2,[6,"checkpoints"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"associate_detail"],[2,[7,"/"],[2,[3,"entity_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /security-services/building-complexes/:building_complex_id/patrols/roads/:id/associate_detail/:entity_id(.:format)
 * @param {any} building_complex_id
 * @param {any} id
 * @param {any} entity_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const associate_detail_security_services_building_complex_patrols_road_path = /*#__PURE__*/ __jsr.r({"building_complex_id":{"r":true},"id":{"r":true},"entity_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"security-services"],[2,[7,"/"],[2,[6,"building-complexes"],[2,[7,"/"],[2,[3,"building_complex_id"],[2,[7,"/"],[2,[6,"patrols"],[2,[7,"/"],[2,[6,"roads"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"associate_detail"],[2,[7,"/"],[2,[3,"entity_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /tasks/:id/associate_detail/:entity_id(.:format)
 * @param {any} id
 * @param {any} entity_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const associate_detail_task_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"entity_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"tasks"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"associate_detail"],[2,[7,"/"],[2,[3,"entity_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /newsletters/:id/associate(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const associate_newsletter_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"newsletters"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"associate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /people/:id/associate(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const associate_person_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"people"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"associate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /person_groups/:id/associate(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const associate_person_group_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"person_groups"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"associate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /resident_reports/:id/associate(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const associate_resident_report_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"resident_reports"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"associate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /complexes/:id/associate_search(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const associate_search_building_complex_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"complexes"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"associate_search"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /complexes/:building_complex_id/buildings/:id/associate_search(.:format)
 * @param {any} building_complex_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const associate_search_building_complex_building_path = /*#__PURE__*/ __jsr.r({"building_complex_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"complexes"],[2,[7,"/"],[2,[3,"building_complex_id"],[2,[7,"/"],[2,[6,"buildings"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"associate_search"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /complexes/:building_complex_id/buildings/:building_id/areas/:id/associate_search(.:format)
 * @param {any} building_complex_id
 * @param {any} building_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const associate_search_building_complex_building_area_path = /*#__PURE__*/ __jsr.r({"building_complex_id":{"r":true},"building_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"complexes"],[2,[7,"/"],[2,[3,"building_complex_id"],[2,[7,"/"],[2,[6,"buildings"],[2,[7,"/"],[2,[3,"building_id"],[2,[7,"/"],[2,[6,"areas"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"associate_search"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /complexes/:building_complex_id/buildings/:building_id/areas/:area_id/properties/:id/associate_search(.:format)
 * @param {any} building_complex_id
 * @param {any} building_id
 * @param {any} area_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const associate_search_building_complex_building_area_property_path = /*#__PURE__*/ __jsr.r({"building_complex_id":{"r":true},"building_id":{"r":true},"area_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"complexes"],[2,[7,"/"],[2,[3,"building_complex_id"],[2,[7,"/"],[2,[6,"buildings"],[2,[7,"/"],[2,[3,"building_id"],[2,[7,"/"],[2,[6,"areas"],[2,[7,"/"],[2,[3,"area_id"],[2,[7,"/"],[2,[6,"properties"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"associate_search"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /complexes/:building_complex_id/contracts/:id/associate_search(.:format)
 * @param {any} building_complex_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const associate_search_building_complex_contract_path = /*#__PURE__*/ __jsr.r({"building_complex_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"complexes"],[2,[7,"/"],[2,[3,"building_complex_id"],[2,[7,"/"],[2,[6,"contracts"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"associate_search"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /complexes/:building_complex_id/equipments/:id/associate_search(.:format)
 * @param {any} building_complex_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const associate_search_building_complex_equipment_path = /*#__PURE__*/ __jsr.r({"building_complex_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"complexes"],[2,[7,"/"],[2,[3,"building_complex_id"],[2,[7,"/"],[2,[6,"equipments"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"associate_search"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /complexes/:building_complex_id/meters/:id/associate_search(.:format)
 * @param {any} building_complex_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const associate_search_building_complex_meter_path = /*#__PURE__*/ __jsr.r({"building_complex_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"complexes"],[2,[7,"/"],[2,[3,"building_complex_id"],[2,[7,"/"],[2,[6,"meters"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"associate_search"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /complexes/:building_complex_id/services/:id/associate_search(.:format)
 * @param {any} building_complex_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const associate_search_building_complex_service_path = /*#__PURE__*/ __jsr.r({"building_complex_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"complexes"],[2,[7,"/"],[2,[3,"building_complex_id"],[2,[7,"/"],[2,[6,"services"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"associate_search"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /complexes/:building_complex_id/warranties/:id/associate_search(.:format)
 * @param {any} building_complex_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const associate_search_building_complex_warranty_path = /*#__PURE__*/ __jsr.r({"building_complex_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"complexes"],[2,[7,"/"],[2,[3,"building_complex_id"],[2,[7,"/"],[2,[6,"warranties"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"associate_search"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /companies/:id/associate_search(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const associate_search_company_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"companies"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"associate_search"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /company_relationship_types/:id/associate_search(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const associate_search_company_relationship_type_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"company_relationship_types"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"associate_search"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /newsletters/:id/associate_search(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const associate_search_newsletter_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"newsletters"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"associate_search"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /people/:id/associate_search(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const associate_search_person_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"people"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"associate_search"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /person_groups/:id/associate_search(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const associate_search_person_group_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"person_groups"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"associate_search"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /resident_reports/:id/associate_search(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const associate_search_resident_report_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"resident_reports"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"associate_search"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /security-services/building-complexes/:id/associate_search(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const associate_search_security_services_building_complex_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"security-services"],[2,[7,"/"],[2,[6,"building-complexes"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"associate_search"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /security-services/building-complexes/:building_complex_id/patrols/checkpoints/:id/associate_search(.:format)
 * @param {any} building_complex_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const associate_search_security_services_building_complex_patrols_checkpoint_path = /*#__PURE__*/ __jsr.r({"building_complex_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"security-services"],[2,[7,"/"],[2,[6,"building-complexes"],[2,[7,"/"],[2,[3,"building_complex_id"],[2,[7,"/"],[2,[6,"patrols"],[2,[7,"/"],[2,[6,"checkpoints"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"associate_search"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /security-services/building-complexes/:building_complex_id/patrols/roads/:id/associate_search(.:format)
 * @param {any} building_complex_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const associate_search_security_services_building_complex_patrols_road_path = /*#__PURE__*/ __jsr.r({"building_complex_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"security-services"],[2,[7,"/"],[2,[6,"building-complexes"],[2,[7,"/"],[2,[3,"building_complex_id"],[2,[7,"/"],[2,[6,"patrols"],[2,[7,"/"],[2,[6,"roads"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"associate_search"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /tasks/:id/associate_search(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const associate_search_task_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"tasks"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"associate_search"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /security-services/building-complexes/:id/associate(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const associate_security_services_building_complex_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"security-services"],[2,[7,"/"],[2,[6,"building-complexes"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"associate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /security-services/building-complexes/:building_complex_id/patrols/checkpoints/:id/associate(.:format)
 * @param {any} building_complex_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const associate_security_services_building_complex_patrols_checkpoint_path = /*#__PURE__*/ __jsr.r({"building_complex_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"security-services"],[2,[7,"/"],[2,[6,"building-complexes"],[2,[7,"/"],[2,[3,"building_complex_id"],[2,[7,"/"],[2,[6,"patrols"],[2,[7,"/"],[2,[6,"checkpoints"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"associate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /security-services/building-complexes/:building_complex_id/patrols/roads/:id/associate(.:format)
 * @param {any} building_complex_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const associate_security_services_building_complex_patrols_road_path = /*#__PURE__*/ __jsr.r({"building_complex_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"security-services"],[2,[7,"/"],[2,[6,"building-complexes"],[2,[7,"/"],[2,[3,"building_complex_id"],[2,[7,"/"],[2,[6,"patrols"],[2,[7,"/"],[2,[6,"roads"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"associate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /tasks/:id/associate(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const associate_task_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"tasks"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"associate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /drive/async_delete(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const async_delete_drive_index_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"drive"],[2,[7,"/"],[2,[6,"async_delete"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /resident_reports/:id/attach_to_task(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const attach_to_task_resident_report_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"resident_reports"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"attach_to_task"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /drive/attach_uploads(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const attach_uploads_drive_index_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"drive"],[2,[7,"/"],[2,[6,"attach_uploads"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /emails/threads/:id/audit_events(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const audit_events_emails_thread_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"emails"],[2,[7,"/"],[2,[6,"threads"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"audit_events"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /security-services/building-complexes/:building_complex_id/package-deliveries/autocomplete(.:format)
 * @param {any} building_complex_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const autocomplete_security_services_building_complex_package_deliveries_path = /*#__PURE__*/ __jsr.r({"building_complex_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"security-services"],[2,[7,"/"],[2,[6,"building-complexes"],[2,[7,"/"],[2,[3,"building_complex_id"],[2,[7,"/"],[2,[6,"package-deliveries"],[2,[7,"/"],[2,[6,"autocomplete"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /security-services/building-complexes/:building_complex_id/recipients/autocomplete(.:format)
 * @param {any} building_complex_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const autocomplete_security_services_building_complex_recipients_path = /*#__PURE__*/ __jsr.r({"building_complex_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"security-services"],[2,[7,"/"],[2,[6,"building-complexes"],[2,[7,"/"],[2,[3,"building_complex_id"],[2,[7,"/"],[2,[6,"recipients"],[2,[7,"/"],[2,[6,"autocomplete"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const aws_action_mailbox_ses_engine_path = /*#__PURE__*/ __jsr.r({}, [7,"/"]);

/**
 * Generates rails route to
 * /chat/dock/badge(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const badge_chat_dock_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"chat"],[2,[7,"/"],[2,[6,"dock"],[2,[7,"/"],[2,[6,"badge"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /billingo/bank_accounts/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const billingo_bank_account_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"billingo"],[2,[7,"/"],[2,[6,"bank_accounts"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /billingo/bank_accounts(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const billingo_bank_accounts_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"billingo"],[2,[7,"/"],[2,[6,"bank_accounts"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /billingo/currencies(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const billingo_currencies_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"billingo"],[2,[7,"/"],[2,[6,"currencies"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /billingo/documents/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const billingo_document_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"billingo"],[2,[7,"/"],[2,[6,"documents"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /billingo/documents(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const billingo_documents_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"billingo"],[2,[7,"/"],[2,[6,"documents"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /billingo/invoices/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const billingo_invoice_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"billingo"],[2,[7,"/"],[2,[6,"invoices"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /billingo/invoices(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const billingo_invoices_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"billingo"],[2,[7,"/"],[2,[6,"invoices"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /billingo/organization(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const billingo_organization_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"billingo"],[2,[7,"/"],[2,[6,"organization"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /billingo/partners/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const billingo_partner_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"billingo"],[2,[7,"/"],[2,[6,"partners"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /billingo/partners(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const billingo_partners_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"billingo"],[2,[7,"/"],[2,[6,"partners"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /billingo/products/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const billingo_product_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"billingo"],[2,[7,"/"],[2,[6,"products"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /billingo/products(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const billingo_products_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"billingo"],[2,[7,"/"],[2,[6,"products"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /billingo/spendings/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const billingo_spending_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"billingo"],[2,[7,"/"],[2,[6,"spendings"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /billingo/spending_categories(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const billingo_spending_categories_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"billingo"],[2,[7,"/"],[2,[6,"spending_categories"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /billingo/spending_categories/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const billingo_spending_category_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"billingo"],[2,[7,"/"],[2,[6,"spending_categories"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /billingo/spendings(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const billingo_spendings_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"billingo"],[2,[7,"/"],[2,[6,"spendings"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /billingo/units(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const billingo_units_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"billingo"],[2,[7,"/"],[2,[6,"units"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /billingo/vats(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const billingo_vats_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"billingo"],[2,[7,"/"],[2,[6,"vats"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /billingo/webhooks/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const billingo_webhook_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"billingo"],[2,[7,"/"],[2,[6,"webhooks"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /billingo/webhooks(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const billingo_webhooks_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"billingo"],[2,[7,"/"],[2,[6,"webhooks"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /invoices/:id/breakdown(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const breakdown_invoice_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"invoices"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"breakdown"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /complexes/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const building_complex_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"complexes"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /complexes/:building_complex_id/buildings/:id(.:format)
 * @param {any} building_complex_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const building_complex_building_path = /*#__PURE__*/ __jsr.r({"building_complex_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"complexes"],[2,[7,"/"],[2,[3,"building_complex_id"],[2,[7,"/"],[2,[6,"buildings"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /complexes/:building_complex_id/buildings/:building_id/areas/:id(.:format)
 * @param {any} building_complex_id
 * @param {any} building_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const building_complex_building_area_path = /*#__PURE__*/ __jsr.r({"building_complex_id":{"r":true},"building_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"complexes"],[2,[7,"/"],[2,[3,"building_complex_id"],[2,[7,"/"],[2,[6,"buildings"],[2,[7,"/"],[2,[3,"building_id"],[2,[7,"/"],[2,[6,"areas"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /complexes/:building_complex_id/buildings/:building_id/areas/:area_id/children/:id(.:format)
 * @param {any} building_complex_id
 * @param {any} building_id
 * @param {any} area_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const building_complex_building_area_child_path = /*#__PURE__*/ __jsr.r({"building_complex_id":{"r":true},"building_id":{"r":true},"area_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"complexes"],[2,[7,"/"],[2,[3,"building_complex_id"],[2,[7,"/"],[2,[6,"buildings"],[2,[7,"/"],[2,[3,"building_id"],[2,[7,"/"],[2,[6,"areas"],[2,[7,"/"],[2,[3,"area_id"],[2,[7,"/"],[2,[6,"children"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /complexes/:building_complex_id/buildings/:building_id/areas/:area_id/children(.:format)
 * @param {any} building_complex_id
 * @param {any} building_id
 * @param {any} area_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const building_complex_building_area_children_path = /*#__PURE__*/ __jsr.r({"building_complex_id":{"r":true},"building_id":{"r":true},"area_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"complexes"],[2,[7,"/"],[2,[3,"building_complex_id"],[2,[7,"/"],[2,[6,"buildings"],[2,[7,"/"],[2,[3,"building_id"],[2,[7,"/"],[2,[6,"areas"],[2,[7,"/"],[2,[3,"area_id"],[2,[7,"/"],[2,[6,"children"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /complexes/:building_complex_id/buildings/:building_id/areas/:area_id/properties(.:format)
 * @param {any} building_complex_id
 * @param {any} building_id
 * @param {any} area_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const building_complex_building_area_properties_path = /*#__PURE__*/ __jsr.r({"building_complex_id":{"r":true},"building_id":{"r":true},"area_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"complexes"],[2,[7,"/"],[2,[3,"building_complex_id"],[2,[7,"/"],[2,[6,"buildings"],[2,[7,"/"],[2,[3,"building_id"],[2,[7,"/"],[2,[6,"areas"],[2,[7,"/"],[2,[3,"area_id"],[2,[7,"/"],[2,[6,"properties"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /complexes/:building_complex_id/buildings/:building_id/areas/:area_id/properties/:id(.:format)
 * @param {any} building_complex_id
 * @param {any} building_id
 * @param {any} area_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const building_complex_building_area_property_path = /*#__PURE__*/ __jsr.r({"building_complex_id":{"r":true},"building_id":{"r":true},"area_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"complexes"],[2,[7,"/"],[2,[3,"building_complex_id"],[2,[7,"/"],[2,[6,"buildings"],[2,[7,"/"],[2,[3,"building_id"],[2,[7,"/"],[2,[6,"areas"],[2,[7,"/"],[2,[3,"area_id"],[2,[7,"/"],[2,[6,"properties"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /complexes/:building_complex_id/buildings/:building_id/areas(.:format)
 * @param {any} building_complex_id
 * @param {any} building_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const building_complex_building_areas_path = /*#__PURE__*/ __jsr.r({"building_complex_id":{"r":true},"building_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"complexes"],[2,[7,"/"],[2,[3,"building_complex_id"],[2,[7,"/"],[2,[6,"buildings"],[2,[7,"/"],[2,[3,"building_id"],[2,[7,"/"],[2,[6,"areas"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /complexes/:building_complex_id/buildings(.:format)
 * @param {any} building_complex_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const building_complex_buildings_path = /*#__PURE__*/ __jsr.r({"building_complex_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"complexes"],[2,[7,"/"],[2,[3,"building_complex_id"],[2,[7,"/"],[2,[6,"buildings"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /complexes/:building_complex_id/contracts/:id(.:format)
 * @param {any} building_complex_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const building_complex_contract_path = /*#__PURE__*/ __jsr.r({"building_complex_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"complexes"],[2,[7,"/"],[2,[3,"building_complex_id"],[2,[7,"/"],[2,[6,"contracts"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /complexes/:building_complex_id/contracts(.:format)
 * @param {any} building_complex_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const building_complex_contracts_path = /*#__PURE__*/ __jsr.r({"building_complex_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"complexes"],[2,[7,"/"],[2,[3,"building_complex_id"],[2,[7,"/"],[2,[6,"contracts"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /building_complex_data_entry/:token(.:format)
 * @param {any} token
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const building_complex_data_entry_path = /*#__PURE__*/ __jsr.r({"token":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"building_complex_data_entry"],[2,[7,"/"],[2,[3,"token"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /resident_reports/:id/:building_complex_id(.:format)
 * @param {any} id
 * @param {any} building_complex_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const building_complex_destroy_resident_report_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"building_complex_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"resident_reports"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[3,"building_complex_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /tasks/:id/:building_complex_id(.:format)
 * @param {any} id
 * @param {any} building_complex_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const building_complex_destroy_task_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"building_complex_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"tasks"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[3,"building_complex_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /resident_reports/:id/edit/:building_complex_id(.:format)
 * @param {any} id
 * @param {any} building_complex_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const building_complex_edit_resident_report_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"building_complex_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"resident_reports"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[2,[7,"/"],[2,[3,"building_complex_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /tasks/:id/edit/:building_complex_id(.:format)
 * @param {any} id
 * @param {any} building_complex_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const building_complex_edit_task_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"building_complex_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"tasks"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[2,[7,"/"],[2,[3,"building_complex_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /complexes/:building_complex_id/equipments/:id(.:format)
 * @param {any} building_complex_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const building_complex_equipment_path = /*#__PURE__*/ __jsr.r({"building_complex_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"complexes"],[2,[7,"/"],[2,[3,"building_complex_id"],[2,[7,"/"],[2,[6,"equipments"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /complexes/:building_complex_id/equipments(.:format)
 * @param {any} building_complex_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const building_complex_equipments_path = /*#__PURE__*/ __jsr.r({"building_complex_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"complexes"],[2,[7,"/"],[2,[3,"building_complex_id"],[2,[7,"/"],[2,[6,"equipments"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /complexes/:building_complex_id/import(.:format)
 * @param {any} building_complex_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const building_complex_import_path = /*#__PURE__*/ __jsr.r({"building_complex_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"complexes"],[2,[7,"/"],[2,[3,"building_complex_id"],[2,[7,"/"],[2,[6,"import"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /complexes/:building_complex_id/incidents/:id(.:format)
 * @param {any} building_complex_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const building_complex_incident_path = /*#__PURE__*/ __jsr.r({"building_complex_id":{"r":true},"id":{"r":true},"format":{"d":"html"}}, [2,[7,"/"],[2,[6,"complexes"],[2,[7,"/"],[2,[3,"building_complex_id"],[2,[7,"/"],[2,[6,"incidents"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /complexes/:building_complex_id/incidents(.:format)
 * @param {any} building_complex_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const building_complex_incidents_path = /*#__PURE__*/ __jsr.r({"building_complex_id":{"r":true},"format":{"d":"html"}}, [2,[7,"/"],[2,[6,"complexes"],[2,[7,"/"],[2,[3,"building_complex_id"],[2,[7,"/"],[2,[6,"incidents"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /complexes/:building_complex_id/insurance_events/:id(.:format)
 * @param {any} building_complex_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const building_complex_insurance_event_path = /*#__PURE__*/ __jsr.r({"building_complex_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"complexes"],[2,[7,"/"],[2,[3,"building_complex_id"],[2,[7,"/"],[2,[6,"insurance_events"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /complexes/:building_complex_id/insurance_events(.:format)
 * @param {any} building_complex_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const building_complex_insurance_events_path = /*#__PURE__*/ __jsr.r({"building_complex_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"complexes"],[2,[7,"/"],[2,[3,"building_complex_id"],[2,[7,"/"],[2,[6,"insurance_events"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /complexes/:building_complex_id/insurance_policies(.:format)
 * @param {any} building_complex_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const building_complex_insurance_policies_path = /*#__PURE__*/ __jsr.r({"building_complex_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"complexes"],[2,[7,"/"],[2,[3,"building_complex_id"],[2,[7,"/"],[2,[6,"insurance_policies"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /complexes/:building_complex_id/insurance_policies/:id(.:format)
 * @param {any} building_complex_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const building_complex_insurance_policy_path = /*#__PURE__*/ __jsr.r({"building_complex_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"complexes"],[2,[7,"/"],[2,[3,"building_complex_id"],[2,[7,"/"],[2,[6,"insurance_policies"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /complexes/:building_complex_id/meters/:id(.:format)
 * @param {any} building_complex_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const building_complex_meter_path = /*#__PURE__*/ __jsr.r({"building_complex_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"complexes"],[2,[7,"/"],[2,[3,"building_complex_id"],[2,[7,"/"],[2,[6,"meters"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /complexes/:building_complex_id/meters(.:format)
 * @param {any} building_complex_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const building_complex_meters_path = /*#__PURE__*/ __jsr.r({"building_complex_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"complexes"],[2,[7,"/"],[2,[3,"building_complex_id"],[2,[7,"/"],[2,[6,"meters"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /resident_reports/new/:building_complex_id(.:format)
 * @param {any} building_complex_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const building_complex_new_resident_reports_path = /*#__PURE__*/ __jsr.r({"building_complex_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"resident_reports"],[2,[7,"/"],[2,[6,"new"],[2,[7,"/"],[2,[3,"building_complex_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /tasks/new/:building_complex_id(.:format)
 * @param {any} building_complex_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const building_complex_new_tasks_path = /*#__PURE__*/ __jsr.r({"building_complex_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"tasks"],[2,[7,"/"],[2,[6,"new"],[2,[7,"/"],[2,[3,"building_complex_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /complexes/:building_complex_id/package-deliveries(.:format)
 * @param {any} building_complex_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const building_complex_package_deliveries_path = /*#__PURE__*/ __jsr.r({"building_complex_id":{"r":true},"format":{"d":"html"}}, [2,[7,"/"],[2,[6,"complexes"],[2,[7,"/"],[2,[3,"building_complex_id"],[2,[7,"/"],[2,[6,"package-deliveries"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /complexes/:building_complex_id/patrols/checkpoints/:id(.:format)
 * @param {any} building_complex_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const building_complex_patrols_checkpoint_path = /*#__PURE__*/ __jsr.r({"building_complex_id":{"r":true},"id":{"r":true},"format":{"d":"html"}}, [2,[7,"/"],[2,[6,"complexes"],[2,[7,"/"],[2,[3,"building_complex_id"],[2,[7,"/"],[2,[6,"patrols"],[2,[7,"/"],[2,[6,"checkpoints"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /complexes/:building_complex_id/patrols/checkpoints(.:format)
 * @param {any} building_complex_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const building_complex_patrols_checkpoints_path = /*#__PURE__*/ __jsr.r({"building_complex_id":{"r":true},"format":{"d":"html"}}, [2,[7,"/"],[2,[6,"complexes"],[2,[7,"/"],[2,[3,"building_complex_id"],[2,[7,"/"],[2,[6,"patrols"],[2,[7,"/"],[2,[6,"checkpoints"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /complexes/:building_complex_id/patrols/roads/:road_id/patrols/:id(.:format)
 * @param {any} building_complex_id
 * @param {any} road_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const building_complex_patrols_road_patrol_path = /*#__PURE__*/ __jsr.r({"building_complex_id":{"r":true},"road_id":{"r":true},"id":{"r":true},"format":{"d":"html"}}, [2,[7,"/"],[2,[6,"complexes"],[2,[7,"/"],[2,[3,"building_complex_id"],[2,[7,"/"],[2,[6,"patrols"],[2,[7,"/"],[2,[6,"roads"],[2,[7,"/"],[2,[3,"road_id"],[2,[7,"/"],[2,[6,"patrols"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /complexes/:building_complex_id/patrols/roads/:road_id/patrols/:id/coordinates(.:format)
 * @param {any} building_complex_id
 * @param {any} road_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const building_complex_patrols_road_patrol_coordinates_path = /*#__PURE__*/ __jsr.r({"building_complex_id":{"r":true},"road_id":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"complexes"],[2,[7,"/"],[2,[3,"building_complex_id"],[2,[7,"/"],[2,[6,"patrols"],[2,[7,"/"],[2,[6,"roads"],[2,[7,"/"],[2,[3,"road_id"],[2,[7,"/"],[2,[6,"patrols"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"coordinates"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /complexes/:building_complex_id/patrols/roads/:road_id/patrols(.:format)
 * @param {any} building_complex_id
 * @param {any} road_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const building_complex_patrols_road_patrols_path = /*#__PURE__*/ __jsr.r({"building_complex_id":{"r":true},"road_id":{"r":true},"format":{"d":"html"}}, [2,[7,"/"],[2,[6,"complexes"],[2,[7,"/"],[2,[3,"building_complex_id"],[2,[7,"/"],[2,[6,"patrols"],[2,[7,"/"],[2,[6,"roads"],[2,[7,"/"],[2,[3,"road_id"],[2,[7,"/"],[2,[6,"patrols"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /complexes/:building_complex_id/patrols/roads(.:format)
 * @param {any} building_complex_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const building_complex_patrols_roads_path = /*#__PURE__*/ __jsr.r({"building_complex_id":{"r":true},"format":{"d":"html"}}, [2,[7,"/"],[2,[6,"complexes"],[2,[7,"/"],[2,[3,"building_complex_id"],[2,[7,"/"],[2,[6,"patrols"],[2,[7,"/"],[2,[6,"roads"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /resident_reports/:building_complex_id/search(.:format)
 * @param {any} building_complex_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const building_complex_search_resident_reports_path = /*#__PURE__*/ __jsr.r({"building_complex_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"resident_reports"],[2,[7,"/"],[2,[3,"building_complex_id"],[2,[7,"/"],[2,[6,"search"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /tasks/:building_complex_id/search(.:format)
 * @param {any} building_complex_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const building_complex_search_tasks_path = /*#__PURE__*/ __jsr.r({"building_complex_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"tasks"],[2,[7,"/"],[2,[3,"building_complex_id"],[2,[7,"/"],[2,[6,"search"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /complexes/:building_complex_id/services/:id(.:format)
 * @param {any} building_complex_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const building_complex_service_path = /*#__PURE__*/ __jsr.r({"building_complex_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"complexes"],[2,[7,"/"],[2,[3,"building_complex_id"],[2,[7,"/"],[2,[6,"services"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /complexes/:building_complex_id/services(.:format)
 * @param {any} building_complex_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const building_complex_services_path = /*#__PURE__*/ __jsr.r({"building_complex_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"complexes"],[2,[7,"/"],[2,[3,"building_complex_id"],[2,[7,"/"],[2,[6,"services"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /resident_reports/:id/:building_complex_id(.:format)
 * @param {any} id
 * @param {any} building_complex_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const building_complex_update_resident_report_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"building_complex_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"resident_reports"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[3,"building_complex_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /tasks/:id/:building_complex_id(.:format)
 * @param {any} id
 * @param {any} building_complex_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const building_complex_update_task_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"building_complex_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"tasks"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[3,"building_complex_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /complexes/:building_complex_id/warranties(.:format)
 * @param {any} building_complex_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const building_complex_warranties_path = /*#__PURE__*/ __jsr.r({"building_complex_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"complexes"],[2,[7,"/"],[2,[3,"building_complex_id"],[2,[7,"/"],[2,[6,"warranties"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /complexes/:building_complex_id/warranties/:id(.:format)
 * @param {any} building_complex_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const building_complex_warranty_path = /*#__PURE__*/ __jsr.r({"building_complex_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"complexes"],[2,[7,"/"],[2,[3,"building_complex_id"],[2,[7,"/"],[2,[6,"warranties"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /complexes(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const building_complexes_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"complexes"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /tasks/calendar_events(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const calendar_events_tasks_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"tasks"],[2,[7,"/"],[2,[6,"calendar_events"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /tasks/calendar(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const calendar_tasks_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"tasks"],[2,[7,"/"],[2,[6,"calendar"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /call_center/call_sessions/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const call_center_call_session_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"call_center"],[2,[7,"/"],[2,[6,"call_sessions"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /call_center/call_sessions(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const call_center_call_sessions_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"call_center"],[2,[7,"/"],[2,[6,"call_sessions"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /call_center/ivr_flows/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const call_center_ivr_flow_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"call_center"],[2,[7,"/"],[2,[6,"ivr_flows"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /call_center/ivr_flows(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const call_center_ivr_flows_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"call_center"],[2,[7,"/"],[2,[6,"ivr_flows"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /call_center/voicemails/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const call_center_voicemail_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"call_center"],[2,[7,"/"],[2,[6,"voicemails"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /call_center/voicemails(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const call_center_voicemails_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"call_center"],[2,[7,"/"],[2,[6,"voicemails"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /call_center/call_sessions/:id/caller_context(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const caller_context_api_call_center_call_session_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{},"subdomain":{"d":"api"}}, [2,[7,"/"],[2,[6,"call_center"],[2,[7,"/"],[2,[6,"call_sessions"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"caller_context"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/invoices/:id/cancel(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const cancel_admin_invoice_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"invoices"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"cancel"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /billingo/invoices/:id/cancel(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const cancel_billingo_invoice_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"billingo"],[2,[7,"/"],[2,[6,"invoices"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"cancel"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /subscription/cancel(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const cancel_subscription_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"subscription"],[2,[7,"/"],[2,[6,"cancel"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /complexes/:building_complex_id/equipments/categories_for_trade(.:format)
 * @param {any} building_complex_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const categories_for_trade_building_complex_equipments_path = /*#__PURE__*/ __jsr.r({"building_complex_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"complexes"],[2,[7,"/"],[2,[3,"building_complex_id"],[2,[7,"/"],[2,[6,"equipments"],[2,[7,"/"],[2,[6,"categories_for_trade"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /cegadat_api/detail(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const cegadat_api_detail_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"cegadat_api"],[2,[7,"/"],[2,[6,"detail"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /cegadat_api/search(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const cegadat_api_search_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"cegadat_api"],[2,[7,"/"],[2,[6,"search"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /tenants/:id/change_current(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const change_current_tenant_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"tenants"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"change_current"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/support/conversations/:id/change_status(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const change_status_admin_support_conversation_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"support"],[2,[7,"/"],[2,[6,"conversations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"change_status"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /email/v1/threads/:id/change_status(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const change_status_api_email_v1_thread_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"},"subdomain":{"d":"api"}}, [2,[7,"/"],[2,[6,"email"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"threads"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"change_status"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /emails/threads/:id/change_status(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const change_status_emails_thread_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"emails"],[2,[7,"/"],[2,[6,"threads"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"change_status"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/ai/activity/charts_data(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const charts_data_admin_ai_activity_index_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"ai"],[2,[7,"/"],[2,[6,"activity"],[2,[7,"/"],[2,[6,"charts_data"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/dashboard/charts_data(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const charts_data_admin_dashboard_index_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"dashboard"],[2,[7,"/"],[2,[6,"charts_data"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/messenger/activity/charts_data(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const charts_data_admin_messenger_activity_index_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"messenger"],[2,[7,"/"],[2,[6,"activity"],[2,[7,"/"],[2,[6,"charts_data"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/tenants/:id/charts_data(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const charts_data_admin_tenant_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"tenants"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"charts_data"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/voice/activity/charts_data(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const charts_data_admin_voice_activity_index_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"voice"],[2,[7,"/"],[2,[6,"activity"],[2,[7,"/"],[2,[6,"charts_data"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/voice_assistant/activity/charts_data(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const charts_data_admin_voice_assistant_activity_index_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"voice_assistant"],[2,[7,"/"],[2,[6,"activity"],[2,[7,"/"],[2,[6,"charts_data"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /ai/statistics/charts_data(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const charts_data_ai_statistics_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"ai"],[2,[7,"/"],[2,[6,"statistics"],[2,[7,"/"],[2,[6,"charts_data"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /subscription/charts_data(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const charts_data_subscription_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"subscription"],[2,[7,"/"],[2,[6,"charts_data"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /voice/statistics/charts_data(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const charts_data_voice_statistics_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"voice"],[2,[7,"/"],[2,[6,"statistics"],[2,[7,"/"],[2,[6,"charts_data"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /chat/rooms/directs(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const chat_directs_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"chat"],[2,[7,"/"],[2,[6,"rooms"],[2,[7,"/"],[2,[6,"directs"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /chat/dock(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const chat_dock_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"chat"],[2,[7,"/"],[2,[6,"dock"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /chat/mentions(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const chat_mentions_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"chat"],[2,[7,"/"],[2,[6,"mentions"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /chat/messages/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const chat_message_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"chat"],[2,[7,"/"],[2,[6,"messages"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /chat/mobile_app_state(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const chat_mobile_app_state_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"chat"],[2,[7,"/"],[2,[6,"mobile_app_state"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /chat/panels/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const chat_panel_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"chat"],[2,[7,"/"],[2,[6,"panels"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /chat/rooms/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const chat_room_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"chat"],[2,[7,"/"],[2,[6,"rooms"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /chat/rooms/:room_id/messages/:id(.:format)
 * @param {any} room_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const chat_room_message_path = /*#__PURE__*/ __jsr.r({"room_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"chat"],[2,[7,"/"],[2,[6,"rooms"],[2,[7,"/"],[2,[3,"room_id"],[2,[7,"/"],[2,[6,"messages"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /chat/rooms/:room_id/messages/:message_id/reaction(.:format)
 * @param {any} room_id
 * @param {any} message_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const chat_room_message_reaction_path = /*#__PURE__*/ __jsr.r({"room_id":{"r":true},"message_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"chat"],[2,[7,"/"],[2,[6,"rooms"],[2,[7,"/"],[2,[3,"room_id"],[2,[7,"/"],[2,[6,"messages"],[2,[7,"/"],[2,[3,"message_id"],[2,[7,"/"],[2,[6,"reaction"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /chat/rooms/:room_id/messages(.:format)
 * @param {any} room_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const chat_room_messages_path = /*#__PURE__*/ __jsr.r({"room_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"chat"],[2,[7,"/"],[2,[6,"rooms"],[2,[7,"/"],[2,[3,"room_id"],[2,[7,"/"],[2,[6,"messages"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /chat/rooms/:room_id/person_profiles/:id(.:format)
 * @param {any} room_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const chat_room_person_profile_path = /*#__PURE__*/ __jsr.r({"room_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"chat"],[2,[7,"/"],[2,[6,"rooms"],[2,[7,"/"],[2,[3,"room_id"],[2,[7,"/"],[2,[6,"person_profiles"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /chat/rooms/:room_id/persons(.:format)
 * @param {any} room_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const chat_room_persons_path = /*#__PURE__*/ __jsr.r({"room_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"chat"],[2,[7,"/"],[2,[6,"rooms"],[2,[7,"/"],[2,[3,"room_id"],[2,[7,"/"],[2,[6,"persons"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /chat/rooms/:room_id/typing(.:format)
 * @param {any} room_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const chat_room_typing_index_path = /*#__PURE__*/ __jsr.r({"room_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"chat"],[2,[7,"/"],[2,[6,"rooms"],[2,[7,"/"],[2,[3,"room_id"],[2,[7,"/"],[2,[6,"typing"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /chat/rooms(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const chat_rooms_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"chat"],[2,[7,"/"],[2,[6,"rooms"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /chat(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const chat_root_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"chat"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /chat/search(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const chat_search_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"chat"],[2,[7,"/"],[2,[6,"search"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /chat/tasks/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const chat_task_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"chat"],[2,[7,"/"],[2,[6,"tasks"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /chat/unfurl_link(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const chat_unfurl_link_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"chat"],[2,[7,"/"],[2,[6,"unfurl_link"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /check/:token(.:format)
 * @param {any} token
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const check_path = /*#__PURE__*/ __jsr.r({"token":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"check"],[2,[7,"/"],[2,[3,"token"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /security-services/building-complexes/:building_complex_id/patrols/roads/:id/checkpoints(.:format)
 * @param {any} building_complex_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const checkpoints_security_services_building_complex_patrols_road_path = /*#__PURE__*/ __jsr.r({"building_complex_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"security-services"],[2,[7,"/"],[2,[6,"building-complexes"],[2,[7,"/"],[2,[3,"building_complex_id"],[2,[7,"/"],[2,[6,"patrols"],[2,[7,"/"],[2,[6,"roads"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"checkpoints"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /resident_reports/v1/reports/:id/comments(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const comments_api_resident_reports_v1_report_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"},"subdomain":{"d":"api"}}, [2,[7,"/"],[2,[6,"resident_reports"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"comments"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /companies(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const companies_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"companies"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /companies/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const company_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"companies"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /company_relationship_types/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const company_relationship_type_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"company_relationship_types"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /company_relationship_types(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const company_relationship_types_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"company_relationship_types"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /ai/voice_conversations/:id/complete(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const complete_api_ai_voice_conversation_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{},"subdomain":{"d":"api"}}, [2,[7,"/"],[2,[6,"ai"],[2,[7,"/"],[2,[6,"voice_conversations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"complete"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /email/v1/attachments/confirm(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const confirm_api_email_v1_attachments_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"},"subdomain":{"d":"api"}}, [2,[7,"/"],[2,[6,"email"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"attachments"],[2,[7,"/"],[2,[6,"confirm"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /confirmations(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const confirmations_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"confirmations"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /security-services/building-complexes/:building_complex_id/patrols/roads/:road_id/patrols/:id/coordinates(.:format)
 * @param {any} building_complex_id
 * @param {any} road_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const coordinates_security_services_building_complex_patrols_road_patrol_path = /*#__PURE__*/ __jsr.r({"building_complex_id":{"r":true},"road_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"security-services"],[2,[7,"/"],[2,[6,"building-complexes"],[2,[7,"/"],[2,[3,"building_complex_id"],[2,[7,"/"],[2,[6,"patrols"],[2,[7,"/"],[2,[6,"roads"],[2,[7,"/"],[2,[3,"road_id"],[2,[7,"/"],[2,[6,"patrols"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"coordinates"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/tenants/:id/create_admin_person(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const create_admin_person_admin_tenant_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"tenants"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"create_admin_person"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /complexes/:id/create_associate(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const create_associate_building_complex_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"complexes"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"create_associate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /complexes/:building_complex_id/buildings/:id/create_associate(.:format)
 * @param {any} building_complex_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const create_associate_building_complex_building_path = /*#__PURE__*/ __jsr.r({"building_complex_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"complexes"],[2,[7,"/"],[2,[3,"building_complex_id"],[2,[7,"/"],[2,[6,"buildings"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"create_associate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /complexes/:building_complex_id/buildings/:building_id/areas/:id/create_associate(.:format)
 * @param {any} building_complex_id
 * @param {any} building_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const create_associate_building_complex_building_area_path = /*#__PURE__*/ __jsr.r({"building_complex_id":{"r":true},"building_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"complexes"],[2,[7,"/"],[2,[3,"building_complex_id"],[2,[7,"/"],[2,[6,"buildings"],[2,[7,"/"],[2,[3,"building_id"],[2,[7,"/"],[2,[6,"areas"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"create_associate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /complexes/:building_complex_id/buildings/:building_id/areas/:area_id/properties/:id/create_associate(.:format)
 * @param {any} building_complex_id
 * @param {any} building_id
 * @param {any} area_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const create_associate_building_complex_building_area_property_path = /*#__PURE__*/ __jsr.r({"building_complex_id":{"r":true},"building_id":{"r":true},"area_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"complexes"],[2,[7,"/"],[2,[3,"building_complex_id"],[2,[7,"/"],[2,[6,"buildings"],[2,[7,"/"],[2,[3,"building_id"],[2,[7,"/"],[2,[6,"areas"],[2,[7,"/"],[2,[3,"area_id"],[2,[7,"/"],[2,[6,"properties"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"create_associate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /complexes/:building_complex_id/contracts/:id/create_associate(.:format)
 * @param {any} building_complex_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const create_associate_building_complex_contract_path = /*#__PURE__*/ __jsr.r({"building_complex_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"complexes"],[2,[7,"/"],[2,[3,"building_complex_id"],[2,[7,"/"],[2,[6,"contracts"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"create_associate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /complexes/:building_complex_id/equipments/:id/create_associate(.:format)
 * @param {any} building_complex_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const create_associate_building_complex_equipment_path = /*#__PURE__*/ __jsr.r({"building_complex_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"complexes"],[2,[7,"/"],[2,[3,"building_complex_id"],[2,[7,"/"],[2,[6,"equipments"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"create_associate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /complexes/:building_complex_id/meters/:id/create_associate(.:format)
 * @param {any} building_complex_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const create_associate_building_complex_meter_path = /*#__PURE__*/ __jsr.r({"building_complex_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"complexes"],[2,[7,"/"],[2,[3,"building_complex_id"],[2,[7,"/"],[2,[6,"meters"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"create_associate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /complexes/:building_complex_id/services/:id/create_associate(.:format)
 * @param {any} building_complex_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const create_associate_building_complex_service_path = /*#__PURE__*/ __jsr.r({"building_complex_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"complexes"],[2,[7,"/"],[2,[3,"building_complex_id"],[2,[7,"/"],[2,[6,"services"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"create_associate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /complexes/:building_complex_id/warranties/:id/create_associate(.:format)
 * @param {any} building_complex_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const create_associate_building_complex_warranty_path = /*#__PURE__*/ __jsr.r({"building_complex_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"complexes"],[2,[7,"/"],[2,[3,"building_complex_id"],[2,[7,"/"],[2,[6,"warranties"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"create_associate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /companies/:id/create_associate(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const create_associate_company_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"companies"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"create_associate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /company_relationship_types/:id/create_associate(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const create_associate_company_relationship_type_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"company_relationship_types"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"create_associate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /newsletters/:id/create_associate(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const create_associate_newsletter_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"newsletters"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"create_associate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /people/:id/create_associate(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const create_associate_person_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"people"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"create_associate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /person_groups/:id/create_associate(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const create_associate_person_group_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"person_groups"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"create_associate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /resident_reports/:id/create_associate(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const create_associate_resident_report_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"resident_reports"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"create_associate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /security-services/building-complexes/:id/create_associate(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const create_associate_security_services_building_complex_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"security-services"],[2,[7,"/"],[2,[6,"building-complexes"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"create_associate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /security-services/building-complexes/:building_complex_id/patrols/checkpoints/:id/create_associate(.:format)
 * @param {any} building_complex_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const create_associate_security_services_building_complex_patrols_checkpoint_path = /*#__PURE__*/ __jsr.r({"building_complex_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"security-services"],[2,[7,"/"],[2,[6,"building-complexes"],[2,[7,"/"],[2,[3,"building_complex_id"],[2,[7,"/"],[2,[6,"patrols"],[2,[7,"/"],[2,[6,"checkpoints"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"create_associate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /security-services/building-complexes/:building_complex_id/patrols/roads/:id/create_associate(.:format)
 * @param {any} building_complex_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const create_associate_security_services_building_complex_patrols_road_path = /*#__PURE__*/ __jsr.r({"building_complex_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"security-services"],[2,[7,"/"],[2,[6,"building-complexes"],[2,[7,"/"],[2,[3,"building_complex_id"],[2,[7,"/"],[2,[6,"patrols"],[2,[7,"/"],[2,[6,"roads"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"create_associate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /tasks/:id/create_associate(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const create_associate_task_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"tasks"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"create_associate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /resident_reports/:id/comments(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const create_comment_resident_report_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"resident_reports"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"comments"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /tasks/:id/comments(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const create_comment_task_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"tasks"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"comments"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /resident_reports/:id/create_task(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const create_task_resident_report_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"resident_reports"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"create_task"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /complexes/:id/delete_associate/:type/:entity_id/:association(.:format)
 * @param {any} id
 * @param {any} type
 * @param {any} entity_id
 * @param {any} association
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const delete_associate_building_complex_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"type":{"r":true},"entity_id":{"r":true},"association":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"complexes"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"delete_associate"],[2,[7,"/"],[2,[3,"type"],[2,[7,"/"],[2,[3,"entity_id"],[2,[7,"/"],[2,[3,"association"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /complexes/:building_complex_id/buildings/:id/delete_associate/:type/:entity_id/:association(.:format)
 * @param {any} building_complex_id
 * @param {any} id
 * @param {any} type
 * @param {any} entity_id
 * @param {any} association
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const delete_associate_building_complex_building_path = /*#__PURE__*/ __jsr.r({"building_complex_id":{"r":true},"id":{"r":true},"type":{"r":true},"entity_id":{"r":true},"association":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"complexes"],[2,[7,"/"],[2,[3,"building_complex_id"],[2,[7,"/"],[2,[6,"buildings"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"delete_associate"],[2,[7,"/"],[2,[3,"type"],[2,[7,"/"],[2,[3,"entity_id"],[2,[7,"/"],[2,[3,"association"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /complexes/:building_complex_id/buildings/:building_id/areas/:id/delete_associate/:type/:entity_id/:association(.:format)
 * @param {any} building_complex_id
 * @param {any} building_id
 * @param {any} id
 * @param {any} type
 * @param {any} entity_id
 * @param {any} association
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const delete_associate_building_complex_building_area_path = /*#__PURE__*/ __jsr.r({"building_complex_id":{"r":true},"building_id":{"r":true},"id":{"r":true},"type":{"r":true},"entity_id":{"r":true},"association":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"complexes"],[2,[7,"/"],[2,[3,"building_complex_id"],[2,[7,"/"],[2,[6,"buildings"],[2,[7,"/"],[2,[3,"building_id"],[2,[7,"/"],[2,[6,"areas"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"delete_associate"],[2,[7,"/"],[2,[3,"type"],[2,[7,"/"],[2,[3,"entity_id"],[2,[7,"/"],[2,[3,"association"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /complexes/:building_complex_id/buildings/:building_id/areas/:area_id/properties/:id/delete_associate/:type/:entity_id/:association(.:format)
 * @param {any} building_complex_id
 * @param {any} building_id
 * @param {any} area_id
 * @param {any} id
 * @param {any} type
 * @param {any} entity_id
 * @param {any} association
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const delete_associate_building_complex_building_area_property_path = /*#__PURE__*/ __jsr.r({"building_complex_id":{"r":true},"building_id":{"r":true},"area_id":{"r":true},"id":{"r":true},"type":{"r":true},"entity_id":{"r":true},"association":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"complexes"],[2,[7,"/"],[2,[3,"building_complex_id"],[2,[7,"/"],[2,[6,"buildings"],[2,[7,"/"],[2,[3,"building_id"],[2,[7,"/"],[2,[6,"areas"],[2,[7,"/"],[2,[3,"area_id"],[2,[7,"/"],[2,[6,"properties"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"delete_associate"],[2,[7,"/"],[2,[3,"type"],[2,[7,"/"],[2,[3,"entity_id"],[2,[7,"/"],[2,[3,"association"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /complexes/:building_complex_id/contracts/:id/delete_associate/:type/:entity_id/:association(.:format)
 * @param {any} building_complex_id
 * @param {any} id
 * @param {any} type
 * @param {any} entity_id
 * @param {any} association
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const delete_associate_building_complex_contract_path = /*#__PURE__*/ __jsr.r({"building_complex_id":{"r":true},"id":{"r":true},"type":{"r":true},"entity_id":{"r":true},"association":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"complexes"],[2,[7,"/"],[2,[3,"building_complex_id"],[2,[7,"/"],[2,[6,"contracts"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"delete_associate"],[2,[7,"/"],[2,[3,"type"],[2,[7,"/"],[2,[3,"entity_id"],[2,[7,"/"],[2,[3,"association"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /complexes/:building_complex_id/equipments/:id/delete_associate/:type/:entity_id/:association(.:format)
 * @param {any} building_complex_id
 * @param {any} id
 * @param {any} type
 * @param {any} entity_id
 * @param {any} association
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const delete_associate_building_complex_equipment_path = /*#__PURE__*/ __jsr.r({"building_complex_id":{"r":true},"id":{"r":true},"type":{"r":true},"entity_id":{"r":true},"association":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"complexes"],[2,[7,"/"],[2,[3,"building_complex_id"],[2,[7,"/"],[2,[6,"equipments"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"delete_associate"],[2,[7,"/"],[2,[3,"type"],[2,[7,"/"],[2,[3,"entity_id"],[2,[7,"/"],[2,[3,"association"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /complexes/:building_complex_id/meters/:id/delete_associate/:type/:entity_id/:association(.:format)
 * @param {any} building_complex_id
 * @param {any} id
 * @param {any} type
 * @param {any} entity_id
 * @param {any} association
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const delete_associate_building_complex_meter_path = /*#__PURE__*/ __jsr.r({"building_complex_id":{"r":true},"id":{"r":true},"type":{"r":true},"entity_id":{"r":true},"association":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"complexes"],[2,[7,"/"],[2,[3,"building_complex_id"],[2,[7,"/"],[2,[6,"meters"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"delete_associate"],[2,[7,"/"],[2,[3,"type"],[2,[7,"/"],[2,[3,"entity_id"],[2,[7,"/"],[2,[3,"association"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /complexes/:building_complex_id/services/:id/delete_associate/:type/:entity_id/:association(.:format)
 * @param {any} building_complex_id
 * @param {any} id
 * @param {any} type
 * @param {any} entity_id
 * @param {any} association
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const delete_associate_building_complex_service_path = /*#__PURE__*/ __jsr.r({"building_complex_id":{"r":true},"id":{"r":true},"type":{"r":true},"entity_id":{"r":true},"association":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"complexes"],[2,[7,"/"],[2,[3,"building_complex_id"],[2,[7,"/"],[2,[6,"services"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"delete_associate"],[2,[7,"/"],[2,[3,"type"],[2,[7,"/"],[2,[3,"entity_id"],[2,[7,"/"],[2,[3,"association"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /complexes/:building_complex_id/warranties/:id/delete_associate/:type/:entity_id/:association(.:format)
 * @param {any} building_complex_id
 * @param {any} id
 * @param {any} type
 * @param {any} entity_id
 * @param {any} association
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const delete_associate_building_complex_warranty_path = /*#__PURE__*/ __jsr.r({"building_complex_id":{"r":true},"id":{"r":true},"type":{"r":true},"entity_id":{"r":true},"association":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"complexes"],[2,[7,"/"],[2,[3,"building_complex_id"],[2,[7,"/"],[2,[6,"warranties"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"delete_associate"],[2,[7,"/"],[2,[3,"type"],[2,[7,"/"],[2,[3,"entity_id"],[2,[7,"/"],[2,[3,"association"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /companies/:id/delete_associate/:type/:entity_id/:association(.:format)
 * @param {any} id
 * @param {any} type
 * @param {any} entity_id
 * @param {any} association
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const delete_associate_company_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"type":{"r":true},"entity_id":{"r":true},"association":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"companies"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"delete_associate"],[2,[7,"/"],[2,[3,"type"],[2,[7,"/"],[2,[3,"entity_id"],[2,[7,"/"],[2,[3,"association"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /company_relationship_types/:id/delete_associate/:type/:entity_id/:association(.:format)
 * @param {any} id
 * @param {any} type
 * @param {any} entity_id
 * @param {any} association
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const delete_associate_company_relationship_type_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"type":{"r":true},"entity_id":{"r":true},"association":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"company_relationship_types"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"delete_associate"],[2,[7,"/"],[2,[3,"type"],[2,[7,"/"],[2,[3,"entity_id"],[2,[7,"/"],[2,[3,"association"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /newsletters/:id/delete_associate/:type/:entity_id/:association(.:format)
 * @param {any} id
 * @param {any} type
 * @param {any} entity_id
 * @param {any} association
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const delete_associate_newsletter_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"type":{"r":true},"entity_id":{"r":true},"association":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"newsletters"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"delete_associate"],[2,[7,"/"],[2,[3,"type"],[2,[7,"/"],[2,[3,"entity_id"],[2,[7,"/"],[2,[3,"association"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /people/:id/delete_associate/:type/:entity_id/:association(.:format)
 * @param {any} id
 * @param {any} type
 * @param {any} entity_id
 * @param {any} association
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const delete_associate_person_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"type":{"r":true},"entity_id":{"r":true},"association":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"people"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"delete_associate"],[2,[7,"/"],[2,[3,"type"],[2,[7,"/"],[2,[3,"entity_id"],[2,[7,"/"],[2,[3,"association"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /person_groups/:id/delete_associate/:type/:entity_id/:association(.:format)
 * @param {any} id
 * @param {any} type
 * @param {any} entity_id
 * @param {any} association
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const delete_associate_person_group_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"type":{"r":true},"entity_id":{"r":true},"association":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"person_groups"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"delete_associate"],[2,[7,"/"],[2,[3,"type"],[2,[7,"/"],[2,[3,"entity_id"],[2,[7,"/"],[2,[3,"association"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /resident_reports/:id/delete_associate/:type/:entity_id/:association(.:format)
 * @param {any} id
 * @param {any} type
 * @param {any} entity_id
 * @param {any} association
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const delete_associate_resident_report_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"type":{"r":true},"entity_id":{"r":true},"association":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"resident_reports"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"delete_associate"],[2,[7,"/"],[2,[3,"type"],[2,[7,"/"],[2,[3,"entity_id"],[2,[7,"/"],[2,[3,"association"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /security-services/building-complexes/:id/delete_associate/:type/:entity_id/:association(.:format)
 * @param {any} id
 * @param {any} type
 * @param {any} entity_id
 * @param {any} association
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const delete_associate_security_services_building_complex_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"type":{"r":true},"entity_id":{"r":true},"association":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"security-services"],[2,[7,"/"],[2,[6,"building-complexes"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"delete_associate"],[2,[7,"/"],[2,[3,"type"],[2,[7,"/"],[2,[3,"entity_id"],[2,[7,"/"],[2,[3,"association"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /security-services/building-complexes/:building_complex_id/patrols/checkpoints/:id/delete_associate/:type/:entity_id/:association(.:format)
 * @param {any} building_complex_id
 * @param {any} id
 * @param {any} type
 * @param {any} entity_id
 * @param {any} association
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const delete_associate_security_services_building_complex_patrols_checkpoint_path = /*#__PURE__*/ __jsr.r({"building_complex_id":{"r":true},"id":{"r":true},"type":{"r":true},"entity_id":{"r":true},"association":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"security-services"],[2,[7,"/"],[2,[6,"building-complexes"],[2,[7,"/"],[2,[3,"building_complex_id"],[2,[7,"/"],[2,[6,"patrols"],[2,[7,"/"],[2,[6,"checkpoints"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"delete_associate"],[2,[7,"/"],[2,[3,"type"],[2,[7,"/"],[2,[3,"entity_id"],[2,[7,"/"],[2,[3,"association"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /security-services/building-complexes/:building_complex_id/patrols/roads/:id/delete_associate/:type/:entity_id/:association(.:format)
 * @param {any} building_complex_id
 * @param {any} id
 * @param {any} type
 * @param {any} entity_id
 * @param {any} association
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const delete_associate_security_services_building_complex_patrols_road_path = /*#__PURE__*/ __jsr.r({"building_complex_id":{"r":true},"id":{"r":true},"type":{"r":true},"entity_id":{"r":true},"association":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"security-services"],[2,[7,"/"],[2,[6,"building-complexes"],[2,[7,"/"],[2,[3,"building_complex_id"],[2,[7,"/"],[2,[6,"patrols"],[2,[7,"/"],[2,[6,"roads"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"delete_associate"],[2,[7,"/"],[2,[3,"type"],[2,[7,"/"],[2,[3,"entity_id"],[2,[7,"/"],[2,[3,"association"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /tasks/:id/delete_associate/:type/:entity_id/:association(.:format)
 * @param {any} id
 * @param {any} type
 * @param {any} entity_id
 * @param {any} association
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const delete_associate_task_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"type":{"r":true},"entity_id":{"r":true},"association":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"tasks"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"delete_associate"],[2,[7,"/"],[2,[3,"type"],[2,[7,"/"],[2,[3,"entity_id"],[2,[7,"/"],[2,[3,"association"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /chat/v1/rooms/:room_id/messages/:id/delivered(.:format)
 * @param {any} room_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const delivered_api_chat_v1_room_message_path = /*#__PURE__*/ __jsr.r({"room_id":{"r":true},"id":{"r":true},"format":{},"subdomain":{"d":"api"}}, [2,[7,"/"],[2,[6,"chat"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"rooms"],[2,[7,"/"],[2,[3,"room_id"],[2,[7,"/"],[2,[6,"messages"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"delivered"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /chat/rooms/:room_id/messages/:id/delivered(.:format)
 * @param {any} room_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const delivered_chat_room_message_path = /*#__PURE__*/ __jsr.r({"room_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"chat"],[2,[7,"/"],[2,[6,"rooms"],[2,[7,"/"],[2,[3,"room_id"],[2,[7,"/"],[2,[6,"messages"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"delivered"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /active_sessions/destroy_all(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const destroy_all_active_sessions_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"active_sessions"],[2,[7,"/"],[2,[6,"destroy_all"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /tasks/:id/comments/:comment_id(.:format)
 * @param {any} id
 * @param {any} comment_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const destroy_comment_task_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"comment_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"tasks"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"comments"],[2,[7,"/"],[2,[3,"comment_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /propertymanager/:property_group_id/property/:id(.:format)
 * @param {any} property_group_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const destroy_property_manager_property_path = /*#__PURE__*/ __jsr.r({"property_group_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"propertymanager"],[2,[7,"/"],[2,[3,"property_group_id"],[2,[7,"/"],[2,[6,"property"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /chat/v1/rooms/direct(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const direct_api_chat_v1_rooms_path = /*#__PURE__*/ __jsr.r({"format":{},"subdomain":{"d":"api"}}, [2,[7,"/"],[2,[6,"chat"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"rooms"],[2,[7,"/"],[2,[6,"direct"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /downloads/:signed_id(.:format)
 * @param {any} signed_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const download_path = /*#__PURE__*/ __jsr.r({"signed_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"downloads"],[2,[7,"/"],[2,[3,"signed_id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/call_center/voicemails/:id/download(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const download_admin_call_center_voicemail_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"call_center"],[2,[7,"/"],[2,[6,"voicemails"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"download"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /call_center/voicemails/:id/download(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const download_call_center_voicemail_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"call_center"],[2,[7,"/"],[2,[6,"voicemails"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"download"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /drive/equipments/:building_complex_id/:equipment_id/:task_id/download/:attachment_id(.:format)
 * @param {any} building_complex_id
 * @param {any} equipment_id
 * @param {any} task_id
 * @param {any} attachment_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const download_equipment_task_file_drive_index_path = /*#__PURE__*/ __jsr.r({"building_complex_id":{"r":true},"equipment_id":{"r":true},"task_id":{"r":true},"attachment_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"drive"],[2,[7,"/"],[2,[6,"equipments"],[2,[7,"/"],[2,[3,"building_complex_id"],[2,[7,"/"],[2,[3,"equipment_id"],[2,[7,"/"],[2,[3,"task_id"],[2,[7,"/"],[2,[6,"download"],[2,[7,"/"],[2,[3,"attachment_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /drive/tasks/:building_complex_id/:task_id/download/:attachment_id(.:format)
 * @param {any} building_complex_id
 * @param {any} task_id
 * @param {any} attachment_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const download_task_file_drive_index_path = /*#__PURE__*/ __jsr.r({"building_complex_id":{"r":true},"task_id":{"r":true},"attachment_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"drive"],[2,[7,"/"],[2,[6,"tasks"],[2,[7,"/"],[2,[3,"building_complex_id"],[2,[7,"/"],[2,[3,"task_id"],[2,[7,"/"],[2,[6,"download"],[2,[7,"/"],[2,[3,"attachment_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /drive/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const drive_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"drive"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /drive/attach_folder_uploads(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const drive_attach_folder_uploads_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"drive"],[2,[7,"/"],[2,[6,"attach_folder_uploads"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /drive/folders/:folder_id/share(.:format)
 * @param {any} folder_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const drive_create_folder_share_path = /*#__PURE__*/ __jsr.r({"folder_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"drive"],[2,[7,"/"],[2,[6,"folders"],[2,[7,"/"],[2,[3,"folder_id"],[2,[7,"/"],[2,[6,"share"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /drive/files/:file_id/share(.:format)
 * @param {any} file_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const drive_create_share_path = /*#__PURE__*/ __jsr.r({"file_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"drive"],[2,[7,"/"],[2,[6,"files"],[2,[7,"/"],[2,[3,"file_id"],[2,[7,"/"],[2,[6,"share"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /drive/files/:file_id(.:format)
 * @param {any} file_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const drive_delete_file_path = /*#__PURE__*/ __jsr.r({"file_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"drive"],[2,[7,"/"],[2,[6,"files"],[2,[7,"/"],[2,[3,"file_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /drive/shares/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const drive_delete_share_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"drive"],[2,[7,"/"],[2,[6,"shares"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /drive/files/:file_id/download(.:format)
 * @param {any} file_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const drive_download_file_path = /*#__PURE__*/ __jsr.r({"file_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"drive"],[2,[7,"/"],[2,[6,"files"],[2,[7,"/"],[2,[3,"file_id"],[2,[7,"/"],[2,[6,"download"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /drive/folders/:folder_id/download_zip(.:format)
 * @param {any} folder_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const drive_download_folder_path = /*#__PURE__*/ __jsr.r({"folder_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"drive"],[2,[7,"/"],[2,[6,"folders"],[2,[7,"/"],[2,[3,"folder_id"],[2,[7,"/"],[2,[6,"download_zip"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /drive/editor/callback(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const drive_editor_callback_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"drive"],[2,[7,"/"],[2,[6,"editor"],[2,[7,"/"],[2,[6,"callback"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /drive/editor/config/:blob_id(.:format)
 * @param {any} blob_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const drive_editor_config_path = /*#__PURE__*/ __jsr.r({"blob_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"drive"],[2,[7,"/"],[2,[6,"editor"],[2,[7,"/"],[2,[6,"config"],[2,[7,"/"],[2,[3,"blob_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /drive/editor/create(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const drive_editor_create_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"drive"],[2,[7,"/"],[2,[6,"editor"],[2,[7,"/"],[2,[6,"create"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /drive/editor/files/:blob_id(.:format)
 * @param {any} blob_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const drive_editor_files_path = /*#__PURE__*/ __jsr.r({"blob_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"drive"],[2,[7,"/"],[2,[6,"editor"],[2,[7,"/"],[2,[6,"files"],[2,[7,"/"],[2,[3,"blob_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /drive/editor/picker(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const drive_editor_picker_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"drive"],[2,[7,"/"],[2,[6,"editor"],[2,[7,"/"],[2,[6,"picker"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /drive/files/:file_id/preview(.:format)
 * @param {any} file_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const drive_file_preview_path = /*#__PURE__*/ __jsr.r({"file_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"drive"],[2,[7,"/"],[2,[6,"files"],[2,[7,"/"],[2,[3,"file_id"],[2,[7,"/"],[2,[6,"preview"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /drive/files/:file_id/permissions(.:format)
 * @param {any} file_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const drive_get_file_permissions_path = /*#__PURE__*/ __jsr.r({"file_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"drive"],[2,[7,"/"],[2,[6,"files"],[2,[7,"/"],[2,[3,"file_id"],[2,[7,"/"],[2,[6,"permissions"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /drive/folders/:folder_id/permissions(.:format)
 * @param {any} folder_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const drive_get_folder_permissions_path = /*#__PURE__*/ __jsr.r({"folder_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"drive"],[2,[7,"/"],[2,[6,"folders"],[2,[7,"/"],[2,[3,"folder_id"],[2,[7,"/"],[2,[6,"permissions"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /drive(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const drive_index_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"drive"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /drive/files/:file_id/permanent(.:format)
 * @param {any} file_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const drive_permanent_delete_file_path = /*#__PURE__*/ __jsr.r({"file_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"drive"],[2,[7,"/"],[2,[6,"files"],[2,[7,"/"],[2,[3,"file_id"],[2,[7,"/"],[2,[6,"permanent"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /drive/files/:file_id(.:format)
 * @param {any} file_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const drive_rename_file_path = /*#__PURE__*/ __jsr.r({"file_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"drive"],[2,[7,"/"],[2,[6,"files"],[2,[7,"/"],[2,[3,"file_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /drive/files/:file_id/restore(.:format)
 * @param {any} file_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const drive_restore_file_path = /*#__PURE__*/ __jsr.r({"file_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"drive"],[2,[7,"/"],[2,[6,"files"],[2,[7,"/"],[2,[3,"file_id"],[2,[7,"/"],[2,[6,"restore"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /drive/files/:file_id/permissions(.:format)
 * @param {any} file_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const drive_set_file_permissions_path = /*#__PURE__*/ __jsr.r({"file_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"drive"],[2,[7,"/"],[2,[6,"files"],[2,[7,"/"],[2,[3,"file_id"],[2,[7,"/"],[2,[6,"permissions"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /drive/folders/:folder_id/permissions(.:format)
 * @param {any} folder_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const drive_set_folder_permissions_path = /*#__PURE__*/ __jsr.r({"folder_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"drive"],[2,[7,"/"],[2,[6,"folders"],[2,[7,"/"],[2,[3,"folder_id"],[2,[7,"/"],[2,[6,"permissions"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/call_center/ivr_flows/:id/duplicate(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const duplicate_admin_call_center_ivr_flow_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"call_center"],[2,[7,"/"],[2,[6,"ivr_flows"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"duplicate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /call_center/ivr_flows/:id/duplicate(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const duplicate_api_call_center_ivr_flow_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{},"subdomain":{"d":"api"}}, [2,[7,"/"],[2,[6,"call_center"],[2,[7,"/"],[2,[6,"ivr_flows"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"duplicate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /call_center/ivr_flows/:id/duplicate(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const duplicate_call_center_ivr_flow_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"call_center"],[2,[7,"/"],[2,[6,"ivr_flows"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"duplicate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/ai/system_prompts/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_admin_ai_system_prompt_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"ai"],[2,[7,"/"],[2,[6,"system_prompts"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/ai/workflows/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_admin_ai_workflow_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"ai"],[2,[7,"/"],[2,[6,"workflows"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/building_complexes/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_admin_building_complex_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"building_complexes"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/call_center/ivr_flows/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_admin_call_center_ivr_flow_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"call_center"],[2,[7,"/"],[2,[6,"ivr_flows"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/company_activities/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_admin_company_activity_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"company_activities"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/company_activity_categories/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_admin_company_activity_category_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"company_activity_categories"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/equipment_categories/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_admin_equipment_category_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"equipment_categories"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/equipment_subcategories/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_admin_equipment_subcategory_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"equipment_subcategories"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/equipment_trades/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_admin_equipment_trade_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"equipment_trades"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/guide/articles/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_admin_guide_article_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"guide"],[2,[7,"/"],[2,[6,"articles"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/invoices/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_admin_invoice_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"invoices"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/subscribers/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_admin_subscriber_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"subscribers"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/support/mailboxes/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_admin_support_mailbox_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"support"],[2,[7,"/"],[2,[6,"mailboxes"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/support/signatures/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_admin_support_signature_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"support"],[2,[7,"/"],[2,[6,"signatures"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/tenants/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_admin_tenant_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"tenants"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /ai/workflows/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_ai_workflow_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"ai"],[2,[7,"/"],[2,[6,"workflows"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /area_types/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_area_type_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"area_types"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /complexes/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_building_complex_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"complexes"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /complexes/:building_complex_id/buildings/:id/edit(.:format)
 * @param {any} building_complex_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_building_complex_building_path = /*#__PURE__*/ __jsr.r({"building_complex_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"complexes"],[2,[7,"/"],[2,[3,"building_complex_id"],[2,[7,"/"],[2,[6,"buildings"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /complexes/:building_complex_id/buildings/:building_id/areas/:id/edit(.:format)
 * @param {any} building_complex_id
 * @param {any} building_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_building_complex_building_area_path = /*#__PURE__*/ __jsr.r({"building_complex_id":{"r":true},"building_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"complexes"],[2,[7,"/"],[2,[3,"building_complex_id"],[2,[7,"/"],[2,[6,"buildings"],[2,[7,"/"],[2,[3,"building_id"],[2,[7,"/"],[2,[6,"areas"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /complexes/:building_complex_id/buildings/:building_id/areas/:area_id/children/:id/edit(.:format)
 * @param {any} building_complex_id
 * @param {any} building_id
 * @param {any} area_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_building_complex_building_area_child_path = /*#__PURE__*/ __jsr.r({"building_complex_id":{"r":true},"building_id":{"r":true},"area_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"complexes"],[2,[7,"/"],[2,[3,"building_complex_id"],[2,[7,"/"],[2,[6,"buildings"],[2,[7,"/"],[2,[3,"building_id"],[2,[7,"/"],[2,[6,"areas"],[2,[7,"/"],[2,[3,"area_id"],[2,[7,"/"],[2,[6,"children"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /complexes/:building_complex_id/buildings/:building_id/areas/:area_id/properties/:id/edit(.:format)
 * @param {any} building_complex_id
 * @param {any} building_id
 * @param {any} area_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_building_complex_building_area_property_path = /*#__PURE__*/ __jsr.r({"building_complex_id":{"r":true},"building_id":{"r":true},"area_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"complexes"],[2,[7,"/"],[2,[3,"building_complex_id"],[2,[7,"/"],[2,[6,"buildings"],[2,[7,"/"],[2,[3,"building_id"],[2,[7,"/"],[2,[6,"areas"],[2,[7,"/"],[2,[3,"area_id"],[2,[7,"/"],[2,[6,"properties"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /complexes/:building_complex_id/contracts/:id/edit(.:format)
 * @param {any} building_complex_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_building_complex_contract_path = /*#__PURE__*/ __jsr.r({"building_complex_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"complexes"],[2,[7,"/"],[2,[3,"building_complex_id"],[2,[7,"/"],[2,[6,"contracts"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /complexes/:building_complex_id/equipments/:id/edit(.:format)
 * @param {any} building_complex_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_building_complex_equipment_path = /*#__PURE__*/ __jsr.r({"building_complex_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"complexes"],[2,[7,"/"],[2,[3,"building_complex_id"],[2,[7,"/"],[2,[6,"equipments"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /complexes/:building_complex_id/insurance_events/:id/edit(.:format)
 * @param {any} building_complex_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_building_complex_insurance_event_path = /*#__PURE__*/ __jsr.r({"building_complex_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"complexes"],[2,[7,"/"],[2,[3,"building_complex_id"],[2,[7,"/"],[2,[6,"insurance_events"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /complexes/:building_complex_id/insurance_policies/:id/edit(.:format)
 * @param {any} building_complex_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_building_complex_insurance_policy_path = /*#__PURE__*/ __jsr.r({"building_complex_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"complexes"],[2,[7,"/"],[2,[3,"building_complex_id"],[2,[7,"/"],[2,[6,"insurance_policies"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /complexes/:building_complex_id/meters/:id/edit(.:format)
 * @param {any} building_complex_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_building_complex_meter_path = /*#__PURE__*/ __jsr.r({"building_complex_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"complexes"],[2,[7,"/"],[2,[3,"building_complex_id"],[2,[7,"/"],[2,[6,"meters"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /complexes/:building_complex_id/services/:id/edit(.:format)
 * @param {any} building_complex_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_building_complex_service_path = /*#__PURE__*/ __jsr.r({"building_complex_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"complexes"],[2,[7,"/"],[2,[3,"building_complex_id"],[2,[7,"/"],[2,[6,"services"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /complexes/:building_complex_id/warranties/:id/edit(.:format)
 * @param {any} building_complex_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_building_complex_warranty_path = /*#__PURE__*/ __jsr.r({"building_complex_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"complexes"],[2,[7,"/"],[2,[3,"building_complex_id"],[2,[7,"/"],[2,[6,"warranties"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /call_center/ivr_flows/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_call_center_ivr_flow_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"call_center"],[2,[7,"/"],[2,[6,"ivr_flows"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /chat/rooms/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_chat_room_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"chat"],[2,[7,"/"],[2,[6,"rooms"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /tasks/:id/edit_comment/:comment_id(.:format)
 * @param {any} id
 * @param {any} comment_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_comment_task_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"comment_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"tasks"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit_comment"],[2,[7,"/"],[2,[3,"comment_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /companies/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_company_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"companies"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /company_relationship_types/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_company_relationship_type_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"company_relationship_types"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /confirmations/:confirmation_token/edit(.:format)
 * @param {any} confirmation_token
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_confirmation_path = /*#__PURE__*/ __jsr.r({"confirmation_token":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"confirmations"],[2,[7,"/"],[2,[3,"confirmation_token"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /emails/drafts/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_emails_draft_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"emails"],[2,[7,"/"],[2,[6,"drafts"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /emails/email_rules/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_emails_email_rule_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"emails"],[2,[7,"/"],[2,[6,"email_rules"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /flowcharts/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_flowchart_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"flowcharts"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /mail_domains/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_mail_domain_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"mail_domains"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /mailboxes/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_mailbox_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"mailboxes"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /newsletters/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_newsletter_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"newsletters"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /passwords/:password_reset_token/edit(.:format)
 * @param {any} password_reset_token
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_password_path = /*#__PURE__*/ __jsr.r({"password_reset_token":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"passwords"],[2,[7,"/"],[2,[3,"password_reset_token"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /people/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_person_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"people"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /person_groups/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_person_group_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"person_groups"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /personal_mailboxes/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_personal_mailbox_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"personal_mailboxes"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /property_groups/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_property_group_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"property_groups"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /propertymanager/:property_group_id/property/:id/edit(.:format)
 * @param {any} property_group_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_property_manager_property_path = /*#__PURE__*/ __jsr.r({"property_group_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"propertymanager"],[2,[7,"/"],[2,[3,"property_group_id"],[2,[7,"/"],[2,[6,"property"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /property_relationship_types/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_property_relationship_type_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"property_relationship_types"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /property_types/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_property_type_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"property_types"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /push_subscriptions/edit(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_push_subscriptions_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"push_subscriptions"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /resident_reports/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_resident_report_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"resident_reports"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /security-services/building-complexes/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_security_services_building_complex_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"security-services"],[2,[7,"/"],[2,[6,"building-complexes"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /security-services/building-complexes/:building_complex_id/package-deliveries/:id/edit(.:format)
 * @param {any} building_complex_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_security_services_building_complex_package_delivery_path = /*#__PURE__*/ __jsr.r({"building_complex_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"security-services"],[2,[7,"/"],[2,[6,"building-complexes"],[2,[7,"/"],[2,[3,"building_complex_id"],[2,[7,"/"],[2,[6,"package-deliveries"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /security-services/building-complexes/:building_complex_id/patrols/checkpoints/:id/edit(.:format)
 * @param {any} building_complex_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_security_services_building_complex_patrols_checkpoint_path = /*#__PURE__*/ __jsr.r({"building_complex_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"security-services"],[2,[7,"/"],[2,[6,"building-complexes"],[2,[7,"/"],[2,[3,"building_complex_id"],[2,[7,"/"],[2,[6,"patrols"],[2,[7,"/"],[2,[6,"checkpoints"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /security-services/building-complexes/:building_complex_id/patrols/roads/:id/edit(.:format)
 * @param {any} building_complex_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_security_services_building_complex_patrols_road_path = /*#__PURE__*/ __jsr.r({"building_complex_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"security-services"],[2,[7,"/"],[2,[6,"building-complexes"],[2,[7,"/"],[2,[3,"building_complex_id"],[2,[7,"/"],[2,[6,"patrols"],[2,[7,"/"],[2,[6,"roads"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /security-services/building-complexes/:building_complex_id/patrols/roads/:road_id/patrols/:id/edit(.:format)
 * @param {any} building_complex_id
 * @param {any} road_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_security_services_building_complex_patrols_road_patrol_path = /*#__PURE__*/ __jsr.r({"building_complex_id":{"r":true},"road_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"security-services"],[2,[7,"/"],[2,[6,"building-complexes"],[2,[7,"/"],[2,[3,"building_complex_id"],[2,[7,"/"],[2,[6,"patrols"],[2,[7,"/"],[2,[6,"roads"],[2,[7,"/"],[2,[3,"road_id"],[2,[7,"/"],[2,[6,"patrols"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /security-services/building-complexes/:building_complex_id/recipients/:id/edit(.:format)
 * @param {any} building_complex_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_security_services_building_complex_recipient_path = /*#__PURE__*/ __jsr.r({"building_complex_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"security-services"],[2,[7,"/"],[2,[6,"building-complexes"],[2,[7,"/"],[2,[3,"building_complex_id"],[2,[7,"/"],[2,[6,"recipients"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /tasks/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_task_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"tasks"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /task_types/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_task_type_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"task_types"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /users/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_user_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /webpush_subscriptions/edit(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_webpush_subscriptions_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"webpush_subscriptions"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /ehaz/connect(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const ehaz_connect_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"ehaz"],[2,[7,"/"],[2,[6,"connect"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /ehaz/consume_token(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const ehaz_consume_token_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"ehaz"],[2,[7,"/"],[2,[6,"consume_token"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /ehaz/links/upsert(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const ehaz_links_upsert_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"ehaz"],[2,[7,"/"],[2,[6,"links"],[2,[7,"/"],[2,[6,"upsert"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /ehaz/modify(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const ehaz_modify_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"ehaz"],[2,[7,"/"],[2,[6,"modify"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /ehaz/sync(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const ehaz_sync_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"ehaz"],[2,[7,"/"],[2,[6,"sync"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /ehaz/sync/finalize(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const ehaz_sync_finalize_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"ehaz"],[2,[7,"/"],[2,[6,"sync"],[2,[7,"/"],[2,[6,"finalize"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /ehaz/sync/status(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const ehaz_sync_status_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"ehaz"],[2,[7,"/"],[2,[6,"sync"],[2,[7,"/"],[2,[6,"status"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /ehaz/tasks(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const ehaz_tasks_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"ehaz"],[2,[7,"/"],[2,[6,"tasks"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /ehaz/token_info(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const ehaz_token_info_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"ehaz"],[2,[7,"/"],[2,[6,"token_info"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /ehaz/unlink(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const ehaz_unlink_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"ehaz"],[2,[7,"/"],[2,[6,"unlink"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /ehaz/webhooks/ping(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const ehaz_webhooks_ping_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"ehaz"],[2,[7,"/"],[2,[6,"webhooks"],[2,[7,"/"],[2,[6,"ping"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /emails/addresses(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const emails_addresses_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"emails"],[2,[7,"/"],[2,[6,"addresses"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /emails/bulk(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const emails_bulk_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"emails"],[2,[7,"/"],[2,[6,"bulk"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /emails/comments/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const emails_comment_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"emails"],[2,[7,"/"],[2,[6,"comments"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /emails/comments(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const emails_comments_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"emails"],[2,[7,"/"],[2,[6,"comments"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /emails/compose(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const emails_compose_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"emails"],[2,[7,"/"],[2,[6,"compose"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /emails/drafts/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const emails_draft_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"emails"],[2,[7,"/"],[2,[6,"drafts"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /emails/drafts(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const emails_drafts_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"emails"],[2,[7,"/"],[2,[6,"drafts"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /emails/email_rules/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const emails_email_rule_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"emails"],[2,[7,"/"],[2,[6,"email_rules"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /emails/email_rules(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const emails_email_rules_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"emails"],[2,[7,"/"],[2,[6,"email_rules"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /emails/folders/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const emails_folder_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"emails"],[2,[7,"/"],[2,[6,"folders"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /emails/folders(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const emails_folders_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"emails"],[2,[7,"/"],[2,[6,"folders"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /emails/image_upload(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const emails_image_upload_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"emails"],[2,[7,"/"],[2,[6,"image_upload"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /emails/inbox(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const emails_inbox_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"emails"],[2,[7,"/"],[2,[6,"inbox"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /emails/message_trace/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const emails_message_trace_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"emails"],[2,[7,"/"],[2,[6,"message_trace"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /emails/message_trace(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const emails_message_trace_index_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"emails"],[2,[7,"/"],[2,[6,"message_trace"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /emails/sidebar_counts(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const emails_sidebar_counts_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"emails"],[2,[7,"/"],[2,[6,"sidebar_counts"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /emails/statistics(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const emails_statistics_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"emails"],[2,[7,"/"],[2,[6,"statistics"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /emails/tags(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const emails_tags_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"emails"],[2,[7,"/"],[2,[6,"tags"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /emails/task_links/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const emails_task_link_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"emails"],[2,[7,"/"],[2,[6,"task_links"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /emails/task_links(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const emails_task_links_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"emails"],[2,[7,"/"],[2,[6,"task_links"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /emails/threads/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const emails_thread_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"emails"],[2,[7,"/"],[2,[6,"threads"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /drive/empty_trash(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const empty_trash_drive_index_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"drive"],[2,[7,"/"],[2,[6,"empty_trash"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /drive/equipments/:building_complex_id/:equipment_id/:task_id(.:format)
 * @param {any} building_complex_id
 * @param {any} equipment_id
 * @param {any} task_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const equipment_task_drive_index_path = /*#__PURE__*/ __jsr.r({"building_complex_id":{"r":true},"equipment_id":{"r":true},"task_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"drive"],[2,[7,"/"],[2,[6,"equipments"],[2,[7,"/"],[2,[3,"building_complex_id"],[2,[7,"/"],[2,[3,"equipment_id"],[2,[7,"/"],[2,[3,"task_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /drive/equipments/:building_complex_id/:equipment_id(.:format)
 * @param {any} building_complex_id
 * @param {any} equipment_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const equipment_tasks_drive_index_path = /*#__PURE__*/ __jsr.r({"building_complex_id":{"r":true},"equipment_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"drive"],[2,[7,"/"],[2,[6,"equipments"],[2,[7,"/"],[2,[3,"building_complex_id"],[2,[7,"/"],[2,[3,"equipment_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /drive/equipments/:building_complex_id(.:format)
 * @param {any} building_complex_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const equipments_building_complex_drive_index_path = /*#__PURE__*/ __jsr.r({"building_complex_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"drive"],[2,[7,"/"],[2,[6,"equipments"],[2,[7,"/"],[2,[3,"building_complex_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /drive/equipments(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const equipments_drive_index_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"drive"],[2,[7,"/"],[2,[6,"equipments"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /subscription/expected_invoice(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const expected_invoice_subscription_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"subscription"],[2,[7,"/"],[2,[6,"expected_invoice"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /files/:file_id/delete(.:format)
 * @param {any} file_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const file_delete_path = /*#__PURE__*/ __jsr.r({"file_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"files"],[2,[7,"/"],[2,[3,"file_id"],[2,[7,"/"],[2,[6,"delete"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /files/:file_id/download(.:format)
 * @param {any} file_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const file_download_path = /*#__PURE__*/ __jsr.r({"file_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"files"],[2,[7,"/"],[2,[3,"file_id"],[2,[7,"/"],[2,[6,"download"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /file_groups/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const file_group_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"file_groups"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /file_groups(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const file_groups_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"file_groups"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /files/:file_id/move(.:format)
 * @param {any} file_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const file_move_path = /*#__PURE__*/ __jsr.r({"file_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"files"],[2,[7,"/"],[2,[3,"file_id"],[2,[7,"/"],[2,[6,"move"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /files/:file_id/pdf_viewer(.:format)
 * @param {any} file_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const file_pdf_viewer_path = /*#__PURE__*/ __jsr.r({"file_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"files"],[2,[7,"/"],[2,[3,"file_id"],[2,[7,"/"],[2,[6,"pdf_viewer"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /files/:file_id/preview(.:format)
 * @param {any} file_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const file_preview_path = /*#__PURE__*/ __jsr.r({"file_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"files"],[2,[7,"/"],[2,[3,"file_id"],[2,[7,"/"],[2,[6,"preview"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /files/:file_id/preview_status(.:format)
 * @param {any} file_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const file_preview_status_path = /*#__PURE__*/ __jsr.r({"file_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"files"],[2,[7,"/"],[2,[3,"file_id"],[2,[7,"/"],[2,[6,"preview_status"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /files/:file_id/title(.:format)
 * @param {any} file_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const file_title_path = /*#__PURE__*/ __jsr.r({"file_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"files"],[2,[7,"/"],[2,[3,"file_id"],[2,[7,"/"],[2,[6,"title"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /resident_reports/v1/reports/:id/files(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const files_api_resident_reports_v1_report_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"},"subdomain":{"d":"api"}}, [2,[7,"/"],[2,[6,"resident_reports"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"files"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /drive/files/delete_multiple(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const files_delete_multiple_drive_index_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"drive"],[2,[7,"/"],[2,[6,"files"],[2,[7,"/"],[2,[6,"delete_multiple"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /file_groups/:id/files/:record_type/:record_id(.:format)
 * @param {any} id
 * @param {any} record_type
 * @param {any} record_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const files_file_group_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"record_type":{"r":true},"record_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"file_groups"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"files"],[2,[7,"/"],[2,[3,"record_type"],[2,[7,"/"],[2,[3,"record_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /drive/files/move(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const files_move_drive_index_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"drive"],[2,[7,"/"],[2,[6,"files"],[2,[7,"/"],[2,[6,"move"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /files/presign(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const files_presign_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"files"],[2,[7,"/"],[2,[6,"presign"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /chat/v1/rooms/:room_id/messages/:message_id/attachments/finalize(.:format)
 * @param {any} room_id
 * @param {any} message_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const finalize_api_chat_v1_room_message_attachments_path = /*#__PURE__*/ __jsr.r({"room_id":{"r":true},"message_id":{"r":true},"format":{},"subdomain":{"d":"api"}}, [2,[7,"/"],[2,[6,"chat"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"rooms"],[2,[7,"/"],[2,[3,"room_id"],[2,[7,"/"],[2,[6,"messages"],[2,[7,"/"],[2,[3,"message_id"],[2,[7,"/"],[2,[6,"attachments"],[2,[7,"/"],[2,[6,"finalize"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /ai/voice_conversations/:id/finish(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const finish_api_ai_voice_conversation_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{},"subdomain":{"d":"api"}}, [2,[7,"/"],[2,[6,"ai"],[2,[7,"/"],[2,[6,"voice_conversations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"finish"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /call_center/call_sessions/:id/finish(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const finish_api_call_center_call_session_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{},"subdomain":{"d":"api"}}, [2,[7,"/"],[2,[6,"call_center"],[2,[7,"/"],[2,[6,"call_sessions"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"finish"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /flowcharts/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const flowchart_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"flowcharts"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /flowcharts(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const flowcharts_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"flowcharts"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /drive/folders(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const folders_drive_index_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"drive"],[2,[7,"/"],[2,[6,"folders"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /emails/compose/forward/:email_id(.:format)
 * @param {any} email_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const forward_emails_compose_path = /*#__PURE__*/ __jsr.r({"email_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"emails"],[2,[7,"/"],[2,[6,"compose"],[2,[7,"/"],[2,[6,"forward"],[2,[7,"/"],[2,[3,"email_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /globalsearch(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const globalsearch_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"globalsearch"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /globalsearch_highlight(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const globalsearch_highlight_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"globalsearch_highlight"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /globalsearch_section(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const globalsearch_section_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"globalsearch_section"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /go/area/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const go_area_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"go"],[2,[7,"/"],[2,[6,"area"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /go/building/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const go_building_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"go"],[2,[7,"/"],[2,[6,"building"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /go/building_complex/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const go_building_complex_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"go"],[2,[7,"/"],[2,[6,"building_complex"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /go/company/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const go_company_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"go"],[2,[7,"/"],[2,[6,"company"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /go/contract/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const go_contract_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"go"],[2,[7,"/"],[2,[6,"contract"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /go/email/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const go_email_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"go"],[2,[7,"/"],[2,[6,"email"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /go/insurance_event/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const go_insurance_event_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"go"],[2,[7,"/"],[2,[6,"insurance_event"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /go/insurance_policy/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const go_insurance_policy_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"go"],[2,[7,"/"],[2,[6,"insurance_policy"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /go/meter/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const go_meter_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"go"],[2,[7,"/"],[2,[6,"meter"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /go/person/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const go_person_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"go"],[2,[7,"/"],[2,[6,"person"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /go/person_group/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const go_person_group_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"go"],[2,[7,"/"],[2,[6,"person_group"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /go/property/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const go_property_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"go"],[2,[7,"/"],[2,[6,"property"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /go/resident_report/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const go_resident_report_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"go"],[2,[7,"/"],[2,[6,"resident_report"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /go/service/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const go_service_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"go"],[2,[7,"/"],[2,[6,"service"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /go/task/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const go_task_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"go"],[2,[7,"/"],[2,[6,"task"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /go/task_comment/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const go_task_comment_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"go"],[2,[7,"/"],[2,[6,"task_comment"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /go/warranty/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const go_warranty_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"go"],[2,[7,"/"],[2,[6,"warranty"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /guard(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const guard_root_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"guard"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /call_center/call_sessions/:id/hangup(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const hangup_api_call_center_call_session_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{},"subdomain":{"d":"api"}}, [2,[7,"/"],[2,[6,"call_center"],[2,[7,"/"],[2,[6,"call_sessions"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"hangup"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /helpscout/oauth/callback(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const helpscout_oauth_callback_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"helpscout"],[2,[7,"/"],[2,[6,"oauth"],[2,[7,"/"],[2,[6,"callback"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/guide/articles/:id/images(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const images_admin_guide_article_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"guide"],[2,[7,"/"],[2,[6,"articles"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"images"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /call_center/call_sessions/inbound(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const inbound_api_call_center_call_sessions_path = /*#__PURE__*/ __jsr.r({"format":{},"subdomain":{"d":"api"}}, [2,[7,"/"],[2,[6,"call_center"],[2,[7,"/"],[2,[6,"call_sessions"],[2,[7,"/"],[2,[6,"inbound"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/support/conversations/:id/internal_note(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internal_note_admin_support_conversation_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"support"],[2,[7,"/"],[2,[6,"conversations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"internal_note"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /invoices/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const invoice_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"invoices"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /szamla/:period(.:format)
 * @param {any} period
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const invoice_statement_path = /*#__PURE__*/ __jsr.r({"period":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"szamla"],[2,[7,"/"],[2,[3,"period"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /invoices(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const invoices_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"invoices"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /tasklist/involved/:building_complex_id(.:format)
 * @param {any} building_complex_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const involved_tasks_path = /*#__PURE__*/ __jsr.r({"building_complex_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"tasklist"],[2,[7,"/"],[2,[6,"involved"],[2,[7,"/"],[2,[3,"building_complex_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /tasks/kanban_column_page(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const kanban_column_page_tasks_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"tasks"],[2,[7,"/"],[2,[6,"kanban_column_page"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /load_more_timeline(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const load_more_timeline_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"load_more_timeline"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /login(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const login_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"login"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /logout(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const logout_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"logout"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /mail_domains/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const mail_domain_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"mail_domains"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /mail_domains(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const mail_domains_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"mail_domains"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /mailboxes/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const mailbox_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"mailboxes"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /mailbox_aliases/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const mailbox_alias_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"mailbox_aliases"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /mailboxes/:mailbox_id/mailbox_aliases(.:format)
 * @param {any} mailbox_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const mailbox_mailbox_aliases_path = /*#__PURE__*/ __jsr.r({"mailbox_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"mailboxes"],[2,[7,"/"],[2,[3,"mailbox_id"],[2,[7,"/"],[2,[6,"mailbox_aliases"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /email/v1/push_tokens/mailbox_preferences(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const mailbox_preferences_api_email_v1_push_tokens_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"},"subdomain":{"d":"api"}}, [2,[7,"/"],[2,[6,"email"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"push_tokens"],[2,[7,"/"],[2,[6,"mailbox_preferences"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /mailboxes(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const mailboxes_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"mailboxes"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /notifications/mark_all_as_read(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const mark_all_as_read_notifications_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"notifications"],[2,[7,"/"],[2,[6,"mark_all_as_read"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /chat/rooms/:room_id/messages/mark_as_read(.:format)
 * @param {any} room_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const mark_as_read_chat_room_messages_path = /*#__PURE__*/ __jsr.r({"room_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"chat"],[2,[7,"/"],[2,[6,"rooms"],[2,[7,"/"],[2,[3,"room_id"],[2,[7,"/"],[2,[6,"messages"],[2,[7,"/"],[2,[6,"mark_as_read"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /notifications/:id/mark_as_read(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const mark_as_read_notification_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"notifications"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"mark_as_read"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /notifications/:id/mark_as_seen(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const mark_as_seen_notification_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"notifications"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"mark_as_seen"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /notifications/mark_multiple_as_read(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const mark_multiple_as_read_notifications_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"notifications"],[2,[7,"/"],[2,[6,"mark_multiple_as_read"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /notifications/mark_multiple_as_seen(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const mark_multiple_as_seen_notifications_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"notifications"],[2,[7,"/"],[2,[6,"mark_multiple_as_seen"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /emails/threads/:id/mark_opened(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const mark_opened_emails_thread_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"emails"],[2,[7,"/"],[2,[6,"threads"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"mark_opened"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /mentions(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const mentions_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"mentions"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /emails/threads/:id/message(/:collapsetype)(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const message_emails_thread_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"collapsetype":{},"format":{}}, [2,[7,"/"],[2,[6,"emails"],[2,[7,"/"],[2,[6,"threads"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"message"],[2,[1,[2,[7,"/"],[3,"collapsetype"]]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /email/v1/threads/:id/move_to_folder(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const move_to_folder_api_email_v1_thread_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"},"subdomain":{"d":"api"}}, [2,[7,"/"],[2,[6,"email"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"threads"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"move_to_folder"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /emails/threads/:id/move_to_folder(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const move_to_folder_emails_thread_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"emails"],[2,[7,"/"],[2,[6,"threads"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"move_to_folder"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /tasklist/my/:building_complex_id(.:format)
 * @param {any} building_complex_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const my_tasks_path = /*#__PURE__*/ __jsr.r({"building_complex_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"tasklist"],[2,[7,"/"],[2,[6,"my"],[2,[7,"/"],[2,[3,"building_complex_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/ai/system_prompts/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_admin_ai_system_prompt_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"ai"],[2,[7,"/"],[2,[6,"system_prompts"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/ai/workflows/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_admin_ai_workflow_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"ai"],[2,[7,"/"],[2,[6,"workflows"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/building_complexes/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_admin_building_complex_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"building_complexes"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/call_center/ivr_flows/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_admin_call_center_ivr_flow_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"call_center"],[2,[7,"/"],[2,[6,"ivr_flows"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/client-creation/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_admin_client_creation_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"client-creation"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/company_activities/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_admin_company_activity_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"company_activities"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/company_activity_categories/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_admin_company_activity_category_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"company_activity_categories"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/equipment_categories/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_admin_equipment_category_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"equipment_categories"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/equipment_subcategories/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_admin_equipment_subcategory_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"equipment_subcategories"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/equipment_trades/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_admin_equipment_trade_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"equipment_trades"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/guide/articles/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_admin_guide_article_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"guide"],[2,[7,"/"],[2,[6,"articles"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/invoices/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_admin_invoice_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"invoices"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/subscribers/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_admin_subscriber_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"subscribers"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/support/mailboxes/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_admin_support_mailbox_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"support"],[2,[7,"/"],[2,[6,"mailboxes"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/tenants/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_admin_tenant_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"tenants"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /ai/workflows/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_ai_workflow_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"ai"],[2,[7,"/"],[2,[6,"workflows"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /area_types/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_area_type_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"area_types"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /complexes/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_building_complex_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"complexes"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /complexes/:building_complex_id/buildings/new(.:format)
 * @param {any} building_complex_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_building_complex_building_path = /*#__PURE__*/ __jsr.r({"building_complex_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"complexes"],[2,[7,"/"],[2,[3,"building_complex_id"],[2,[7,"/"],[2,[6,"buildings"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /complexes/:building_complex_id/buildings/:building_id/areas/new(.:format)
 * @param {any} building_complex_id
 * @param {any} building_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_building_complex_building_area_path = /*#__PURE__*/ __jsr.r({"building_complex_id":{"r":true},"building_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"complexes"],[2,[7,"/"],[2,[3,"building_complex_id"],[2,[7,"/"],[2,[6,"buildings"],[2,[7,"/"],[2,[3,"building_id"],[2,[7,"/"],[2,[6,"areas"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /complexes/:building_complex_id/buildings/:building_id/areas/:area_id/children/new(.:format)
 * @param {any} building_complex_id
 * @param {any} building_id
 * @param {any} area_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_building_complex_building_area_child_path = /*#__PURE__*/ __jsr.r({"building_complex_id":{"r":true},"building_id":{"r":true},"area_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"complexes"],[2,[7,"/"],[2,[3,"building_complex_id"],[2,[7,"/"],[2,[6,"buildings"],[2,[7,"/"],[2,[3,"building_id"],[2,[7,"/"],[2,[6,"areas"],[2,[7,"/"],[2,[3,"area_id"],[2,[7,"/"],[2,[6,"children"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /complexes/:building_complex_id/buildings/:building_id/areas/:area_id/properties/new(.:format)
 * @param {any} building_complex_id
 * @param {any} building_id
 * @param {any} area_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_building_complex_building_area_property_path = /*#__PURE__*/ __jsr.r({"building_complex_id":{"r":true},"building_id":{"r":true},"area_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"complexes"],[2,[7,"/"],[2,[3,"building_complex_id"],[2,[7,"/"],[2,[6,"buildings"],[2,[7,"/"],[2,[3,"building_id"],[2,[7,"/"],[2,[6,"areas"],[2,[7,"/"],[2,[3,"area_id"],[2,[7,"/"],[2,[6,"properties"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /complexes/:building_complex_id/contracts/new(.:format)
 * @param {any} building_complex_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_building_complex_contract_path = /*#__PURE__*/ __jsr.r({"building_complex_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"complexes"],[2,[7,"/"],[2,[3,"building_complex_id"],[2,[7,"/"],[2,[6,"contracts"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /complexes/:building_complex_id/equipments/new(.:format)
 * @param {any} building_complex_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_building_complex_equipment_path = /*#__PURE__*/ __jsr.r({"building_complex_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"complexes"],[2,[7,"/"],[2,[3,"building_complex_id"],[2,[7,"/"],[2,[6,"equipments"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /complexes/:building_complex_id/import/new(.:format)
 * @param {any} building_complex_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_building_complex_import_path = /*#__PURE__*/ __jsr.r({"building_complex_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"complexes"],[2,[7,"/"],[2,[3,"building_complex_id"],[2,[7,"/"],[2,[6,"import"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /complexes/:building_complex_id/insurance_events/new(.:format)
 * @param {any} building_complex_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_building_complex_insurance_event_path = /*#__PURE__*/ __jsr.r({"building_complex_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"complexes"],[2,[7,"/"],[2,[3,"building_complex_id"],[2,[7,"/"],[2,[6,"insurance_events"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /complexes/:building_complex_id/insurance_policies/new(.:format)
 * @param {any} building_complex_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_building_complex_insurance_policy_path = /*#__PURE__*/ __jsr.r({"building_complex_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"complexes"],[2,[7,"/"],[2,[3,"building_complex_id"],[2,[7,"/"],[2,[6,"insurance_policies"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /complexes/:building_complex_id/meters/new(.:format)
 * @param {any} building_complex_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_building_complex_meter_path = /*#__PURE__*/ __jsr.r({"building_complex_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"complexes"],[2,[7,"/"],[2,[3,"building_complex_id"],[2,[7,"/"],[2,[6,"meters"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /complexes/:building_complex_id/services/new(.:format)
 * @param {any} building_complex_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_building_complex_service_path = /*#__PURE__*/ __jsr.r({"building_complex_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"complexes"],[2,[7,"/"],[2,[3,"building_complex_id"],[2,[7,"/"],[2,[6,"services"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /complexes/:building_complex_id/warranties/new(.:format)
 * @param {any} building_complex_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_building_complex_warranty_path = /*#__PURE__*/ __jsr.r({"building_complex_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"complexes"],[2,[7,"/"],[2,[3,"building_complex_id"],[2,[7,"/"],[2,[6,"warranties"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /call_center/ivr_flows/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_call_center_ivr_flow_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"call_center"],[2,[7,"/"],[2,[6,"ivr_flows"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /chat/rooms/directs/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_chat_direct_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"chat"],[2,[7,"/"],[2,[6,"rooms"],[2,[7,"/"],[2,[6,"directs"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /chat/rooms/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_chat_room_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"chat"],[2,[7,"/"],[2,[6,"rooms"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /tasks/:id/child(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_child_task_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"tasks"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"child"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /companies/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_company_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"companies"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /company_relationship_types/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_company_relationship_type_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"company_relationship_types"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /confirmations/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_confirmation_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"confirmations"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /emails/compose/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_emails_compose_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"emails"],[2,[7,"/"],[2,[6,"compose"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /emails/email_rules/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_emails_email_rule_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"emails"],[2,[7,"/"],[2,[6,"email_rules"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /flowcharts/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_flowchart_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"flowcharts"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /drive/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_folder_drive_index_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"drive"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /tasks/fromemail/:emailid(.:format)
 * @param {any} emailid
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_fromemail_tasks_path = /*#__PURE__*/ __jsr.r({"emailid":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"tasks"],[2,[7,"/"],[2,[6,"fromemail"],[2,[7,"/"],[2,[3,"emailid"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /mail_domains/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_mail_domain_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"mail_domains"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /mailboxes/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_mailbox_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"mailboxes"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /newsletters/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_newsletter_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"newsletters"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /passwords/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_password_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"passwords"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /people/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_person_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"people"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /person_groups/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_person_group_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"person_groups"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /personal_mailboxes/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_personal_mailbox_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"personal_mailboxes"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /property_groups/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_property_group_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"property_groups"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /property_relationship_types/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_property_relationship_type_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"property_relationship_types"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /property_types/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_property_type_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"property_types"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /push_subscriptions/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_push_subscriptions_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"push_subscriptions"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /rails/conductor/action_mailbox/inbound_emails/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_rails_conductor_inbound_email_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"conductor"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"inbound_emails"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/conductor/action_mailbox/inbound_emails/sources/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_rails_conductor_inbound_email_source_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"conductor"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"inbound_emails"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /resident_reports/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_resident_report_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"resident_reports"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /security-services/building-complexes/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_security_services_building_complex_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"security-services"],[2,[7,"/"],[2,[6,"building-complexes"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /security-services/building-complexes/:building_complex_id/incidents/new(.:format)
 * @param {any} building_complex_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_security_services_building_complex_incident_path = /*#__PURE__*/ __jsr.r({"building_complex_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"security-services"],[2,[7,"/"],[2,[6,"building-complexes"],[2,[7,"/"],[2,[3,"building_complex_id"],[2,[7,"/"],[2,[6,"incidents"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /security-services/building-complexes/:building_complex_id/package-deliveries/new(.:format)
 * @param {any} building_complex_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_security_services_building_complex_package_delivery_path = /*#__PURE__*/ __jsr.r({"building_complex_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"security-services"],[2,[7,"/"],[2,[6,"building-complexes"],[2,[7,"/"],[2,[3,"building_complex_id"],[2,[7,"/"],[2,[6,"package-deliveries"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /security-services/building-complexes/:building_complex_id/patrols/checkpoints/new(.:format)
 * @param {any} building_complex_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_security_services_building_complex_patrols_checkpoint_path = /*#__PURE__*/ __jsr.r({"building_complex_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"security-services"],[2,[7,"/"],[2,[6,"building-complexes"],[2,[7,"/"],[2,[3,"building_complex_id"],[2,[7,"/"],[2,[6,"patrols"],[2,[7,"/"],[2,[6,"checkpoints"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /security-services/building-complexes/:building_complex_id/patrols/roads/new(.:format)
 * @param {any} building_complex_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_security_services_building_complex_patrols_road_path = /*#__PURE__*/ __jsr.r({"building_complex_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"security-services"],[2,[7,"/"],[2,[6,"building-complexes"],[2,[7,"/"],[2,[3,"building_complex_id"],[2,[7,"/"],[2,[6,"patrols"],[2,[7,"/"],[2,[6,"roads"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /security-services/building-complexes/:building_complex_id/patrols/roads/:road_id/patrols/new(.:format)
 * @param {any} building_complex_id
 * @param {any} road_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_security_services_building_complex_patrols_road_patrol_path = /*#__PURE__*/ __jsr.r({"building_complex_id":{"r":true},"road_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"security-services"],[2,[7,"/"],[2,[6,"building-complexes"],[2,[7,"/"],[2,[3,"building_complex_id"],[2,[7,"/"],[2,[6,"patrols"],[2,[7,"/"],[2,[6,"roads"],[2,[7,"/"],[2,[3,"road_id"],[2,[7,"/"],[2,[6,"patrols"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /security-services/building-complexes/:building_complex_id/recipients/new(.:format)
 * @param {any} building_complex_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_security_services_building_complex_recipient_path = /*#__PURE__*/ __jsr.r({"building_complex_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"security-services"],[2,[7,"/"],[2,[6,"building-complexes"],[2,[7,"/"],[2,[3,"building_complex_id"],[2,[7,"/"],[2,[6,"recipients"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /tasks/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_task_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"tasks"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /task_types/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_task_type_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"task_types"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /users/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_user_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /webpush_subscriptions/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_webpush_subscriptions_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"webpush_subscriptions"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /newsletters/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newsletter_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"newsletters"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /newsletters(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newsletters_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"newsletters"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /call_center/call_sessions/:id/node_completed(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const node_completed_api_call_center_call_session_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{},"subdomain":{"d":"api"}}, [2,[7,"/"],[2,[6,"call_center"],[2,[7,"/"],[2,[6,"call_sessions"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"node_completed"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /notifications(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const notifications_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"notifications"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /passwords/:password_reset_token(.:format)
 * @param {any} password_reset_token
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const password_path = /*#__PURE__*/ __jsr.r({"password_reset_token":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"passwords"],[2,[7,"/"],[2,[3,"password_reset_token"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /password_migration(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const password_migration_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"password_migration"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /passwords(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const passwords_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"passwords"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /people(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const people_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"people"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /people/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const person_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"people"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /person_groups/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const person_group_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"person_groups"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /person_groups(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const person_groups_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"person_groups"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /personal_mailboxes/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const personal_mailbox_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"personal_mailboxes"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /personal_mailboxes(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const personal_mailboxes_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"personal_mailboxes"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /admin/audit_events/persons(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const persons_admin_audit_events_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"audit_events"],[2,[7,"/"],[2,[6,"persons"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /security-services/building-complexes/:building_complex_id/package-deliveries/:id/pickup(.:format)
 * @param {any} building_complex_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const pickup_security_services_building_complex_package_delivery_path = /*#__PURE__*/ __jsr.r({"building_complex_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"security-services"],[2,[7,"/"],[2,[6,"building-complexes"],[2,[7,"/"],[2,[3,"building_complex_id"],[2,[7,"/"],[2,[6,"package-deliveries"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"pickup"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /postcode/hu(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const postcode_hu_code_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"postcode"],[2,[7,"/"],[2,[6,"hu"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /postcode/hu(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const postcode_hu_codes_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"postcode"],[2,[7,"/"],[2,[6,"hu"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /security-services/building-complexes/:building_complex_id/patrols/roads/:road_id/patrols/:id/postmortem(.:format)
 * @param {any} building_complex_id
 * @param {any} road_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const postmortem_security_services_building_complex_patrols_road_patrol_path = /*#__PURE__*/ __jsr.r({"building_complex_id":{"r":true},"road_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"security-services"],[2,[7,"/"],[2,[6,"building-complexes"],[2,[7,"/"],[2,[3,"building_complex_id"],[2,[7,"/"],[2,[6,"patrols"],[2,[7,"/"],[2,[6,"roads"],[2,[7,"/"],[2,[3,"road_id"],[2,[7,"/"],[2,[6,"patrols"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"postmortem"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /chat/v1/rooms/:room_id/attachments/presign(.:format)
 * @param {any} room_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const presign_api_chat_v1_room_attachments_path = /*#__PURE__*/ __jsr.r({"room_id":{"r":true},"format":{},"subdomain":{"d":"api"}}, [2,[7,"/"],[2,[6,"chat"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"rooms"],[2,[7,"/"],[2,[3,"room_id"],[2,[7,"/"],[2,[6,"attachments"],[2,[7,"/"],[2,[6,"presign"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /email/v1/attachments/presign(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const presign_api_email_v1_attachments_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"},"subdomain":{"d":"api"}}, [2,[7,"/"],[2,[6,"email"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"attachments"],[2,[7,"/"],[2,[6,"presign"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /drive/preview_statuses(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const preview_statuses_drive_index_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"drive"],[2,[7,"/"],[2,[6,"preview_statuses"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /privacy_policy(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const privacy_policy_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"privacy_policy"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /property_groups/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const property_group_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"property_groups"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /property_groups(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const property_groups_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"property_groups"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /propertymanager/:property_group_id(.:format)
 * @param {any} property_group_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const property_manager_path = /*#__PURE__*/ __jsr.r({"property_group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"propertymanager"],[2,[7,"/"],[2,[3,"property_group_id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /propertymanager/:property_group_id/property/:id(.:format)
 * @param {any} property_group_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const property_manager_property_path = /*#__PURE__*/ __jsr.r({"property_group_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"propertymanager"],[2,[7,"/"],[2,[3,"property_group_id"],[2,[7,"/"],[2,[6,"property"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /property_relationship_types/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const property_relationship_type_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"property_relationship_types"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /property_relationship_types(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const property_relationship_types_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"property_relationship_types"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /property_types/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const property_type_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"property_types"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /property_types(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const property_types_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"property_types"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /public/document_acceptance/:token(.:format)
 * @param {any} token
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const public_path = /*#__PURE__*/ __jsr.r({"token":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"public"],[2,[7,"/"],[2,[6,"document_acceptance"],[2,[7,"/"],[2,[3,"token"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /public/document_acceptance/:token(.:format)
 * @param {any} token
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const public_document_acceptance_path = /*#__PURE__*/ __jsr.r({"token":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"public"],[2,[7,"/"],[2,[6,"document_acceptance"],[2,[7,"/"],[2,[3,"token"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /public/quote_submission/:token(.:format)
 * @param {any} token
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const public_quote_submission_path = /*#__PURE__*/ __jsr.r({"token":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"public"],[2,[7,"/"],[2,[6,"quote_submission"],[2,[7,"/"],[2,[3,"token"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /s/:token(.:format)
 * @param {any} token
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const public_share_path = /*#__PURE__*/ __jsr.r({"token":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"s"],[2,[7,"/"],[2,[3,"token"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /s/:token/download(.:format)
 * @param {any} token
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const public_share_download_path = /*#__PURE__*/ __jsr.r({"token":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"s"],[2,[7,"/"],[2,[3,"token"],[2,[7,"/"],[2,[6,"download"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /s/:token/file/:file_id(.:format)
 * @param {any} token
 * @param {any} file_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const public_share_file_path = /*#__PURE__*/ __jsr.r({"token":{"r":true},"file_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"s"],[2,[7,"/"],[2,[3,"token"],[2,[7,"/"],[2,[6,"file"],[2,[7,"/"],[2,[3,"file_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /s/:token/preview(.:format)
 * @param {any} token
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const public_share_preview_path = /*#__PURE__*/ __jsr.r({"token":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"s"],[2,[7,"/"],[2,[3,"token"],[2,[7,"/"],[2,[6,"preview"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /s/:token/folder/:folder_id(.:format)
 * @param {any} token
 * @param {any} folder_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const public_share_subfolder_path = /*#__PURE__*/ __jsr.r({"token":{"r":true},"folder_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"s"],[2,[7,"/"],[2,[3,"token"],[2,[7,"/"],[2,[6,"folder"],[2,[7,"/"],[2,[3,"folder_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/guide/articles/:id/publish(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const publish_admin_guide_article_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"guide"],[2,[7,"/"],[2,[6,"articles"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"publish"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /chat/v1/rooms/:id/purge(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const purge_api_chat_v1_room_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{},"subdomain":{"d":"api"}}, [2,[7,"/"],[2,[6,"chat"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"rooms"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"purge"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /chat/rooms/:id/purge(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const purge_chat_room_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"chat"],[2,[7,"/"],[2,[6,"rooms"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"purge"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /push_subscriptions(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const push_subscriptions_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"push_subscriptions"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /manifest(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const pwa_manifest_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"manifest"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /service-worker(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const pwa_service_worker_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"service-worker"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /tasks/:id/quote_request_file_groups(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const quote_request_file_groups_task_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"tasks"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"quote_request_file_groups"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /tasks/:id/quote_request_recipients(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const quote_request_recipients_task_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"tasks"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"quote_request_recipients"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /tasks/:id/quote_request_search_companies(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const quote_request_search_companies_task_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"tasks"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"quote_request_search_companies"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /tasks/:id/quote_request_warning_modal(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const quote_request_warning_modal_task_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"tasks"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"quote_request_warning_modal"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /storage/representations/redirect/:signed_blob_id/:variation_key/*filename(.:format)
 * @param {any} signed_blob_id
 * @param {any} variation_key
 * @param {any} filename
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_blob_representation_path = /*#__PURE__*/ __jsr.r({"signed_blob_id":{"r":true},"variation_key":{"r":true},"filename":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"storage"],[2,[7,"/"],[2,[6,"representations"],[2,[7,"/"],[2,[6,"redirect"],[2,[7,"/"],[2,[3,"signed_blob_id"],[2,[7,"/"],[2,[3,"variation_key"],[2,[7,"/"],[2,[5,[3,"filename"]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /storage/representations/proxy/:signed_blob_id/:variation_key/*filename(.:format)
 * @param {any} signed_blob_id
 * @param {any} variation_key
 * @param {any} filename
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_blob_representation_proxy_path = /*#__PURE__*/ __jsr.r({"signed_blob_id":{"r":true},"variation_key":{"r":true},"filename":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"storage"],[2,[7,"/"],[2,[6,"representations"],[2,[7,"/"],[2,[6,"proxy"],[2,[7,"/"],[2,[3,"signed_blob_id"],[2,[7,"/"],[2,[3,"variation_key"],[2,[7,"/"],[2,[5,[3,"filename"]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/conductor/action_mailbox/inbound_emails/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_conductor_inbound_email_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"conductor"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"inbound_emails"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/conductor/action_mailbox/:inbound_email_id/incinerate(.:format)
 * @param {any} inbound_email_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_conductor_inbound_email_incinerate_path = /*#__PURE__*/ __jsr.r({"inbound_email_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"conductor"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[3,"inbound_email_id"],[2,[7,"/"],[2,[6,"incinerate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/conductor/action_mailbox/:inbound_email_id/reroute(.:format)
 * @param {any} inbound_email_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_conductor_inbound_email_reroute_path = /*#__PURE__*/ __jsr.r({"inbound_email_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"conductor"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[3,"inbound_email_id"],[2,[7,"/"],[2,[6,"reroute"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/conductor/action_mailbox/inbound_emails/sources(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_conductor_inbound_email_sources_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"conductor"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"inbound_emails"],[2,[7,"/"],[2,[6,"sources"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/conductor/action_mailbox/inbound_emails(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_conductor_inbound_emails_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"conductor"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"inbound_emails"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /storage/direct_uploads(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_direct_uploads_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"storage"],[2,[7,"/"],[2,[6,"direct_uploads"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /storage/disk/:encoded_key/*filename(.:format)
 * @param {any} encoded_key
 * @param {any} filename
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_disk_service_path = /*#__PURE__*/ __jsr.r({"encoded_key":{"r":true},"filename":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"storage"],[2,[7,"/"],[2,[6,"disk"],[2,[7,"/"],[2,[3,"encoded_key"],[2,[7,"/"],[2,[5,[3,"filename"]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /up(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_health_check_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"up"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /rails/action_mailbox/mailgun/inbound_emails/mime(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_mailgun_inbound_emails_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"mailgun"],[2,[7,"/"],[2,[6,"inbound_emails"],[2,[7,"/"],[2,[6,"mime"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/action_mailbox/mandrill/inbound_emails(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_mandrill_inbound_emails_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"mandrill"],[2,[7,"/"],[2,[6,"inbound_emails"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/action_mailbox/mandrill/inbound_emails(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_mandrill_inbound_health_check_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"mandrill"],[2,[7,"/"],[2,[6,"inbound_emails"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/action_mailbox/postmark/inbound_emails(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_postmark_inbound_emails_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"postmark"],[2,[7,"/"],[2,[6,"inbound_emails"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/action_mailbox/relay/inbound_emails(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_relay_inbound_emails_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"relay"],[2,[7,"/"],[2,[6,"inbound_emails"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/action_mailbox/sendgrid/inbound_emails(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_sendgrid_inbound_emails_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"sendgrid"],[2,[7,"/"],[2,[6,"inbound_emails"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /storage/blobs/redirect/:signed_id/*filename(.:format)
 * @param {any} signed_id
 * @param {any} filename
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_service_blob_path = /*#__PURE__*/ __jsr.r({"signed_id":{"r":true},"filename":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"storage"],[2,[7,"/"],[2,[6,"blobs"],[2,[7,"/"],[2,[6,"redirect"],[2,[7,"/"],[2,[3,"signed_id"],[2,[7,"/"],[2,[5,[3,"filename"]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /storage/blobs/proxy/:signed_id/*filename(.:format)
 * @param {any} signed_id
 * @param {any} filename
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_service_blob_proxy_path = /*#__PURE__*/ __jsr.r({"signed_id":{"r":true},"filename":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"storage"],[2,[7,"/"],[2,[6,"blobs"],[2,[7,"/"],[2,[6,"proxy"],[2,[7,"/"],[2,[3,"signed_id"],[2,[7,"/"],[2,[5,[3,"filename"]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/action_mailbox/ses/inbound_emails(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_ses_inbound_emails_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"ses"],[2,[7,"/"],[2,[6,"inbound_emails"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /chat/v1/rooms/:room_id/messages/:id/reactions(.:format)
 * @param {any} room_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reactions_api_chat_v1_room_message_path = /*#__PURE__*/ __jsr.r({"room_id":{"r":true},"id":{"r":true},"format":{},"subdomain":{"d":"api"}}, [2,[7,"/"],[2,[6,"chat"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"rooms"],[2,[7,"/"],[2,[3,"room_id"],[2,[7,"/"],[2,[6,"messages"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"reactions"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /chat/v1/rooms/:room_id/messages/read(.:format)
 * @param {any} room_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const read_api_chat_v1_room_messages_path = /*#__PURE__*/ __jsr.r({"room_id":{"r":true},"format":{},"subdomain":{"d":"api"}}, [2,[7,"/"],[2,[6,"chat"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"rooms"],[2,[7,"/"],[2,[3,"room_id"],[2,[7,"/"],[2,[6,"messages"],[2,[7,"/"],[2,[6,"read"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /chat/v1/rooms/:room_id/messages/:id/receipts(.:format)
 * @param {any} room_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const receipts_api_chat_v1_room_message_path = /*#__PURE__*/ __jsr.r({"room_id":{"r":true},"id":{"r":true},"format":{},"subdomain":{"d":"api"}}, [2,[7,"/"],[2,[6,"chat"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"rooms"],[2,[7,"/"],[2,[3,"room_id"],[2,[7,"/"],[2,[6,"messages"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"receipts"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /notifications/recent(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const recent_notifications_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"notifications"],[2,[7,"/"],[2,[6,"recent"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /security-services/building-complexes/:building_complex_id/patrols/roads/:id/record(.:format)
 * @param {any} building_complex_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const record_security_services_building_complex_patrols_road_path = /*#__PURE__*/ __jsr.r({"building_complex_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"security-services"],[2,[7,"/"],[2,[6,"building-complexes"],[2,[7,"/"],[2,[3,"building_complex_id"],[2,[7,"/"],[2,[6,"patrols"],[2,[7,"/"],[2,[6,"roads"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"record"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/ai/workflows/:workflow_id/runs/:id/refresh(.:format)
 * @param {any} workflow_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const refresh_admin_ai_workflow_run_path = /*#__PURE__*/ __jsr.r({"workflow_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"ai"],[2,[7,"/"],[2,[6,"workflows"],[2,[7,"/"],[2,[3,"workflow_id"],[2,[7,"/"],[2,[6,"runs"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"refresh"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /ai/workflows/:workflow_id/runs/:id/refresh(.:format)
 * @param {any} workflow_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const refresh_ai_workflow_run_path = /*#__PURE__*/ __jsr.r({"workflow_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"ai"],[2,[7,"/"],[2,[6,"workflows"],[2,[7,"/"],[2,[3,"workflow_id"],[2,[7,"/"],[2,[6,"runs"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"refresh"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/guide/articles/:id/refresh_build(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const refresh_build_admin_guide_article_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"guide"],[2,[7,"/"],[2,[6,"articles"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"refresh_build"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/invoices/:id/regenerate(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const regenerate_admin_invoice_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"invoices"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"regenerate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /emails/email_rules/reorder(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reorder_emails_email_rules_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"emails"],[2,[7,"/"],[2,[6,"email_rules"],[2,[7,"/"],[2,[6,"reorder"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /tasks/reorder_kanban_column(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reorder_kanban_column_tasks_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"tasks"],[2,[7,"/"],[2,[6,"reorder_kanban_column"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/support/conversations/:id/reply(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reply_admin_support_conversation_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"support"],[2,[7,"/"],[2,[6,"conversations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"reply"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /emails/compose/reply_all/:email_id(.:format)
 * @param {any} email_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reply_all_emails_compose_path = /*#__PURE__*/ __jsr.r({"email_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"emails"],[2,[7,"/"],[2,[6,"compose"],[2,[7,"/"],[2,[6,"reply_all"],[2,[7,"/"],[2,[3,"email_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /emails/compose/reply/:email_id(.:format)
 * @param {any} email_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reply_emails_compose_path = /*#__PURE__*/ __jsr.r({"email_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"emails"],[2,[7,"/"],[2,[6,"compose"],[2,[7,"/"],[2,[6,"reply"],[2,[7,"/"],[2,[3,"email_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /mail_domains/:id/reprovision(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reprovision_mail_domain_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"mail_domains"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"reprovision"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /mailboxes/:id/reprovision(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reprovision_mailbox_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"mailboxes"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"reprovision"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /call_center/call_sessions/:id/request_agent(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const request_agent_api_call_center_call_session_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{},"subdomain":{"d":"api"}}, [2,[7,"/"],[2,[6,"call_center"],[2,[7,"/"],[2,[6,"call_sessions"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"request_agent"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /tasks/reset_kanban_column(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reset_kanban_column_tasks_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"tasks"],[2,[7,"/"],[2,[6,"reset_kanban_column"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /resident_reports/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const resident_report_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"resident_reports"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /resident_reports(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const resident_reports_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"resident_reports"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /resident_reports/:building_complex_id(.:format)
 * @param {any} building_complex_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const resident_reports_index_path = /*#__PURE__*/ __jsr.r({"building_complex_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"resident_reports"],[2,[7,"/"],[2,[3,"building_complex_id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/guide/articles/:id/restore(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const restore_admin_guide_article_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"guide"],[2,[7,"/"],[2,[6,"articles"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"restore"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /drive/:id/restore(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const restore_drive_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"drive"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"restore"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /people/:id/restore(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const restore_person_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"people"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"restore"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/support/mailboxes/:id/reverify(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reverify_admin_support_mailbox_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"support"],[2,[7,"/"],[2,[6,"mailboxes"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"reverify"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /mail_domains/:id/reverify(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reverify_mail_domain_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"mail_domains"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"reverify"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /mailboxes/:id/reverify(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reverify_mailbox_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"mailboxes"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"reverify"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/tenants/:tenant_id/webdav_credentials/:id/revoke(.:format)
 * @param {any} tenant_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const revoke_admin_tenant_webdav_credential_path = /*#__PURE__*/ __jsr.r({"tenant_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"tenants"],[2,[7,"/"],[2,[3,"tenant_id"],[2,[7,"/"],[2,[6,"webdav_credentials"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"revoke"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /drive/webdav/credentials/:id/revoke(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const revoke_webdav_credential_drive_index_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"drive"],[2,[7,"/"],[2,[6,"webdav"],[2,[7,"/"],[2,[6,"credentials"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"revoke"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const root_path = /*#__PURE__*/ __jsr.r({}, [7,"/"]);

/**
 * Generates rails route to
 * /admin/ai/workflows/:id/run(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const run_admin_ai_workflow_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"ai"],[2,[7,"/"],[2,[6,"workflows"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"run"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /ai/workflows/:id/run(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const run_ai_workflow_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"ai"],[2,[7,"/"],[2,[6,"workflows"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"run"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/invoices/run_monthly_billing(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const run_monthly_billing_admin_invoices_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"invoices"],[2,[7,"/"],[2,[6,"run_monthly_billing"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /ai/conversations/messages/save_assistant(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const save_assistant_api_ai_conversations_messages_path = /*#__PURE__*/ __jsr.r({"format":{},"subdomain":{"d":"api"}}, [2,[7,"/"],[2,[6,"ai"],[2,[7,"/"],[2,[6,"conversations"],[2,[7,"/"],[2,[6,"messages"],[2,[7,"/"],[2,[6,"save_assistant"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /ai/conversations/messages/save_user(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const save_user_api_ai_conversations_messages_path = /*#__PURE__*/ __jsr.r({"format":{},"subdomain":{"d":"api"}}, [2,[7,"/"],[2,[6,"ai"],[2,[7,"/"],[2,[6,"conversations"],[2,[7,"/"],[2,[6,"messages"],[2,[7,"/"],[2,[6,"save_user"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /companies/search_activities(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const search_activities_companies_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"companies"],[2,[7,"/"],[2,[6,"search_activities"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /resident_reports/v1/reports/search(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const search_api_resident_reports_v1_reports_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"},"subdomain":{"d":"api"}}, [2,[7,"/"],[2,[6,"resident_reports"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"search"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /area_types/search(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const search_area_types_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"area_types"],[2,[7,"/"],[2,[6,"search"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /complexes/:building_complex_id/buildings/:building_id/areas/:area_id/properties/search(.:format)
 * @param {any} building_complex_id
 * @param {any} building_id
 * @param {any} area_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const search_building_complex_building_area_properties_path = /*#__PURE__*/ __jsr.r({"building_complex_id":{"r":true},"building_id":{"r":true},"area_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"complexes"],[2,[7,"/"],[2,[3,"building_complex_id"],[2,[7,"/"],[2,[6,"buildings"],[2,[7,"/"],[2,[3,"building_id"],[2,[7,"/"],[2,[6,"areas"],[2,[7,"/"],[2,[3,"area_id"],[2,[7,"/"],[2,[6,"properties"],[2,[7,"/"],[2,[6,"search"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /complexes/:building_complex_id/buildings/:building_id/areas/search(.:format)
 * @param {any} building_complex_id
 * @param {any} building_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const search_building_complex_building_areas_path = /*#__PURE__*/ __jsr.r({"building_complex_id":{"r":true},"building_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"complexes"],[2,[7,"/"],[2,[3,"building_complex_id"],[2,[7,"/"],[2,[6,"buildings"],[2,[7,"/"],[2,[3,"building_id"],[2,[7,"/"],[2,[6,"areas"],[2,[7,"/"],[2,[6,"search"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /complexes/:building_complex_id/buildings/search(.:format)
 * @param {any} building_complex_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const search_building_complex_buildings_path = /*#__PURE__*/ __jsr.r({"building_complex_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"complexes"],[2,[7,"/"],[2,[3,"building_complex_id"],[2,[7,"/"],[2,[6,"buildings"],[2,[7,"/"],[2,[6,"search"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /complexes/:building_complex_id/contracts/search(.:format)
 * @param {any} building_complex_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const search_building_complex_contracts_path = /*#__PURE__*/ __jsr.r({"building_complex_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"complexes"],[2,[7,"/"],[2,[3,"building_complex_id"],[2,[7,"/"],[2,[6,"contracts"],[2,[7,"/"],[2,[6,"search"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /complexes/:building_complex_id/equipments/search(.:format)
 * @param {any} building_complex_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const search_building_complex_equipments_path = /*#__PURE__*/ __jsr.r({"building_complex_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"complexes"],[2,[7,"/"],[2,[3,"building_complex_id"],[2,[7,"/"],[2,[6,"equipments"],[2,[7,"/"],[2,[6,"search"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /complexes/:building_complex_id/insurance_events/search(.:format)
 * @param {any} building_complex_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const search_building_complex_insurance_events_path = /*#__PURE__*/ __jsr.r({"building_complex_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"complexes"],[2,[7,"/"],[2,[3,"building_complex_id"],[2,[7,"/"],[2,[6,"insurance_events"],[2,[7,"/"],[2,[6,"search"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /complexes/:building_complex_id/insurance_policies/search(.:format)
 * @param {any} building_complex_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const search_building_complex_insurance_policies_path = /*#__PURE__*/ __jsr.r({"building_complex_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"complexes"],[2,[7,"/"],[2,[3,"building_complex_id"],[2,[7,"/"],[2,[6,"insurance_policies"],[2,[7,"/"],[2,[6,"search"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /complexes/:building_complex_id/meters/search(.:format)
 * @param {any} building_complex_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const search_building_complex_meters_path = /*#__PURE__*/ __jsr.r({"building_complex_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"complexes"],[2,[7,"/"],[2,[3,"building_complex_id"],[2,[7,"/"],[2,[6,"meters"],[2,[7,"/"],[2,[6,"search"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /complexes/:building_complex_id/services/search(.:format)
 * @param {any} building_complex_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const search_building_complex_services_path = /*#__PURE__*/ __jsr.r({"building_complex_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"complexes"],[2,[7,"/"],[2,[3,"building_complex_id"],[2,[7,"/"],[2,[6,"services"],[2,[7,"/"],[2,[6,"search"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /complexes/:building_complex_id/warranties/search(.:format)
 * @param {any} building_complex_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const search_building_complex_warranties_path = /*#__PURE__*/ __jsr.r({"building_complex_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"complexes"],[2,[7,"/"],[2,[3,"building_complex_id"],[2,[7,"/"],[2,[6,"warranties"],[2,[7,"/"],[2,[6,"search"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /complexes/search(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const search_building_complexes_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"complexes"],[2,[7,"/"],[2,[6,"search"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /companies/search(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const search_companies_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"companies"],[2,[7,"/"],[2,[6,"search"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /company_relationship_types/search(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const search_company_relationship_types_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"company_relationship_types"],[2,[7,"/"],[2,[6,"search"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /drive/search(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const search_drive_index_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"drive"],[2,[7,"/"],[2,[6,"search"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /emails/task_links/search(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const search_emails_task_links_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"emails"],[2,[7,"/"],[2,[6,"task_links"],[2,[7,"/"],[2,[6,"search"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /flowcharts/search(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const search_flowcharts_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"flowcharts"],[2,[7,"/"],[2,[6,"search"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /mailboxes/search(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const search_mailboxes_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"mailboxes"],[2,[7,"/"],[2,[6,"search"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /newsletters/search(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const search_newsletters_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"newsletters"],[2,[7,"/"],[2,[6,"search"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /people/search(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const search_people_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"people"],[2,[7,"/"],[2,[6,"search"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /person_groups/search(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const search_person_groups_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"person_groups"],[2,[7,"/"],[2,[6,"search"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /property_groups/search(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const search_property_groups_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"property_groups"],[2,[7,"/"],[2,[6,"search"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /propertymanager/:property_group_id/search(.:format)
 * @param {any} property_group_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const search_property_manager_path = /*#__PURE__*/ __jsr.r({"property_group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"propertymanager"],[2,[7,"/"],[2,[3,"property_group_id"],[2,[7,"/"],[2,[6,"search"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /property_relationship_types/search(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const search_property_relationship_types_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"property_relationship_types"],[2,[7,"/"],[2,[6,"search"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /property_types/search(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const search_property_types_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"property_types"],[2,[7,"/"],[2,[6,"search"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /resident_reports/search(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const search_resident_reports_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"resident_reports"],[2,[7,"/"],[2,[6,"search"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /security-services/building-complexes/:building_complex_id/patrols/checkpoints/search(.:format)
 * @param {any} building_complex_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const search_security_services_building_complex_patrols_checkpoints_path = /*#__PURE__*/ __jsr.r({"building_complex_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"security-services"],[2,[7,"/"],[2,[6,"building-complexes"],[2,[7,"/"],[2,[3,"building_complex_id"],[2,[7,"/"],[2,[6,"patrols"],[2,[7,"/"],[2,[6,"checkpoints"],[2,[7,"/"],[2,[6,"search"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /security-services/building-complexes/:building_complex_id/patrols/roads/:road_id/patrols/search(.:format)
 * @param {any} building_complex_id
 * @param {any} road_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const search_security_services_building_complex_patrols_road_patrols_path = /*#__PURE__*/ __jsr.r({"building_complex_id":{"r":true},"road_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"security-services"],[2,[7,"/"],[2,[6,"building-complexes"],[2,[7,"/"],[2,[3,"building_complex_id"],[2,[7,"/"],[2,[6,"patrols"],[2,[7,"/"],[2,[6,"roads"],[2,[7,"/"],[2,[3,"road_id"],[2,[7,"/"],[2,[6,"patrols"],[2,[7,"/"],[2,[6,"search"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /security-services/building-complexes/:building_complex_id/patrols/roads/search(.:format)
 * @param {any} building_complex_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const search_security_services_building_complex_patrols_roads_path = /*#__PURE__*/ __jsr.r({"building_complex_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"security-services"],[2,[7,"/"],[2,[6,"building-complexes"],[2,[7,"/"],[2,[3,"building_complex_id"],[2,[7,"/"],[2,[6,"patrols"],[2,[7,"/"],[2,[6,"roads"],[2,[7,"/"],[2,[6,"search"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /security-services/building-complexes/search(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const search_security_services_building_complexes_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"security-services"],[2,[7,"/"],[2,[6,"building-complexes"],[2,[7,"/"],[2,[6,"search"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /task_types/search(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const search_task_types_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"task_types"],[2,[7,"/"],[2,[6,"search"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /tasks/search(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const search_tasks_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"tasks"],[2,[7,"/"],[2,[6,"search"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /users/search(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const search_users_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"search"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /security-services/building-complexes/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const security_services_building_complex_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"security-services"],[2,[7,"/"],[2,[6,"building-complexes"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /security-services/building-complexes/:building_complex_id/incidents/:id(.:format)
 * @param {any} building_complex_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const security_services_building_complex_incident_path = /*#__PURE__*/ __jsr.r({"building_complex_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"security-services"],[2,[7,"/"],[2,[6,"building-complexes"],[2,[7,"/"],[2,[3,"building_complex_id"],[2,[7,"/"],[2,[6,"incidents"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /security-services/building-complexes/:building_complex_id/incidents(.:format)
 * @param {any} building_complex_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const security_services_building_complex_incidents_path = /*#__PURE__*/ __jsr.r({"building_complex_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"security-services"],[2,[7,"/"],[2,[6,"building-complexes"],[2,[7,"/"],[2,[3,"building_complex_id"],[2,[7,"/"],[2,[6,"incidents"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /security-services/building-complexes/:building_complex_id/package-deliveries(.:format)
 * @param {any} building_complex_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const security_services_building_complex_package_deliveries_path = /*#__PURE__*/ __jsr.r({"building_complex_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"security-services"],[2,[7,"/"],[2,[6,"building-complexes"],[2,[7,"/"],[2,[3,"building_complex_id"],[2,[7,"/"],[2,[6,"package-deliveries"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /security-services/building-complexes/:building_complex_id/package-deliveries/:id(.:format)
 * @param {any} building_complex_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const security_services_building_complex_package_delivery_path = /*#__PURE__*/ __jsr.r({"building_complex_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"security-services"],[2,[7,"/"],[2,[6,"building-complexes"],[2,[7,"/"],[2,[3,"building_complex_id"],[2,[7,"/"],[2,[6,"package-deliveries"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /security-services/building-complexes/:building_complex_id/patrols/checkpoints/:id(.:format)
 * @param {any} building_complex_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const security_services_building_complex_patrols_checkpoint_path = /*#__PURE__*/ __jsr.r({"building_complex_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"security-services"],[2,[7,"/"],[2,[6,"building-complexes"],[2,[7,"/"],[2,[3,"building_complex_id"],[2,[7,"/"],[2,[6,"patrols"],[2,[7,"/"],[2,[6,"checkpoints"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /security-services/building-complexes/:building_complex_id/patrols/checkpoints(.:format)
 * @param {any} building_complex_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const security_services_building_complex_patrols_checkpoints_path = /*#__PURE__*/ __jsr.r({"building_complex_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"security-services"],[2,[7,"/"],[2,[6,"building-complexes"],[2,[7,"/"],[2,[3,"building_complex_id"],[2,[7,"/"],[2,[6,"patrols"],[2,[7,"/"],[2,[6,"checkpoints"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /security-services/building-complexes/:building_complex_id/patrols/roads/:id(.:format)
 * @param {any} building_complex_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const security_services_building_complex_patrols_road_path = /*#__PURE__*/ __jsr.r({"building_complex_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"security-services"],[2,[7,"/"],[2,[6,"building-complexes"],[2,[7,"/"],[2,[3,"building_complex_id"],[2,[7,"/"],[2,[6,"patrols"],[2,[7,"/"],[2,[6,"roads"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /security-services/building-complexes/:building_complex_id/patrols/roads/:road_id/patrols/:id(.:format)
 * @param {any} building_complex_id
 * @param {any} road_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const security_services_building_complex_patrols_road_patrol_path = /*#__PURE__*/ __jsr.r({"building_complex_id":{"r":true},"road_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"security-services"],[2,[7,"/"],[2,[6,"building-complexes"],[2,[7,"/"],[2,[3,"building_complex_id"],[2,[7,"/"],[2,[6,"patrols"],[2,[7,"/"],[2,[6,"roads"],[2,[7,"/"],[2,[3,"road_id"],[2,[7,"/"],[2,[6,"patrols"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /security-services/building-complexes/:building_complex_id/patrols/roads/:road_id/patrols(.:format)
 * @param {any} building_complex_id
 * @param {any} road_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const security_services_building_complex_patrols_road_patrols_path = /*#__PURE__*/ __jsr.r({"building_complex_id":{"r":true},"road_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"security-services"],[2,[7,"/"],[2,[6,"building-complexes"],[2,[7,"/"],[2,[3,"building_complex_id"],[2,[7,"/"],[2,[6,"patrols"],[2,[7,"/"],[2,[6,"roads"],[2,[7,"/"],[2,[3,"road_id"],[2,[7,"/"],[2,[6,"patrols"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /security-services/building-complexes/:building_complex_id/patrols/roads(.:format)
 * @param {any} building_complex_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const security_services_building_complex_patrols_roads_path = /*#__PURE__*/ __jsr.r({"building_complex_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"security-services"],[2,[7,"/"],[2,[6,"building-complexes"],[2,[7,"/"],[2,[3,"building_complex_id"],[2,[7,"/"],[2,[6,"patrols"],[2,[7,"/"],[2,[6,"roads"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /security-services/building-complexes/:building_complex_id/recipients/:id(.:format)
 * @param {any} building_complex_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const security_services_building_complex_recipient_path = /*#__PURE__*/ __jsr.r({"building_complex_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"security-services"],[2,[7,"/"],[2,[6,"building-complexes"],[2,[7,"/"],[2,[3,"building_complex_id"],[2,[7,"/"],[2,[6,"recipients"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /security-services/building-complexes/:building_complex_id/recipients(.:format)
 * @param {any} building_complex_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const security_services_building_complex_recipients_path = /*#__PURE__*/ __jsr.r({"building_complex_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"security-services"],[2,[7,"/"],[2,[6,"building-complexes"],[2,[7,"/"],[2,[3,"building_complex_id"],[2,[7,"/"],[2,[6,"recipients"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /security-services/building-complexes(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const security_services_building_complexes_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"security-services"],[2,[7,"/"],[2,[6,"building-complexes"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /security-services/dashboards(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const security_services_dashboards_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"security-services"],[2,[7,"/"],[2,[6,"dashboards"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /security-services/patrol-files/:file_id/preview(.:format)
 * @param {any} file_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const security_services_patrols_patrol_file_preview_path = /*#__PURE__*/ __jsr.r({"file_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"security-services"],[2,[7,"/"],[2,[6,"patrol-files"],[2,[7,"/"],[2,[3,"file_id"],[2,[7,"/"],[2,[6,"preview"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /security-services/patrol-files/:file_id/preview_status(.:format)
 * @param {any} file_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const security_services_patrols_patrol_file_preview_status_path = /*#__PURE__*/ __jsr.r({"file_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"security-services"],[2,[7,"/"],[2,[6,"patrol-files"],[2,[7,"/"],[2,[3,"file_id"],[2,[7,"/"],[2,[6,"preview_status"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /security-services/update_serial(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const security_services_update_serial_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"security-services"],[2,[7,"/"],[2,[6,"update_serial"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /webhooks/seeme_sms(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const seeme_sms_webhook_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"webhooks"],[2,[7,"/"],[2,[6,"seeme_sms"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/subscribers/:id/send_contract_email(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const send_contract_email_admin_subscriber_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"subscribers"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"send_contract_email"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /people/:id/send_invitation(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const send_invitation_person_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"people"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"send_invitation"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /billingo/invoices/:id/send_invoice(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const send_invoice_billingo_invoice_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"billingo"],[2,[7,"/"],[2,[6,"invoices"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"send_invoice"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /newsletters/:id/send(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const send_newsletter_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"newsletters"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"send"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /tasks/:id/send_quote_request(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const send_quote_request_task_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"tasks"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"send_quote_request"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /emails/compose/send_reply(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const send_reply_emails_compose_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"emails"],[2,[7,"/"],[2,[6,"compose"],[2,[7,"/"],[2,[6,"send_reply"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /complexes/:building_complex_id/equipments/:id/service_history(.:format)
 * @param {any} building_complex_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const service_history_building_complex_equipment_path = /*#__PURE__*/ __jsr.r({"building_complex_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"complexes"],[2,[7,"/"],[2,[3,"building_complex_id"],[2,[7,"/"],[2,[6,"equipments"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"service_history"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /service-provider-log(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const service_provider_logs_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"service-provider-log"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /admin/support/mailboxes/:id/setup_instructions(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const setup_instructions_admin_support_mailbox_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"support"],[2,[7,"/"],[2,[6,"mailboxes"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"setup_instructions"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /mail_domains/:id/setup_instructions(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const setup_instructions_mail_domain_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"mail_domains"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"setup_instructions"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /mailboxes/:id/setup_instructions(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const setup_instructions_mailbox_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"mailboxes"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"setup_instructions"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /drive/shared_with_me(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const shared_with_me_drive_index_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"drive"],[2,[7,"/"],[2,[6,"shared_with_me"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /drive/shares(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const shares_drive_index_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"drive"],[2,[7,"/"],[2,[6,"shares"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /tasklist/all/:building_complex_id/:id(.:format)
 * @param {any} building_complex_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const show_all_task_path = /*#__PURE__*/ __jsr.r({"building_complex_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"tasklist"],[2,[7,"/"],[2,[6,"all"],[2,[7,"/"],[2,[3,"building_complex_id"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /tasklist/involved/:building_complex_id/:id(.:format)
 * @param {any} building_complex_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const show_involved_task_path = /*#__PURE__*/ __jsr.r({"building_complex_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"tasklist"],[2,[7,"/"],[2,[6,"involved"],[2,[7,"/"],[2,[3,"building_complex_id"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /tasklist/my/:building_complex_id/:id(.:format)
 * @param {any} building_complex_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const show_my_task_path = /*#__PURE__*/ __jsr.r({"building_complex_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"tasklist"],[2,[7,"/"],[2,[6,"my"],[2,[7,"/"],[2,[3,"building_complex_id"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /resident_reports/:building_complex_id/:id(.:format)
 * @param {any} building_complex_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const show_resident_report_path = /*#__PURE__*/ __jsr.r({"building_complex_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"resident_reports"],[2,[7,"/"],[2,[3,"building_complex_id"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /sign_up(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const sign_up_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"sign_up"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /mailboxes/:id/signature/:type(.:format)
 * @param {any} id
 * @param {any} type
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const signature_mailbox_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"type":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"mailboxes"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"signature"],[2,[7,"/"],[2,[3,"type"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /mailboxes/signature_upload(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const signature_upload_mailboxes_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"mailboxes"],[2,[7,"/"],[2,[6,"signature_upload"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /auth/:provider(.:format)
 * @param {any} provider
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const social_login_path = /*#__PURE__*/ __jsr.r({"provider":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"auth"],[2,[7,"/"],[2,[3,"provider"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /auth/cognito/callback(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const social_login_callback_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"auth"],[2,[7,"/"],[2,[6,"cognito"],[2,[7,"/"],[2,[6,"callback"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /static_pages/home(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const static_pages_home_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"static_pages"],[2,[7,"/"],[2,[6,"home"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /complexes/:building_complex_id/package-deliveries/statistics(.:format)
 * @param {any} building_complex_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const statistics_building_complex_package_deliveries_path = /*#__PURE__*/ __jsr.r({"building_complex_id":{"r":true},"format":{"d":"html"}}, [2,[7,"/"],[2,[6,"complexes"],[2,[7,"/"],[2,[3,"building_complex_id"],[2,[7,"/"],[2,[6,"package-deliveries"],[2,[7,"/"],[2,[6,"statistics"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /complexes/:building_complex_id/package-deliveries/statistics_data(.:format)
 * @param {any} building_complex_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const statistics_data_building_complex_package_deliveries_path = /*#__PURE__*/ __jsr.r({"building_complex_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"complexes"],[2,[7,"/"],[2,[3,"building_complex_id"],[2,[7,"/"],[2,[6,"package-deliveries"],[2,[7,"/"],[2,[6,"statistics_data"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /security-services/building-complexes/:building_complex_id/package-deliveries/statistics_data(.:format)
 * @param {any} building_complex_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const statistics_data_security_services_building_complex_package_deliveries_path = /*#__PURE__*/ __jsr.r({"building_complex_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"security-services"],[2,[7,"/"],[2,[6,"building-complexes"],[2,[7,"/"],[2,[3,"building_complex_id"],[2,[7,"/"],[2,[6,"package-deliveries"],[2,[7,"/"],[2,[6,"statistics_data"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /drive/statistics(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const statistics_drive_index_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"drive"],[2,[7,"/"],[2,[6,"statistics"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /security-services/building-complexes/:building_complex_id/package-deliveries/statistics(.:format)
 * @param {any} building_complex_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const statistics_security_services_building_complex_package_deliveries_path = /*#__PURE__*/ __jsr.r({"building_complex_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"security-services"],[2,[7,"/"],[2,[6,"building-complexes"],[2,[7,"/"],[2,[3,"building_complex_id"],[2,[7,"/"],[2,[6,"package-deliveries"],[2,[7,"/"],[2,[6,"statistics"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/call_center/call_sessions/stats(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const stats_admin_call_center_call_sessions_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"call_center"],[2,[7,"/"],[2,[6,"call_sessions"],[2,[7,"/"],[2,[6,"stats"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/call_center/ivr_flows/stats(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const stats_admin_call_center_ivr_flows_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"call_center"],[2,[7,"/"],[2,[6,"ivr_flows"],[2,[7,"/"],[2,[6,"stats"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /call_center/call_sessions/stats(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const stats_api_call_center_call_sessions_path = /*#__PURE__*/ __jsr.r({"format":{},"subdomain":{"d":"api"}}, [2,[7,"/"],[2,[6,"call_center"],[2,[7,"/"],[2,[6,"call_sessions"],[2,[7,"/"],[2,[6,"stats"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /complexes/:building_complex_id/equipments/subcategories_for_category(.:format)
 * @param {any} building_complex_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const subcategories_for_category_building_complex_equipments_path = /*#__PURE__*/ __jsr.r({"building_complex_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"complexes"],[2,[7,"/"],[2,[3,"building_complex_id"],[2,[7,"/"],[2,[6,"equipments"],[2,[7,"/"],[2,[6,"subcategories_for_category"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /push_subscriptions/subscribe(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const subscribe_push_subscriptions_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"push_subscriptions"],[2,[7,"/"],[2,[6,"subscribe"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /webpush_subscriptions/subscribe(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const subscribe_webpush_subscriptions_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"webpush_subscriptions"],[2,[7,"/"],[2,[6,"subscribe"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /subscription(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const subscription_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"subscription"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /support/widget/ai_conversations/:agent_id(.:format)
 * @param {any} agent_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const support_widget_ai_conversation_messages_path = /*#__PURE__*/ __jsr.r({"agent_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"support"],[2,[7,"/"],[2,[6,"widget"],[2,[7,"/"],[2,[6,"ai_conversations"],[2,[7,"/"],[2,[3,"agent_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /support/widget/conversations/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const support_widget_conversation_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"support"],[2,[7,"/"],[2,[6,"widget"],[2,[7,"/"],[2,[6,"conversations"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /support/widget/conversations(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const support_widget_conversations_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"support"],[2,[7,"/"],[2,[6,"widget"],[2,[7,"/"],[2,[6,"conversations"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/building_complexes/:id/sync_ehaz(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const sync_ehaz_admin_building_complex_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"building_complexes"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"sync_ehaz"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /szerzodes-kotes(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const szerzodes_kotes_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"szerzodes-kotes"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /szerzodes-kotes/status(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const szerzodes_kotes_status_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"szerzodes-kotes"],[2,[7,"/"],[2,[6,"status"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /szerzodes-kotes/waiting(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const szerzodes_kotes_waiting_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"szerzodes-kotes"],[2,[7,"/"],[2,[6,"waiting"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /tasks/tags(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const tags_tasks_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"tasks"],[2,[7,"/"],[2,[6,"tags"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /tasks/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const task_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"tasks"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /t/:reference_code(.:format)
 * @param {any} reference_code
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const task_by_reference_path = /*#__PURE__*/ __jsr.r({"reference_code":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"t"],[2,[7,"/"],[2,[3,"reference_code"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /tasks/:id/task_modal(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const task_modal_task_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"tasks"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"task_modal"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /task_schedules/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const task_schedule_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"task_schedules"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /tasks/:task_id/task_schedules/:id(.:format)
 * @param {any} task_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const task_task_schedule_path = /*#__PURE__*/ __jsr.r({"task_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"tasks"],[2,[7,"/"],[2,[3,"task_id"],[2,[7,"/"],[2,[6,"task_schedules"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /task_types/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const task_type_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"task_types"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /task_types(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const task_types_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"task_types"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /resident_reports/:id/task_workflow/ai_search(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const task_workflow_ai_search_resident_report_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"resident_reports"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"task_workflow"],[2,[7,"/"],[2,[6,"ai_search"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /resident_reports/:id/task_workflow/attach(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const task_workflow_attach_resident_report_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"resident_reports"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"task_workflow"],[2,[7,"/"],[2,[6,"attach"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /resident_reports/:id/task_workflow/create(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const task_workflow_create_resident_report_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"resident_reports"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"task_workflow"],[2,[7,"/"],[2,[6,"create"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /resident_reports/:id/task_workflow(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const task_workflow_resident_report_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"resident_reports"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"task_workflow"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /resident_reports/:id/task_workflow/search(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const task_workflow_search_resident_report_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"resident_reports"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"task_workflow"],[2,[7,"/"],[2,[6,"search"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /tasks(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const tasks_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"tasks"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /drive/tasks/:building_complex_id(.:format)
 * @param {any} building_complex_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const tasks_building_complex_drive_index_path = /*#__PURE__*/ __jsr.r({"building_complex_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"drive"],[2,[7,"/"],[2,[6,"tasks"],[2,[7,"/"],[2,[3,"building_complex_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /companies/:id/tasks(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const tasks_company_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"companies"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"tasks"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /drive/tasks(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const tasks_drive_index_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"drive"],[2,[7,"/"],[2,[6,"tasks"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /drive/tasks/:building_complex_id/:task_id(.:format)
 * @param {any} building_complex_id
 * @param {any} task_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const tasks_task_drive_index_path = /*#__PURE__*/ __jsr.r({"building_complex_id":{"r":true},"task_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"drive"],[2,[7,"/"],[2,[6,"tasks"],[2,[7,"/"],[2,[3,"building_complex_id"],[2,[7,"/"],[2,[3,"task_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /complexes/:building_complex_id/import/template(.:format)
 * @param {any} building_complex_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const template_building_complex_import_path = /*#__PURE__*/ __jsr.r({"building_complex_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"complexes"],[2,[7,"/"],[2,[3,"building_complex_id"],[2,[7,"/"],[2,[6,"import"],[2,[7,"/"],[2,[6,"template"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/audit_events/tenants(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const tenants_admin_audit_events_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"audit_events"],[2,[7,"/"],[2,[6,"tenants"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/call_center/call_sessions/:id/terminate(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const terminate_admin_call_center_call_session_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"call_center"],[2,[7,"/"],[2,[6,"call_sessions"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"terminate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /email/v1/tags/toggle(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const toggle_api_email_v1_tags_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"},"subdomain":{"d":"api"}}, [2,[7,"/"],[2,[6,"email"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"tags"],[2,[7,"/"],[2,[6,"toggle"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /emails/email_rules/:id/toggle(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const toggle_emails_email_rule_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"emails"],[2,[7,"/"],[2,[6,"email_rules"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"toggle"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /emails/tags/toggle(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const toggle_emails_tags_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"emails"],[2,[7,"/"],[2,[6,"tags"],[2,[7,"/"],[2,[6,"toggle"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/guide/articles/:id/toggle_featured(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const toggle_featured_admin_guide_article_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"guide"],[2,[7,"/"],[2,[6,"articles"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"toggle_featured"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /tasks/:id/timeline_events(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const toggle_timeline_events_task_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"tasks"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"timeline_events"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /drive/trash(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const trash_drive_index_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"drive"],[2,[7,"/"],[2,[6,"trash"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /recede_historical_location(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const turbo_recede_historical_location_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"recede_historical_location"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /refresh_historical_location(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const turbo_refresh_historical_location_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"refresh_historical_location"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /resume_historical_location(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const turbo_resume_historical_location_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"resume_historical_location"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /notifications/unread_count(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const unread_count_notifications_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"notifications"],[2,[7,"/"],[2,[6,"unread_count"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /push_subscriptions/unsubscribe(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const unsubscribe_push_subscriptions_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"push_subscriptions"],[2,[7,"/"],[2,[6,"unsubscribe"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /mailboxes/:id/update_avatar(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const update_avatar_mailbox_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"mailboxes"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"update_avatar"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /tasks/update_calendar_visibility(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const update_calendar_visibility_tasks_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"tasks"],[2,[7,"/"],[2,[6,"update_calendar_visibility"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /tasks/:id/update_comment/:comment_id(.:format)
 * @param {any} id
 * @param {any} comment_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const update_comment_task_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"comment_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"tasks"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"update_comment"],[2,[7,"/"],[2,[3,"comment_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /propertymanager/:property_group_id/property/:id(.:format)
 * @param {any} property_group_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const update_property_manager_property_path = /*#__PURE__*/ __jsr.r({"property_group_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"propertymanager"],[2,[7,"/"],[2,[3,"property_group_id"],[2,[7,"/"],[2,[6,"property"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /storage/disk/:encoded_token(.:format)
 * @param {any} encoded_token
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const update_rails_disk_service_path = /*#__PURE__*/ __jsr.r({"encoded_token":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"storage"],[2,[7,"/"],[2,[6,"disk"],[2,[7,"/"],[2,[3,"encoded_token"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /email/v1/threads/:id/update_state(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const update_state_api_email_v1_thread_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"},"subdomain":{"d":"api"}}, [2,[7,"/"],[2,[6,"email"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"threads"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"update_state"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /emails/threads/:id/update_state(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const update_state_emails_thread_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"emails"],[2,[7,"/"],[2,[6,"threads"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"update_state"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/invoices/:id/update_status(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const update_status_admin_invoice_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"invoices"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"update_status"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /resident_reports/:id/update_status(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const update_status_resident_report_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"resident_reports"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"update_status"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /tasks/:id/update_status(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const update_status_task_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"tasks"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"update_status"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /file_groups/upload_files(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const upload_files_file_groups_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"file_groups"],[2,[7,"/"],[2,[6,"upload_files"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /users/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /userinfo(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const userinfo_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"userinfo"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /users(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const users_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /admin/support/mailboxes/:id/verify(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const verify_admin_support_mailbox_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"support"],[2,[7,"/"],[2,[6,"mailboxes"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"verify"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /mail_domains/:id/verify(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const verify_mail_domain_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"mail_domains"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"verify"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /mailboxes/:id/verify(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const verify_mailbox_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"mailboxes"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"verify"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /personal_mailboxes/:id/verify(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const verify_personal_mailbox_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"personal_mailboxes"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"verify"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /voice/statistics(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const voice_statistics_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"voice"],[2,[7,"/"],[2,[6,"statistics"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /webdav/*path
 * @param {any} path
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const webdav_path = /*#__PURE__*/ __jsr.r({"path":{"r":true}}, [2,[7,"/"],[2,[6,"webdav"],[2,[7,"/"],[5,[3,"path"]]]]]);

/**
 * Generates rails route to
 * /drive/webdav/credentials(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const webdav_credentials_drive_index_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"drive"],[2,[7,"/"],[2,[6,"webdav"],[2,[7,"/"],[2,[6,"credentials"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /drive/webdav(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const webdav_drive_index_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"drive"],[2,[7,"/"],[2,[6,"webdav"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /webdav(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const webdav_root_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"webdav"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /webpush_subscriptions(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const webpush_subscriptions_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"webpush_subscriptions"],[1,[2,[8,"."],[3,"format"]]]]]);

